{
  "access.denied": "Brak dostępu do tego ekranu",
  "access.deniedHint": "To konto nie ma uprawnień do tej części portalu. Jeśli powinno je mieć, poproś administratora.",
  "accounts.active": "aktywne",
  "accounts.add": "Dodaj",
  "accounts.addHint": "Konto logowania do portalu — uprawnienia nadajesz poniżej",
  "accounts.addTitle": "Nowe konto",
  "accounts.allModules": "wszystkie",
  "accounts.archive": "Archiwizuj",
  "accounts.archived": "Konto zarchiwizowane",
  "accounts.archived_": "archiwum",
  "accounts.cannotSelf": "Nie możesz tego zrobić na własnym koncie",
  "accounts.created": "Konto utworzone",
  "accounts.editTitle": "Edycja konta",
  "accounts.email": "E-mail",
  "accounts.lastLogin": "Ostatnie logowanie",
  "accounts.moduleNotForClient": "Ten moduł nie jest dostępny dla kont klienta",
  "accounts.modules": "Uprawnienia",
  "accounts.modulesAdminHint": "Administrator ma dostęp do wszystkiego",
  "accounts.modulesClientHint": "Konto klienta ma dostęp tylko do odczytu raportów — pozostałe moduły są niedostępne, także dla administratora klienta",
  "accounts.modulesHint": "Zaznacz moduły, do których konto ma dostęp",
  "accounts.name": "Nazwa",
  "accounts.newPassword": "Nowe hasło",
  "accounts.password": "Hasło",
  "accounts.passwordChanged": "Hasło zmienione",
  "accounts.passwordHint": "Minimum 8 znaków. Puste = konto bez hasła lokalnego.",
  "accounts.passwordTitle": "Zmiana hasła",
  "accounts.passwordTooShort": "Hasło musi mieć co najmniej 8 znaków",
  "accounts.restore": "Przywróć",
  "accounts.restored": "Konto przywrócone",
  "accounts.role": "Rola",
  "accounts.saved": "Zapisano",
  "accounts.scope": "Zakres",
  "accounts.scopeHint": "Do jakiego klienta konto jest zawężone. Wyboru nie da się później zmienić edycją — przeniesienie konta między klientami to zmiana uprawnień, nie zmiana pola.",
  "accounts.scopePick": "— wybierz zakres —",
  "accounts.scopeSdi": "SDI — wszyscy klienci",
  "accounts.scopeSdiShort": "SDI",
  "accounts.scopeSdiWarn": "Konto bez zawężenia widzi WSZYSTKICH klientów i wszystkie ich wyspy. Zakładaj takie tylko dla naszych ludzi.",
  "accounts.showArchived": "Pokaż zarchiwizowane",
  "accounts.status": "Status",
  "agents.aktualnaWersja": "agent: {wersja}",
  "agents.accept": "Potwierdź",
  "agents.accepted": "Węzeł potwierdzony — portal przyjmuje od niego dane.",
  "agents.aktualizujTeraz": "aktualizuj teraz",
  "agents.aktualizujTerazOpis": "Poproś tego agenta o sprawdzenie wersji przy najbliższym sygnale życia, zamiast czekać na jego własny odstęp (raz na 30 cykli). Portal nie puka do maszyny — prośba jedzie w odpowiedzi na sygnał, więc skutek widać w ciągu jednego cyklu. Aktualizacja i tak wykona się dopiero po udanym cyklu.",
  "agents.aktualizujTerazStary": "Ten agent jest starszy niż {wersja} i nie zna tej prośby — podniesie się sam przy swoim najbliższym sprawdzeniu wersji. Przycisk zadziała po tej aktualizacji.",
  "agents.aktualizujZlecone": "Poproszono {wezel} o sprawdzenie wersji — agent usłyszy to przy najbliższym sygnale życia.",
  "agents.alreadyAccepted": "Ten węzeł był już potwierdzony; nic nie zmieniono.",
  "agents.alreadyRejected": "Ten węzeł był już odrzucony; nic nie zmieniono.",
  "agents.bezAutomatu": "baza bez automatu",
  "agents.clockFixOff": "korekta wyłączona (Ustawienia instancji)",
  "agents.clockFixOn": "korekta włączona",
  "agents.clockShort": "zegar:",
  "agents.code.alreadyRevoked": "Ten kod był już odwołany.",
  "agents.code.colDenied": "Odmowy",
  "agents.code.colExpires": "Ważny do",
  "agents.code.colKind": "Rodzaj",
  "agents.code.colLabel": "Opis",
  "agents.code.colModel": "Wdrożenie",
  "agents.code.colUses": "Użycia",
  "agents.code.copied": "Kod skopiowany.",
  "agents.code.copy": "Kopiuj",
  "agents.code.copyFailed": "Nie udało się skopiować — przepisz kod z ekranu.",
  "agents.code.forIsland": "Wyspa",
  "agents.code.hide": "Ukryj",
  "agents.code.hours": "Ważny (godzin)",
  "agents.code.hoursWhat": "Kod ma żyć tyle, ile trwa wdrożenie. Po terminie nie zarejestruje już nic, nawet jeśli wyciekł.",
  "agents.code.islandCode": "Krótki identyfikator wyspy",
  "agents.code.islandCodeWhat": "Techniczna nazwa bez spacji i polskich znaków — widać ją w adresach portalu i w eksportach. Składamy ją z nazwy obiektu; zmieniaj tylko wtedy, gdy klient ma własne nazewnictwo.",
  "agents.code.islandName": "Nazwa obiektu (wyspy)",
  "agents.code.islandNamePlaceholder": "np. nazwa firmy albo zakładu",
  "agents.code.islandNameWhat": "Jak ten zakład ma się nazywać w portalu i w raportach — zwykle nazwa firmy albo zakładu (np. „Zakład Wschód\", „Magazyn główny\"). Wyspa to jedna baza SPS: wszystkie automaty obsługiwane z tej bazy trafią pod tę nazwę.",
  "agents.code.issue": "Wydaj kod",
  "agents.code.kindFounding": "założycielski",
  "agents.code.kindJoin": "do wyspy",
  "agents.code.kodZNazwy": "Składane z nazwy obiektu. Jeśli taki identyfikator jest zajęty, instancja doda numer.",
  "agents.code.label": "Opis kodu (nieobowiązkowy)",
  "agents.code.labelWhat": "Notatka wyłącznie dla nas: widać ją na liście wydanych kodów niżej i przy agencie, który tym kodem się zarejestrował. Pomaga po miesiącach odpowiedzieć „co to był za kod\". Puste = wpiszemy nazwę obiektu.",
  "agents.code.listTitle": "Wydane kody",
  "agents.code.manyClients": "Ta instancja ma więcej niż jednego klienta — kod powstanie dla pierwszego z listy. Sprawdź, czy to właściwy.",
  "agents.code.maxUses": "Ile maszyn wolno zarejestrować",
  "agents.code.maxUsesWhat": "Jednym kodem obchodzi się cały obiekt. Limit jest twardy — po jego wyczerpaniu kod przestaje wpuszczać.",
  "agents.code.mode.WYSPA": "Dołączam maszynę do istniejącej wyspy",
  "agents.code.mode.ZALOZYCIELSKI": "Zakładam nową wyspę",
  "agents.code.modeHint.WYSPA": "Kod dołączy maszyny do wyspy wybranej w przełączniku u góry — używaj go dla kolejnych automatów obsługiwanych z tej samej bazy SPS.",
  "agents.code.modeHint.ZALOZYCIELSKI": "Dla pierwszej maszyny w nowym zakładzie. Wyspa powstanie przy pierwszym użyciu kodu: Ty podajesz nazwę obiektu, a agent sam przyniesie serwer i nazwę bazy — tego nie da się wiedzieć z góry.",
  "agents.code.modelZalozy": "wyspa jeszcze nie powstała — tak ją założy",
  "agents.code.more": "Więcej opcji — teraz: {maszyn} maszyn, ważny {godzin} h",
  "agents.code.noIsland": "Nie wybrano wyspy — wybierz ją w przełączniku u góry albo wydaj kod założycielski.",
  "agents.code.notFoundedYet": "wyspa jeszcze nie powstała",
  "agents.code.onceWarning": "Zapisz kod TERAZ — nie da się go odczytać ponownie.",
  "agents.code.revoke": "Odwołaj",
  "agents.code.revokePytanie": "Odwołać kod rejestracyjny „{label}\" ({prefiks}…)?\n\nOdwołanie działa natychmiast i nie da się go cofnąć — tym kodem nie zarejestruje się już żadna kolejna maszyna. Węzły, które weszły wcześniej, DZIAŁAJĄ DALEJ: mają własne tokeny i odwołuje się je osobno, przy węźle.\n\nZużyto: {uzyc}.",
  "agents.code.revoked": "Kod odwołany — nie zarejestruje już żadnej maszyny.",
  "agents.code.revokedAt": "odwołany",
  "agents.code.title": "Kod rejestracyjny",
  "agents.code.trybKrotki.SMART_SYNC": "Smart Sync — master w chmurze",
  "agents.code.trybKrotki.ZWYKLY": "zwykły — jedna baza",
  "agents.code.trybWyspy": "Model wdrożenia tej wyspy",
  "agents.code.trybWyspy.SMART_SYNC": "Smart Sync — master w chmurze",
  "agents.code.trybWyspy.ZWYKLY": "Zwykły — jedna baza",
  "agents.code.trybWyspyHint.SMART_SYNC": "Master stoi w naszym MSSQL-u, a każda maszyna ma własną bazę lokalną. Wybór tutaj jest ważny: wyspa przełączona na Smart Sync PO instalacji maszyn zostawia je bez prawa do synchronizacji i bez dostępu do bazy — trzeba je wtedy instalować od nowa.",
  "agents.code.trybWyspyHint.ZWYKLY": "Master to baza na maszynie klienta. Tak działa cała dotychczasowa flota.",
  "agents.code.trybWyspyWhat": "Wybierz TERAZ. Tryb wpisuje się w wyspę przy jej narodzinach i każda maszyna rejestruje się już w nim.",
  "agents.code.zAdresu": "Wypełnione z adresu tej instancji: „{nazwa}\". Popraw, jeśli obiekt nazywa się inaczej.",
  "agents.codeStillActive": "Kod, którym ten węzeł wszedł, jest nadal aktywny i wpuści kolejne maszyny. Odrzucenie blokuje tylko ten jeden węzeł — kod odwołuje się osobno.",
  "agents.colDecision": "Decyzja",
  "agents.colFound": "Co zastał",
  "agents.colIsland": "Klient / wyspa",
  "agents.colLastSeen": "Ostatni kontakt",
  "agents.colNode": "Węzeł",
  "agents.colState": "Stan",
  "agents.ct": "CT",
  "agents.ctOpis": "Natywny Change Tracking MSSQL-a jest tu włączony. Portal z niego nie korzysta — agent liczy różnicę lokalnie. Rozwiń węzeł, żeby zobaczyć objęte tabele i wyłączyć.",
  "agents.delete": "Usuń",
  "agents.deleteBody": "Wiersz zniknie z ekranu, a token węzła zostanie odwołany — bez tego agent wróciłby tu przy najbliższym sygnale życia. Odpis (węzeł, maszyna, baza, kto i kiedy odrzucił) zostaje w audycie. Jeśli agent nadal stoi na tej maszynie, najpierw go odinstaluj.",
  "agents.deleteHint": "Usuwa wiersz i odwołuje token tego węzła — do sprzątania po nieudanej rejestracji.",
  "agents.deleteTitle": "Usunąć ten węzeł?",
  "agents.deleted": "Węzeł {wezel} usunięty, odwołanych tokenów: {tokeny}",
  "agents.deployTitle": "Wdrożenie: kod i instalator",
  "agents.fClock": "Rozjazd zegara",
  "agents.fCode": "Kod wejścia",
  "agents.fDatabase": "Baza SPS",
  "agents.fEnrolled": "Zarejestrowany",
  "agents.fHostname": "Host",
  "agents.fIp": "Adres IP (ostatni meldunek)",
  "agents.fLastSeen": "Ostatni kontakt",
  "agents.fRole": "Rola",
  "agents.fServer": "Serwer SPS",
  "agents.fTimeSync": "Synchronizacja czasu",
  "agents.fTimeZone": "Strefa czasowa",
  "agents.fVersion": "Wersja agenta",
  "agents.fVmid": "VMID",
  "agents.ikonaChmura": "Węzeł w chmurze — baza bez automatu",
  "agents.ikonaMaszyna": "Węzeł na maszynie (szafa vendingowa)",
  "agents.inst.builtOn": "Złożony",
  "agents.inst.channel": "Wersja wydawana agentom (kanał aktualizacji)",
  "agents.inst.download": "Instalator (.zip)",
  "agents.inst.downloadExe": "Pobierz instalator (.exe)",
  "agents.inst.file": "Plik",
  "agents.inst.node": "Node w paczce",
  "agents.inst.notReady": "Ten obraz instancji nie zawiera instalatora agenta — zgłoś to jako błąd wydania.",
  "agents.inst.size": "Rozmiar",
  "agents.inst.smartscreen": "Pliku nie podpisujemy certyfikatem, więc Windows pokaże „Windows protected your PC” — to nie jest ostrzeżenie o wirusie: kliknij „Więcej informacji”, potem „Uruchom mimo to”.",
  "agents.inst.title": "Instalator agenta",
  "agents.inst.version": "Wersja agenta w paczce",
  "agents.island.delete": "Usuń wyspę",
  "agents.island.deleteBody": "Wyspa zniknie razem z tym, co do niej należy: węzłami ({wezly}), ich tokenami, odstępami tabel i alertami. Usuwamy tylko wyspy bez danych klienta — automatów, pracowników, wydań i operacji w niej nie ma. Odpis zostaje w audycie.",
  "agents.island.deleteTitle": "Usunąć tę wyspę?",
  "agents.island.deleted": "Wyspa {wyspa} usunięta (węzłów: {wezly})",
  "agents.island.employees": "Pracownicy",
  "agents.island.force": "Usuń z danymi",
  "agents.island.forceAgents": "Agenci w terenie stracą tokeny razem z wyspą: każdą maszynę trzeba będzie zarejestrować od nowa przy niej. Jeśli chodzi tylko o zepsute dane, użyj „Wyczyść dane wyspy\" w Ustawieniach — tam węzły i tokeny zostają.",
  "agents.island.forceBody": "Znika wyspa i wszystko, co do niej należy: automaty ({automaty}), pracownicy ({pracownicy}), wydania ({wydania}), węzły ({wezly}) z tokenami, kolejka zmian, alerty, kody rejestracyjne tej wyspy oraz jej pliki w magazynie. Nie ma z tego powrotu — read-model odbuduje się tylko z bazy klienta, a wydania tylko te, które SPS jeszcze u siebie ma.",
  "agents.island.forceConfirm": "Przepisz kod wyspy „{kod}\", żeby potwierdzić",
  "agents.island.forceDone": "Wyspa {wyspa} usunięta z danymi ({wierszy} wierszy, {wezly} węzłów, {obiekty} plików)",
  "agents.island.forceTitle": "Usunąć wyspę RAZEM Z DANYMI?",
  "agents.island.island": "Wyspa",
  "agents.island.machines": "Automaty",
  "agents.island.nodes": "Węzły",
  "agents.island.title": "Wyspy tego klienta",
  "agents.island.withdrawals": "Wydania",
  "agents.masterWyspy": "master wyspy",
  "agents.masterWyspyOpis": "Na tym węźle stoi baza master tej wyspy — ustaliło to udane odtworzenie kopii pod nazwą mastera. To z niego (a nie z maszyn) czyta się stan wyspy w trybie Smart Sync.",
  "agents.othersEmpty": "Na tej instancji nie zgłosił się jeszcze żaden agent.",
  "agents.othersTitle": "Aktywni agenci",
  "agents.odwolane.tytul": "Odwołane, wciąż próbują",
  "agents.odwolane.opis": "Odwołane tokeny, które w ostatnich 30 dniach próbowały się łączyć. Portal je odrzuca — niczego nie zapisują.",
  "agents.odwolane.wezel": "Węzeł",
  "agents.odwolane.wyspa": "Wyspa",
  "agents.odwolane.odwolany": "Odwołany",
  "agents.odwolane.od": "Próbuje od",
  "agents.odwolane.ostatnio": "Ostatnia próba",
  "agents.odwolane.adres": "Adres",
  "agents.odwolane.coZrobic": "Co zrobić",
  "agents.odinstaluj.przycisk": "Odinstaluj",
  "agents.odinstaluj.hint": "Zdejmij agenta z maszyny i usuń węzeł",
  "agents.odinstaluj.tytul": "Odinstalować agenta?",
  "agents.odinstaluj.opis": "Agent usunie z maszyny usługę, pliki i stan, a konto SQL zablokuje. Węzeł zniknie z listy od razu; maszyna offline odinstaluje się, gdy wróci.",
  "agents.odinstaluj.potwierdz": "Wpisz nazwę węzła „{wezel}\", żeby potwierdzić",
  "agents.odinstaluj.zlecone": "Zlecono odinstalowanie {wezel}",
  "agents.odinstaluj.bezTokenu": "Węzeł {wezel} usunięty, ale nie miał tokenu — maszyna nie dostanie polecenia",
  "agents.odinstaluj.zWyspa": "Odinstaluj agentów z maszyn",
  "agents.odinstaluj.zleconeWyspy": "Zlecono odinstalowanie agentów ({n})",
  "agents.odinstalowania.tytul": "Odinstalowania",
  "agents.odinstalowania.zlecono": "Zlecono",
  "agents.odinstalowania.stan": "Stan",
  "agents.odinstalowania.przyjete": "przyjęte",
  "agents.odinstalowania.pukala": "zapukała",
  "agents.odinstalowania.czeka": "czeka na maszynę",
  "agents.odwolane.wygasl": "wygasł",
  "agents.odwolane.staraMaszyna": "Węzeł działa na nowym tokenie — wyłącz agenta na maszynie spod tego adresu",
  "agents.odwolane.bezKlucza": "Węzeł nie ma działającego tokenu — zarejestruj maszynę ponownie (agent enroll)",
  "agents.oczekujeWiersz": "czeka na potwierdzenie — portal przyjmuje od tego węzła wyłącznie sygnał życia",
  "agents.reset.button": "Wyczyść instancję",
  "agents.reset.confirm": "Przepisz zdanie „{fraza}\", żeby potwierdzić",
  "agents.reset.dialogTitle": "Wyczyścić całą instancję?",
  "agents.reset.done": "Instancja wyczyszczona: {wysp} wysp, {wezlow} węzłów, {wierszy} wierszy, {kodow} kodów rejestracyjnych",
  "agents.reset.leftovers": "Nie udało się usunąć {n} plików z magazynu — wiersze zniknęły, pliki zostały. Szczegóły w logu instancji.",
  "agents.reset.summary": "Do usunięcia: {wysp} wysp, {wezlow} węzłów, {maszyn} automatów, {wydan} wydań.",
  "agents.reset.title": "Wyczyść instancję do zera",
  "agents.reset.what": "Usuwa WSZYSTKIE wyspy tej instancji razem z danymi, węzłami, tokenami, plikami w magazynie i wydanymi kodami rejestracyjnymi — także tymi założycielskimi, które nie wskazują jeszcze żadnej wyspy. Zostają: konta portalu i uprawnienia, klienci, token Vending+ oraz dziennik audytu, w którym zapisujemy, co zniknęło.",
  "agents.rodz.dociaganie": "rodzeństwo: nowe wydania jadą, historia dociąga się w tle (kursor {kursor} z {granica})",
  "agents.rozwinWszystkie": "Rozwiń wszystkie",
  "agents.sct": "SCT",
  "agents.sctOpis": "Replikacja SupplyPointa (SyncChangeTracking) jest tu czynna — triggery zapisują zmiany, a nikt ich nie odbiera. Rozwiń węzeł, żeby zobaczyć liczby i wyłączyć.",
  "agents.szczegoly": "Szczegóły",
  "agents.inst.legacy": "legacy",
  "agents.reasonHint": "Powód (opcjonalnie, trafia do audytu)",
  "agents.reject": "Odrzuć",
  "agents.rejectConfirm": "Potwierdź odrzucenie",
  "agents.rejected": "Węzeł odrzucony — portal przestał przyjmować od niego dane.",
  "agents.rodz.blad": "rodzeństwo: NIE WPISAŁ — {blad}",
  "agents.rodz.milczy": "rodzeństwo: węzeł NIE PYTA o wydania (ostatnio: {kiedy})",
  "agents.doPrzerobienia": "operacji do wykonania: {n}",
  "agents.rodz.nadaza": "rodzeństwo: nadąża ({wpisanych} wpisanych)",
  "agents.rodz.nadazaProsto": "rodzeństwo: nadąża",
  "agents.rodz.zaleglosc": "rodzeństwo: czeka dociągnięcie (kursor {kursor} z {szczyt})",
  "agents.state.NIEZNANY": "Nieznany",
  "agents.state.OCZEKUJE": "Czeka",
  "agents.state.ODRZUCONY": "Odrzucony",
  "agents.state.POTWIERDZONY": "Potwierdzony",
  "agents.timeSyncShort": "synchronizacja zegara:",
  "agents.title": "Agenci",
  "agents.uwagiWiecej": "+ {ile} więcej",
  "agents.verBehind": "Starsza niż docelowa ({docelowa}) — agent podniesie się sam przy najbliższym sprawdzeniu wersji",
  "agents.verShort": "wersja",
  "agents.wskazMastera": "Wskaż jako master wyspy",
  "agents.wskazMasteraOpis": "Ustawia ten węzeł jako mastera wyspy. Potrzebne, gdy baza mastera została odtworzona POZA portalem — bez tego wskazania portal nie wie, gdzie stoi master, i wstrzymuje wysyłanie zmian konfiguracji do maszyn.",
  "agents.wskazanoMastera": "Master wyspy wskazany na węzeł {wezel} — zmiany konfiguracji ruszą do maszyn.",
  "agents.wskazanoMasteraBezZmian": "Ten węzeł był już masterem tej wyspy; nic nie zmieniono.",
  "agents.zwinWszystkie": "Zwiń wszystkie",
  "alerts.unmonitored": "Automaty bez agenta",
  "alerts.unmonitoredHint": "To nie awaria, a luka wdrożeniowa: nikt tu nie zainstalował agenta, więc portal nie wie o tej maszynie nic poza tym, co przyszło ze SPS.",
  "alr.ack": "Potwierdzam",
  "alr.ackGrupe": "Potwierdź {n}",
  "alr.acked": "Potwierdzono {n} — to znacznik w portalu, nic się nie zmieniło na automacie",
  "alr.acknowledged": "potwierdzone",
  "alr.bannerBody": "Alerty w tej tabeli powstają, gdy agent coś zgłosi — dziś są to sprawy wyspy i bazy (agent wskazuje inną bazę niż wyspa, drugie źródło danych na wyspie, master czekający na zatwierdzenie). Pusta lista nie znaczy „brak problemów”, znaczy „nikt niczego nie zgłosił”. Sekcja poniżej pokazuje to, co portal wylicza sam, bez zgłoszenia.",
  "alr.bannerTitle": "Alerty floty",
  "alr.blindPeople": "osób przekroczyło limit niewidocznie dla automatów",
  "alr.channelAge": "Ostatnie zgłoszenie",
  "alr.code": "Kod",
  "alr.code.CONFIG_APPLIED": "Konfiguracja zastosowana na automacie",
  "alr.code.LOW_STOCK": "Niski stan w przegródce — wymagane uzupełnienie",
  "alr.code.SYNC_LAG": "Automat nie raportował od dłuższego czasu",
  "alr.contradiction": "sprzeczność",
  "alr.contradictionHint": "Portal ma ten automat jako podłączony, a jednocześnie nie słyszał go dłużej niż przyjęty próg. Jedna z tych informacji jest nieaktualna.",
  "alr.contradictionNote": "{n} automatów jest oznaczonych jako podłączone, choć portal ich nie słyszał — flaga podłączenia jest nieaktualna albo ostatni kontakt się nie zapisuje.",
  "alr.detectedNote": "Liczone TERAZ z danych, które portal już ma — bez agenta. To nie są wiersze w bazie: nie mają stanu i nie da się ich potwierdzić.",
  "alr.detectedTitle": "Wykryte przez portal",
  "alr.empty": "Na tej wyspie nie ma żadnych zgłoszonych alertów.",
  "alr.filterAll": "Wszystkie",
  "alr.hoursAgo": "{n} h temu",
  "alr.lowStockAt": "Niski stan przy",
  "alr.lowStockTitle": "Przegródki na wyczerpaniu",
  "alr.lowStockTruncated": "Lista obcięta do 100 pozycji — licznik dotyczy tylko pobranych wierszy.",
  "alr.message": "Treść",
  "alr.neverSeen": "nigdy nie raportował",
  "alr.odKiedy": "pierwsze wystąpienie: {kiedy}",
  "alr.openCritical": "Otwarte krytyczne",
  "alr.openWarning": "Otwarte ostrzeżenia",
  "alr.rationingDetail": "Nad limitem w sumie: {over} os., w {rules} regułach są przekroczenia, których żaden automat nie widzi.",
  "alr.rationingTitle": "Ograniczenia bez ochrony",
  "alr.rationingWhy": "Dla tych osób każdy automat osobno przepuściłby kolejne pobranie, bo na żadnym z nich limit nie został dobity.",
  "alr.razy": "×{n}",
  "alr.reportedTitle": "Zgłoszone przez agenta",
  "alr.resolved": "rozwiązane",
  "alr.sev.CRITICAL": "krytyczny",
  "alr.sev.INFO": "informacja",
  "alr.sev.WARNING": "ostrzeżenie",
  "alr.severity": "Waga",
  "alr.silentFor": "{n} h bez kontaktu",
  "alr.silentMinutes": "Milczy powyżej (min)",
  "alr.silentMinutesHint": "Po ilu minutach bez kontaktu automat jest zgłaszany jako milczący. Nie mniej niż 16 — agent po awarii melduje się najrzadziej co kwadrans, więc niższy próg oskarżałby o milczenie kogoś, z kim mamy kontakt.",
  "alr.silentTitle": "Automaty bez kontaktu",
  "alr.status.ACKNOWLEDGED": "potwierdzony",
  "alr.status.ACKNOWLEDGED.hint": "Ktoś w portalu zaznaczył, że to widział. Przyczyna alertu NIE zniknęła.",
  "alr.status.OPEN": "otwarty",
  "alr.status.RESOLVED": "rozwiązany",
  "alr.statusCol": "Stan",
  "alr.when": "Kiedy",
  "app.name": "Vendi",
  "asg.allGroupsAssigned": "Wszystkie grupy już mają dostęp.",
  "asg.alsoOther": "Też inne automaty",
  "asg.alsoOtherHint": "Tyle osób z dostępem do tego automatu pobiera także na innym — dla nich limit liczony per automat wychodzi za niski.",
  "asg.assignedEmployees": "Mają dostęp",
  "asg.assignedGroups": "Grupy z dostępem",
  "asg.availableEmployees": "Bez dostępu",
  "asg.availableGroups": "Grupy bez dostępu",
  "asg.direct": "Bezpośrednio",
  "asg.groupWarn": "Przypisanie grupy wpuszcza na automat CAŁY jej skład naraz — a odebranie odbiera dostęp wszystkim, którzy nie mają go inną drogą.",
  "asg.groups": "Grupy",
  "asg.machine": "Automat",
  "asg.netHeads": "Osób w zmienianych grupach",
  "asg.netHeadsHint": "Suma liczebności WSZYSTKICH grup, którym dodajesz albo odbierasz dostęp. Nie jest to przyrost dostępu: część tych osób może mieć dostęp inną drogą, a przy jednoczesnym dodawaniu i odbieraniu zmiany idą w przeciwnych kierunkach. Realny skutek pokazuje kolumna „Zasięg” po zapisie.",
  "asg.noEmployees": "Żaden pracownik nie ma przypisania bezpośredniego.",
  "asg.noGroups": "Żadna grupa nie ma dostępu do tego automatu.",
  "asg.pendingHint": "Jest niezastosowana zmiana przypisań dla tego automatu.",
  "asg.reach": "Zasięg",
  "asg.reachHint": "Różni pracownicy mający dostęp: bezpośrednio LUB przez grupę.",
  "asg.readOnlyForYou": "Masz podgląd przypisań. Zmiany może wprowadzać tylko administrator.",
  "asg.saved": "Zmiana przypisań zakolejkowana",
  "asg.tab.employees": "Pracownicy",
  "asg.tab.groups": "Grupy",
  "asg.title": "Dostęp do automatu",
  "beben.dodaj": "Dodaj bęben",
  "beben.kolumny": "Liczba kolumn",
  "beben.niedostepny": "wzorzec wierszy nieustalony, czekamy na pomiar",
  "beben.ostrzezenieTresc": "Zapis idzie do bazy automatu i zmienia jego geometrię. Zła liczba kolumn nie da błędu — da automat, który wskazuje inną fizyczną komórkę, niż widzisz na planogramie. Usunięcie bębna wymaga wejścia do SPSUI na maszynie.",
  "beben.ostrzezenieTytul": "To zmienia konstrukcję maszyny",
  "beben.podsumowanie": "Powstanie {szuflad} szuflad i {przegrod} przegród. Sprawdź, czy to ta maszyna — tej operacji nie da się cofnąć z portalu.",
  "beben.poziomy": "Liczba poziomów (szuflad w kolumnie)",
  "beben.typRamy": "Typ ramy",
  "beben.tytul": "Nowy bęben",
  "beben.utworz": "Utwórz bęben",
  "beben.zlecono": "Zlecono bęben PIC {pic}: {szuflad} szuflad, {przegrod} przegród. Powstanie po dojechaniu zmiany do maszyny.",
  "cc.add": "Dodaj centrum",
  "cc.addTitle": "Nowe centrum kosztowe",
  "cc.alias": "Alias",
  "cc.aliasHint": "Pole ALIAS encji — drugie oznaczenie centrum, nieobowiązkowe.",
  "cc.code": "Kod centrum",
  "cc.codeHint": "Klucz naturalny w SPS, tekst nadawany przez człowieka. Najwyżej 50 znaków. SPS nie rozróżnia wielkości liter.",
  "cc.codeTaken": "Ten kod ma już centrum „{name}”. SPS nie rozróżnia wielkości liter, więc to byłby ten sam wiersz.",
  "cc.created": "Centrum kosztowe zakolejkowane",
  "cc.divergenceIntro": "Niezgodne centrum kosztowe u {n} pracowników — te same wydania policzą się inaczej w zależności od raportu.",
  "cc.spoza": "spoza słownika",
  "cc.spozaHint": "Kod wpisany na kartach pracowników, bez wpisu w słowniku SPS",
  "cc.doSlownika.przycisk": "Dodaj do słownika",
  "cc.doSlownika.wszystkie": "Dodaj do słownika ({n})",
  "cc.doSlownika.tytul": "Dodaj do słownika centrów",
  "cc.doSlownika.opis": "Kody trafią do słownika centrów w SPS. Przypisania pracowników się nie zmienią.",
  "cc.doSlownika.osob": "Osób",
  "cc.doSlownika.nazwyHr": "Pobieram nazwy z HR+…",
  "cc.doSlownika.dodaj": "Dodaj {n}",
  "cc.doSlownika.dodano": "Dodano do słownika: {n}",
  "cc.divergent": "Rozjazd",
  "cc.divergentHint": "Różnica między liczbą osób z przynależnością a liczbą osób z tym kodem w polu tekstowym. Obie liczby trafiają na wydanie, więc dwa raporty odpowiedzą inaczej.",
  "cc.kpi.centers": "Centra",
  "cc.kpi.mismatch": "Napis ≠ przynależność",
  "cc.kpi.multiple": "W kilku centrach",
  "cc.kpi.onlyColumn": "Tylko napis",
  "cc.kpi.onlyMembership": "Tylko przynależność",
  "cc.kpi.unknownCodes": "Kody spoza słownika",
  "cc.members": "Przynależność",
  "cc.name": "Nazwa",
  "cc.usun.akcja": "Usuń centrum kosztowe",
  "cc.usun.harmonogramy": "Filtruje harmonogramy raportów: {lista}",
  "cc.usun.historia": "Historia wydań zostaje bez zmian.",
  "cc.usun.hrPlus": "HR+ przywróci ten kod na kartach, jeśli dalej go wysyła.",
  "cc.usun.napisy": "Kod na kartach do wyczyszczenia",
  "cc.usun.potwierdz": "Usuń centrum",
  "cc.usun.przynaleznosci": "Przynależności do zdjęcia",
  "cc.usun.slownik": "Wpis w słowniku",
  "cc.usun.slownikNie": "brak — kod tylko na kartach",
  "cc.usun.slownikTak": "usuniemy",
  "cc.usun.tytul": "Usunięcie centrum kosztowego",
  "cc.usun.wKolejce": "Na ten kod czekają zmiany w kolejce — usuniesz go po ich zakończeniu.",
  "cc.usun.zlecono": "Usunięcie w kolejce zmian",
  "cc.niezgodni.karta": "Karta",
  "cc.niezgodni.napis": "Przy pracowniku",
  "cc.niezgodni.podtytul": "{n} pracowników. Poprawia się to na karcie pracownika — przypisaniem centrum.",
  "cc.niezgodni.pokaz": "Pokaż ich",
  "cc.niezgodni.pracownik": "Pracownik",
  "cc.niezgodni.przynaleznosc": "Przypisane centra",
  "cc.niezgodni.pusto": "Nikogo — już poprawione.",
  "cc.niezgodni.tytul": "Niezgodne centrum kosztowe",
  "cc.niezgodni.uciete": "i jeszcze {n} — lista jest ucięta.",
  "cc.niezgodni.wielu": "w kilku centrach",
  "cc.onColumn": "Napis w Users",
  "cc.pendingHint": "Jest niezastosowana zmiana konfiguracji dla tego centrum.",
  "cd.ack.assumedMapping": "Nazwy kolumn tej tabeli są ZAŁOŻONE z konwencji SPS, nie potwierdzone. Zmiana może trafić w niewłaściwą kolumnę na bazie klienta.",
  "cd.ack.conflict": "Na ten sam rekord czeka już niezastosowana zmiana. Portal nie umie unieważnić starszej intencji — kolejność rozstrzygnie numer w kolejce.",
  "cd.ack.keyOutOfSequence": "Numer klucza jest poza sekwencją, którą nadaje portal. Rozumiem, że może zderzyć się z rekordem wydanym później.",
  "cd.ack.modeTypeUnknown": "Nieznany tryb adresowania bębna. SPS używa 9 (bęben natywny) i 25 (DynaBox); inna wartość może uniemożliwić start bębna albo rozjechać współrzędne przegródek.",
  "cd.ack.moduleOwned": "Ta tabela ma własny moduł portalu, który sprawdza reguły domenowe pominięte tutaj. Świadomie omijam te sprawdzenia.",
  "cd.ack.nieznanyWiersz": "Portal nie zna tego wiersza. Rozumiem, że usunięcie i tak pójdzie do baz wyspy, a w portalu nie będzie czego odbić.",
  "cd.ack.podzialNaOperacje": "Rozumiem, że zmiana pójdzie w kilku operacjach, każda jest osobną transakcją i odrzucenie jednej nie cofa pozostałych.",
  "cd.ackTitle": "Potwierdź, że rozumiesz skutki:",
  "cd.action": "Akcja",
  "cd.actionI": "I — nowy wiersz",
  "cd.actionP": "P — zmiana wskazanych kolumn",
  "cd.actionD": "D — usunięcie wiersza",
  "cd.deleteByKey": "Usunięcie wskazuje wiersz samym kluczem — bez danych.",
  "cd.addToBatch": "Dodaj do paczki",
  "cd.author": "Autor",
  "cd.authorNote": "Uzasadnienie",
  "cd.authorNoteHint": "Tytuł operacji generuje portal z faktów. To pole odpowiada na pytanie, DLACZEGO sięgasz po surowy edytor zamiast modułu. Zostaje w rejestrze zmian.",
  "cd.authorNotePlaceholder": "np. Korekta ceny po zmianie cennika dostawcy — moduł katalogu towarów nie istnieje",
  "cd.bannerBody": "Ten ekran kolejkuje zmianę WPROST do bazy klienta, z pominięciem sprawdzeń domenowych, które robią moduły portalu. Agent pobiera kolejkę co ~10 s i wykonuje ją na automacie — o ile wartownik nie odmówi, bo wiersz zmienił się w SPSUI po ostatnim odczycie. Stan każdej operacji i powód ewentualnej odmowy widać w kolumnie „Stan” niżej.",
  "cd.bannerIsland": "Zmiany dotyczą wyspy: {client} — {island}. Przełączenie wyspy w nagłówku czyści szkic paczki.",
  "cd.bannerTitle": "Działania na bazie — zapis wprost do bazy klienta",
  "cd.batchEmpty": "Paczka jest pusta. Dodaj co najmniej jedną zmianę.",
  "cd.batchOrderHint": "Kolejność ma znaczenie: zmiany trafią do kolejki w tej kolejności (np. grupa musi powstać przed członkostwem).",
  "cd.batchTitle": "Paczka — jedna operacja",
  "cd.builderTitle": "Złóż zmianę",
  "cd.chooseTable": "— wybierz tabelę —",
  "cd.clearBatch": "Wyczyść paczkę",
  "cd.closedTitle": "Czego edytor nie otwiera: {unavailable} tabel bez mapowania, {forbidden} zakazane",
  "cd.columnsToPatch": "Kolumny do zmiany",
  "cd.forbiddenTables": "Tabele, do których config-down nie pisze nigdy",
  "cd.keyOnlyTable": "W tej tabeli cały wiersz jest kluczem — nie ma osobnych kolumn do ustawienia.",
  "cd.mappingAssumed": "mapowanie założone",
  "cd.mappingConfirmed": "mapowanie potwierdzone",
  "cd.moveDown": "W dół",
  "cd.moveUp": "W górę",
  "cd.naturalKey": "Klucz naturalny",
  "cd.nextKeyHint": "Portal nadałby tu numer {next} (najwyższy zajęty: {max}). Inny numer zatruwa numerację na przyszłość.",
  "cd.noTypeDeclared": "brak zadeklarowanego typu — nieedytowalna",
  "cd.notOfferedActions": "Akcje, których edytor nie oferuje",
  "cd.opChanges": "Zmiany",
  "cd.opTitle": "Operacja",
  "cd.ownedBy": "ma moduł: {module}",
  "cd.ownedHint": "Zmiana przez moduł jest bezpieczniejsza — sprawdza reguły domenowe i aktualizuje portal razem z kolejką.",
  "cd.portalDoesNotKnow": "Portal nie zna rekordu o tym kluczu.",
  "cd.portalHasNow": "Portal ma dziś:",
  "cd.preview": "Podgląd",
  "cd.previewDesc": "Werdykt dla każdej z {n} zmian. Zapis jest możliwy tylko wtedy, gdy żadna nie jest zablokowana.",
  "cd.previewIsPortalOnly": "„Portal ma dziś” to read-model portalu, czyli OSTATNIA MIGAWKA agenta (cykl konfiguracji co ~60 s), a nie odczyt bazy SPS na żywo — wartość mogła się tam zmienić po tej migawce. Przed zapisem agent i tak porównuje prawdziwy wiersz i odmawia, jeśli ktoś ruszył go w SPSUI.",
  "cd.previewRunning": "Sprawdzam paczkę i próbnie odzwierciedlam ją w portalu…",
  "cd.previewTitle": "Podgląd przed zakolejkowaniem",
  "cd.queueAction": "Zakolejkuj zmiany",
  "cd.queued": "Zmiany zakolejkowane — agent pobierze je w ciągu ~10 s",
  "cd.queuedHint": "Czeka na agenta. Kolejka schodzi co ~10 s; stan zmieni się sam.",
  "cd.registryEmpty": "Na tej wyspie nie złożono tu jeszcze żadnej operacji.",
  "cd.registryTitle": "Operacje z tej zakładki",
  "cd.removeFromBatch": "Usuń z paczki",
  "cd.rowData": "Dane wiersza",
  "cd.status": "Stan",
  "cd.statusQueued": "w kolejce",
  "cd.table": "Tabela SPS",
  "cd.unavailableTables": "Tabele bez zadeklarowanego klucza naturalnego",
  "cd.verdictBlocked": "zablokowana",
  "cd.verdictOk": "przejdzie",
  "cd.when": "Kiedy",
  "chg.action": "Akcja",
  "chg.actionName.D": "usunięcie wiersza",
  "chg.actionName.I": "dodanie wiersza",
  "chg.actionName.P": "zmiana kolumn",
  "chg.actionName.U": "podmiana całego wiersza",
  "chg.author": "Autor",
  "chg.authorNote": "Uzasadnienie",
  "chg.bannerBody": "Etapy poza „w kolejce” przestawia agent działający u klienta. Zakolejkowanie nie znaczy, że zmiana jest już na automacie.",
  "chg.bannerNothingAdvanced": "Żadna operacja nigdy nie wyszła ze stanu „w kolejce”. Kolejkę pobiera agent bazy co ~10 s, więc dziś to JEST sygnał do sprawdzenia: albo ta wyspa nie ma agenta z dostępem do bazy, albo agent nie chodzi, albo wartownik odrzuca wszystko — wtedy powód stoi przy operacji. Rosnący wiek najstarszej pozycji pozostaje najuczciwszą miarą stanu kolejki.",
  "chg.bannerTitle": "Kolejka zmian konfiguracji",
  "chg.changeCount": "Zmian",
  "chg.changesPending": "Zmian w oczekujących",
  "chg.confirmedAt": "Potwierdzono na automacie",
  "chg.created": "Zakolejkowano",
  "chg.data": "Dane",
  "chg.przed": "Przed",
  "chg.przedBrakHint": "Brak stanu sprzed zmiany — operacja sprzed 15.10.2026, starszy agent albo ponad 90 dni",
  "chg.przedNieBylo": "wiersza nie było",
  "chg.przedRozny": "różny na maszynach",
  "chg.cofnij": "Cofnij",
  "chg.cofa": "Cofa operację",
  "chg.cofnietaPrzez": "Cofnięta ({status})",
  "cofn.tytul": "Cofnięcie operacji",
  "cofn.opis": "Zmiany odwrotne ze stanu sprzed operacji. Agent odmówi, jeśli ktoś zmienił te wiersze później.",
  "cofn.blokady": "Nie da się cofnąć przyciskiem",
  "cofn.uzasadnienie": "Uzasadnienie (co najmniej 10 znaków)",
  "cofn.potwierdz": "Cofnij operację",
  "cofn.zakolejkowano": "Cofnięcie w kolejce",
  "chg.detailTitle": "Operacja config-down",
  "chg.details": "Szczegóły",
  "chg.empty": "Na tej wyspie nie ma jeszcze żadnej operacji config-down.",
  "chg.external": "z zewnątrz",
  "chg.externalHint": "Operację zlecił zewnętrzny system po API (nazwa osoby jest deklaracją tamtej strony, nie tożsamością, której dowiedliśmy).",
  "chg.filterAll": "Wszystkie",
  "chg.filterNone": "brak",
  "chg.fromEditor": "z edytora",
  "chg.holdTitle": "Kolejka stoi — {n} operacji czeka",
  "chg.collapse": "Zwiń oczekujące",
  "chg.collapsePick": "Tabela do zwinięcia",
  "chg.collapseConfirm": "Zwinąć oczekujące operacje tabeli {t}? Nie pojadą na automaty. Tego nie da się cofnąć.",
  "chg.collapseDone": "Zwinięto {n} operacji tabeli {t}",
  "chg.collapseNone": "Nie ma czego zwijać w tabeli {t}",
  "chg.key": "Klucz naturalny",
  "chg.never": "nigdy",
  "chg.oldestWaiting": "Najstarsza czeka",
  "chg.opId": "Identyfikator operacji",
  "chg.juzPrzejrzane": "Przejrzanych wcześniej: {ile}",
  "chg.nicDoZamkniecia": "Nie było czego zamykać — wszystkie {ile} nieudanych jest już przejrzanych",
  "chg.brakNieudanych": "Ta wyspa nie ma nieudanych operacji",
  "chg.nieudaneWszystkiePrzejrzane": "Nieudane operacje: {ile} — wszystkie przejrzane",
  "chg.nieudaneZostajaOpis": "Te zmiany nie dojechały na automaty. Skwitowanie nic nie naprawia — jeśli miały wejść, trzeba je wprowadzić ponownie.",
  "chg.przejrzana": "przejrzana",
  "chg.przejrzanaHint": "Kto i kiedy — w szczegółach operacji",
  "chg.nieudanePasek": "Nieudane operacje: {ile}",
  "chg.nieudanePasekOpis": "Te zmiany NIE dojadą same — dopóki są otwarte, wyspa świeci „wymaga uwagi\". Zamknięcie nie kasuje ani operacji, ani błędu: zostaje w rejestrze razem z tym, kto ją przejrzał.",
  "chg.pokazNieudane": "Pokaż tylko nieudane",
  "chg.nieudanaTytul": "Ta operacja się nie udała",
  "chg.nieudanaPodpowiedz": "„Zamknij\" znaczy: widzieliśmy, nie da się tego dokończyć — operacja zostaje nieudana, przestaje tylko liczyć się do stanu wyspy. „Wyślij ponownie\" próbuje TĄ SAMĄ wartością i może nadpisać to, co jest teraz na automacie.",
  "chg.zamknij": "Zamknij",
  "chg.jużZamknięta": "Zamknięta",
  "chg.ponow": "Wyślij ponownie",
  "chg.zamknieta": "Operacja zamknięta — przestała liczyć się do stanu wyspy",
  "chg.ponowiona": "Operacja wróciła do kolejki (zdjęto {ile} nieudanych wydań)",
  "chg.zamknietaPrzez": "Zamknięta przez {kto}, {kiedy}",
  "chg.ponawiana": "Ponawiana {ile} razy",
  "chg.zamknijWszystkie": "Zamknij wszystkie nieudane ({ile})",
  "chg.zamknieteWszystkie": "Zamknięto {ile} nieudanych operacji",
  "chg.opTitle": "Operacja",
  "chg.pending": "Czeka operacji",
  "chg.seq": "Nr w kolejce",
  "chg.source": "Skąd",
  "chg.source.AUTHORING": "działania na bazie",
  "chg.source.MODULE": "moduł portalu",
  "chg.sourceHint.AUTHORING": "Złożona w „Działaniach na bazie” — w edytorze (bez sprawdzeń domenowych modułu) albo gotową korektą.",
  "chg.stageInProgress": "w toku",
  "chg.stageReached": "osiągnięty",
  "chg.stageUnreachable": "jeszcze nieosiągnięty",
  "chg.status.APPLIED": "zastosowana",
  "chg.status.CONFIRMED": "potwierdzona",
  "chg.status.FAILED": "nieudana",
  "chg.status.QUEUED": "w kolejce",
  "chg.status.SENT": "wysłana",
  "chg.status.SUPERSEDED": "zastąpiona",
  "chg.statusCol": "Etap",
  "chg.statusHint.APPLIED": "Agent wykonał zapis na bazie automatu, ale nie potwierdził jeszcze, że zmiana jest tam widoczna.",
  "chg.statusHint.CONFIRMED": "Agent potwierdził, że zmiana jest widoczna w bazie automatu. Dopiero to znaczy „zrobione”.",
  "chg.statusHint.FAILED": "Zapis na automacie się nie udał. Powód jest w szczegółach operacji.",
  "chg.statusHint.QUEUED": "Intencja zapisana w portalu. Nikt jej jeszcze nie wykonał na automacie.",
  "chg.statusHint.SENT": "Agent pobrał zmianę. To NIE znaczy, że zapisał ją w bazie automatu.",
  "chg.statusHint.SUPERSEDED": "Nowsza zmiana na ten sam rekord unieważniła tę operację.",
  "chg.stepperNote": "Etapy po „w kolejce” przestawia agent u klienta, kiedy pobierze operację i wykona ją na bazie automatu. Operacja stojąca tutaj znaczy, że agent jej jeszcze nie pobrał — albo nie działa.",
  "chg.stepperNoteAdvanced": "Ta operacja wyszła poza pierwszy etap, czyli ktoś ją wykonał na automacie. W tej wersji portalu etapy przestawia wyłącznie agent u klienta — portal sam ich nie zmienia.",
  "chg.table": "Tabela",
  "chg.tables": "Tabele",
  "chg.waiting": "Czeka",
  "chg.waitingDays": "{n} dni",
  "chg.wydaniaLicznik": "potwierdziło {ile} z {wszystkich}",
  "chg.wydaniaTytul": "Na których bazach ta zmiana już jest",
  "chg.wydanieLiczby": "zapisanych {zapisanych} · pominiętych {pominietych}",
  "common.cancel": "Anuluj",
  "common.checkingSession": "Sprawdzanie sesji…",
  "common.close": "Zamknij",
  "common.configured": "skonfigurowany",
  "common.delete": "Usuń",
  "common.disabled": "wyłączony",
  "common.edit": "Edytuj",
  "common.enabled": "włączony",
  "common.error": "Błąd",
  "common.inProgress": "w trakcie",
  "common.loading": "Ładowanie…",
  "common.nie": "nie",
  "common.notConfigured": "nieskonfigurowany",
  "common.save": "Zapisz",
  "common.starszaInstancja": "Ten ekran pochodzi z nowszego wydania portalu niż API tej instancji — brakująca trasa odpowiada 404. Funkcja pojawi się, gdy wdrożenie backendu dojdzie do końca; nic nie trzeba naprawiać.",
  "common.tak": "tak",
  "dashboard.auth": "Uwierzytelnianie",
  "dashboard.noIslandBody": "Wyspa to jedna baza SPS i powstaje sama — przy pierwszej rejestracji agenta na maszynie klienta. Dopóki nie zarejestruje się ani jeden agent, portal nie ma skąd wziąć danych: automatów, pracowników ani wydań.",
  "dashboard.noIslandCta": "Dodaj pierwszego agenta",
  "dashboard.noIslandNoAccess": "Dodawanie agentów prowadzi serwis SDI — zgłoś się do nas, a uruchomimy pierwszą wyspę.",
  "dashboard.noIslandSteps": "Na ekranie Agentów wydasz kod rejestracyjny i pobierzesz instalator — jedno archiwum, które na maszynie klienta rozkłada wszystko samo.",
  "dashboard.noIslandTitle": "Nie ma jeszcze żadnej wyspy",
  "dashboard.runtime": "Konfiguracja runtime",
  "dashboard.stack": "Stack",
  "dashboard.storage": "Magazyn plików (S3/MinIO)",
  "dashboard.storageOff": "niepodłączony",
  "dashboard.subtitle": "Stan instancji i konfiguracja runtime",
  "dashboard.sync": "Silnik synchronizacji",
  "dashboard.syncBrakWezlow": "Na tej wyspie nie ma jeszcze węzła z bazą — synchronizacja zacznie się po wdrożeniu pierwszego agenta.",
  "dashboard.syncMasterDoPotwierdzenia": "Baza master wyspy: „{baza}\" na maszynie klienta — jeszcze nie zatwierdzona (Ustawienia wyspy → Model wdrożenia i baza wyspy).",
  "dashboard.syncMasterNaMaszynie": "Baza master wyspy: „{baza}\" — stoi na maszynie klienta.",
  "dashboard.syncMasterNieustalony": "Baza master wyspy: „{baza}\". Portal nie wie, na którym węźle stoi — ustali to zasianie mastera (Kopie → na maszynę → odtwórz).",
  "dashboard.syncMasterOk": "Master „{baza}\" stoi na węźle {wezel} i synchronizuje — ostatni sygnał {minut} min temu.",
  "dashboard.syncMasterSamaBaza": "Baza master wyspy: „{baza}\".",
  "dashboard.syncMasterZly": "Master „{baza}\" na węźle {wezel} NIE ODPOWIADA POPRAWNIE (ostatni sygnał {minut} min temu).",
  "dashboard.syncModul": "Instancja ma moduł synchronizacji. Stanu tej wyspy ta wersja portalu nie podaje.",
  "dashboard.title": "Pulpit",
  "dashboard.trybSmartSync": "Smart Sync",
  "dashboard.trybZwykly": "zwykły",
  "dashboard.vendingPlus": "Token Vending+",
  "dashboard.vendingPlusBrak": "brak",
  "dashboard.vendingPlusBrakHint": "Ta instancja nie ma aktywnego tokenu — integracja Vending+ nie ma czym się uwierzytelnić. Wydaj go w Administracja → {gdzie}.",
  "dashboard.vendingPlusHint": "Wydany {kiedy}, ostatnio użyty {ostatnio} ({n} wywołań).",
  "dashboard.vendingPlusNieuzywany": "Wydany {kiedy}, ale ANI RAZU nie użyty — sekret nie dojechał do drugiej strony albo ich integracja nie wystartowała.",
  "dashboard.vendingPlusWaski": "wydany, węższy zakres",
  "dashboard.vendingPlusWaskiHint": "Zakres jest WĘŻSZY niż pełna integracja — część tras odpowie 403. Popraw zakres w Tokenach panelu.",
  "dashboard.vendingPlusWydany": "wydany",
  "dashboard.version": "Wersja",
  "emp.active": "Konto aktywne",
  "emp.activity": "Aktywność",
  "emp.add": "Dodaj pracownika",
  "emp.addTitle": "Nowy pracownik",
  "emp.alias": "Numer dodatkowy (alias)",
  "emp.allCostCenters": "wszystkie centra",
  "emp.allGroups": "wszystkie grupy",
  "emp.byGroup": "Pracownicy wg grupy",
  "emp.byGroupEmpty": "Żadna grupa na tej wyspie nie ma jeszcze członków.",
  "emp.byGroupFilter": "Kliknij, żeby zawęzić listę do tej grupy.",
  "emp.cardChangeAction": "Zmień numer",
  "emp.cardChangeHistory": "Zmień numer także w historii wydań",
  "emp.cardChangeHistoryHint": "SPS tego NIE robi — po jego stronie pobrania zostają przy starym numerze i odczepiają się od człowieka. Zaznaczenie przepisze je na nowy numer, dzięki czemu raporty pójdą za osobą. Kosztem jest rozjazd z kopiami bazy zrobionymi wcześniej po stronie klienta.",
  "emp.cardChangeIntro": "Numer karty jest w SPS kluczem, po którym poznaje pracownika siedem tabel naraz. Zmiana przenosi go razem z członkostwem w grupach, dostępem do automatów, dozwolonymi operacjami, centrum kosztowym oraz limitem i dostępem do towaru celującym w tę osobę. Reszta wiersza — z PIN-em włącznie — zostaje nietknięta.",
  "emp.cardChangeNew": "Nowy numer karty",
  "emp.cardChangeRemovedHolder": "Numer ma „{name}” (usunięta z automatów) — zwolni go „Usuń trwale z Vendi”.",
  "emp.cardChangeSame": "To jest obecny numer tej osoby.",
  "emp.cardChangeTitle": "Zmiana numeru karty",
  "emp.cardChangeWarn": "Operacja idzie do automatu przy najbliższym cyklu agenta jako jedna paczka i wykonuje się w całości albo wcale. Do czasu potwierdzenia portal pokazuje już nowy numer, a automat jeszcze stary.",
  "emp.cardChanged": "Zmiana numeru {stary} → {nowy} zakolejkowana ({n} wydań w historii)",
  "emp.cardNumber": "Numer karty",
  "emp.cardPending": "Karta jest wolna w portalu, ale czeka na nią operacja w kolejce zmian.",
  "emp.cardTaken": "Ta karta jest już przypisana do „{name}\". SPS nie rozróżnia wielkości liter.",
  "emp.columnsNotice": "Zmiana trafia do kolejki i jedzie do automatu przy najbliższym cyklu agenta. Do czasu potwierdzenia wiersz jest oznaczony jako oczekujący.",
  "emp.costCenter": "Centrum kosztowe",
  "emp.costCenterFromDict": "ze słownika centrów",
  "emp.costCenterInUse": "używane u {n} os.",
  "emp.costCenterNone": "bez centrum kosztowego",
  "emp.costCenterUnknown": "poza słownikiem (kod z danych klienta)",
  "emp.created": "Pracownik utworzony",
  "emp.dateRangeEnable": "Ogranicz ważność konta zakresem dat",
  "emp.dateRangeEnd": "Ważne do",
  "emp.dateRangeHint": "Data kalendarzowa z automatu, bez strefy czasowej. Pusta granica znaczy „bez ograniczenia z tej strony”.",
  "emp.dateRangeOrder": "Data „ważne od” jest późniejsza niż „ważne do” — w takim zakresie nie ma ani jednego dnia.",
  "emp.dateRangeStart": "Ważne od",
  "emp.detailError": "Nie udało się wczytać ustawień pracownika. Formularz zostaje zamknięty, bo zapis bez nich wyzerowałby to, czego nie pokazał.",
  "emp.detailLoading": "Wczytuję ustawienia pracownika…",
  "emp.editTitle": "Edycja pracownika",
  "emp.employee": "Pracownik",
  "emp.bezNazwy": "(bez nazwy)",
  "emp.flag.allowDisabledItems": "Może pobierać pozycje wyłączone",
  "emp.flag.canAccessExternalStock": "Dostęp do magazynu zewnętrznego",
  "emp.flag.canSizeGrid": "Może zmieniać rozmiar siatki na ekranie automatu",
  "emp.flag.demoModeOnly": "Tylko tryb demonstracyjny (bez realnego wydania)",
  "emp.flag.dispenseUsedFirst": "Wydawaj najpierw sztuki używane",
  "emp.flag.forceCountersign": "Wymagaj potwierdzenia drugiej osoby",
  "emp.flag.ignoreStrictReturnRule": "Pomiń rygorystyczną regułę zwrotu",
  "emp.flag.ignoreSwap": "Pomiń regułę wymiany „oddaj stare, weź nowe”",
  "emp.flag.isHhAdmin": "Administrator terminala ręcznego (HH)",
  "emp.flag.kitChangeIssue": "Może zmieniać skład zestawu przy wydaniu",
  "emp.flag.kitExceed": "Może pobrać zestaw ponad przewidzianą ilość",
  "emp.flag.kitIgnoreShortage": "Wydaj zestaw mimo braku części pozycji",
  "emp.flag.offerConUncon": "Proponuj pozycje zwrotne i bezzwrotne",
  "emp.flag.returnToMenu": "Wyloguj po operacji",
  "emp.flag.singleCompRestrict": "Ograniczenie do pojedynczej przegrody",
  "emp.flag.skipFpCheck": "Pomiń weryfikację odcisku palca",
  "emp.group": "Grupa pracownicza",
  "emp.groups": "Grupy",
  "emp.groupsNone": "Na tej wyspie nie ma jeszcze żadnej grupy pracowniczej.",
  "emp.grupySzukaj": "Szukaj grupy…",
  "emp.grupyBrakTrafien": "Żadna grupa nie pasuje do szukanej frazy",
  "emp.inactive": "nieaktywny",
  "emp.kpi.active": "Aktywni",
  "emp.kpi.activeRecently": "Aktywni ostatnio ({d} dni)",
  "emp.kpi.all": "Wszyscy",
  "emp.kpi.blocked": "Zablokowani",
  "emp.kpi.inGroups": "W grupach",
  "emp.kpi.withLimits": "Z limitami",
  "emp.limitsShort": "Lim.",
  "emp.machine": "Automat",
  "emp.machines": "Automaty",
  "emp.machinesAll": "Zaznacz wszystkie",
  "emp.machinesClear": "Odznacz wszystkie",
  "emp.machinesEmpty": "Na tej wyspie nie ma jeszcze automatów.",
  "emp.machinesShort": "Aut.",
  "emp.machinesViaGroup": "z grupy",
  "emp.machinesViaGroupHint": "Ten automat jest dostępny również przez grupę pracownika — odznaczenie go tutaj nie odbierze dostępu.",
  "emp.machinesZGrup": "+{n} z grupy",
  "emp.machinesZGrupHint": "Automaty dostępne przez grupy pracownika, poza przypisanymi wprost",
  "emp.multiHint": "Ta osoba pobiera na więcej niż jednym automacie — limit liczony osobno na każdym automacie wyszedłby dla niej za niski.",
  "emp.name": "Imię i nazwisko",
  "emp.noGroup": "bez grupy",
  "emp.onlyMulti": "Tylko pobierający na >1 automacie",
  "emp.pendingHint": "Jest niezastosowana zmiana konfiguracji dla tego pracownika.",
  "emp.pinChange": "Zmień PIN",
  "emp.pinClearWarn": "Puste pole przy włączonym przełączniku WYCZYŚCI PIN pracownika.",
  "emp.pinLabel": "Nowy PIN",
  "emp.rationEffect": "Egzekwowanie limitów",
  "emp.rationEffect1": "1 — nie pilnuj limitów w ogóle",
  "emp.rationEffect2": "2 — nie pilnuj, ale zapisuj wydania",
  "emp.rationEffect3": "3 — pilnuj limitów",
  "emp.rationOff": "Automat NIE pilnuje limitów tej osoby",
  "emp.saved": "Zmiana zakolejkowana",
  "emp.section.basic": "Dane podstawowe",
  "emp.section.groups": "Grupy pracownicze",
  "emp.section.machines": "Automaty",
  "emp.section.more": "Więcej ustawień",
  "emp.section.pin": "PIN przy automacie",
  "emp.selected": "zaznaczonych: {n} z {total}",
  "emp.state": "Stan konta",
  "emp.stateActive": "Aktywni",
  "emp.stateAll": "Wszyscy",
  "emp.stateInactive": "Tylko nieaktywni",
  "emp.status": "Status",
  "emp.statusActive": "aktywny",
  "emp.statusBlocked": "zablokowany",
  "emp.statusBlockedHint": "Users.ALLOWLOGIN = 0 — konto nie wpuszcza do automatu.",
  "grp.add": "Dodaj grupę",
  "grp.addTitle": "Nowa grupa pracownicza",
  "grp.assignAction": "Dodaj do grupy ({n})",
  "grp.assignTo": "Grupa docelowa",
  "grp.assignToPick": "wybierz grupę…",
  "grp.available": "Poza grupą",
  "grp.candidatesCapped": "Pokazuję maksymalnie 50 osób — zawęź szukaniem.",
  "grp.code": "Kod grupy",
  "grp.codeChangeAction": "Zmień kod grupy",
  "grp.usun.akcja": "Usuń grupę",
  "grp.usun.tytul": "Usunąć grupę?",
  "grp.usun.przycisk": "Usuń grupę",
  "grp.usun.zlecone": "Zlecono usunięcie grupy",
  "grp.usun.blokady": "Nie można usunąć — grupę wskazują:",
  "grp.usun.blokSzuflada": "szuflada (właściciel): {automat}, bęben {beben}, szuflada {szuflada}",
  "grp.usun.blokKlapa": "klapa (właściciel): {automat}, szuflada {szuflada}, klapa {klapa}",
  "grp.usun.blokPozycja": "pozycja automatu: {automat}, towar {towar} ({role})",
  "grp.usun.blokRaport": "harmonogram raportu: {nazwa}",
  "grp.usun.blokKolejka": "niedokończone zmiany tej grupy w kolejce",
  "grp.usun.zniknie": "Razem z grupą zniknie:",
  "grp.usun.czlonkostwa": "członkostw osób",
  "grp.usun.bezInnejGrupy": "{n} bez innej grupy",
  "grp.usun.pokazOsoby": "pokaż osoby",
  "grp.usun.automaty": "automatów grupy (dostęp)",
  "grp.usun.tracaDostep": "{n} osób straci dostęp do automatu",
  "grp.usun.bezAutomatu": "{n} bez żadnego automatu",
  "grp.usun.operacje": "dozwolonych operacji",
  "grp.usun.limity": "limitów",
  "grp.usun.uprawnienia": "uprawnień do towarów",
  "grp.usun.historia": "Historia wydań zostaje bez zmian.",
  "grp.usun.hrPlus": "HR+ prowadzi {n} członków tej grupy — zdejmij ją też w HR+, inaczej HR+ będzie wskazywać grupę, której nie ma.",
  "grp.usun.hrPlusWyjatek": "Grupa zniknie z wyjątków HR+.",
  "grp.usun.potwierdz": "Wpisz kod grupy „{kod}\", żeby potwierdzić",
  "grp.codeChangeIntro": "Kod grupy jest w SPS kluczem, po którym poznaje ją sześć tabel naraz. Zmiana przenosi go razem ze składem grupy, dostępem do automatów, dozwolonymi operacjami oraz limitem i dostępem do towaru celującym w tę grupę. Reszta wiersza zostaje nietknięta.",
  "grp.codeChangeNew": "Nowy kod grupy",
  "grp.codeChangeTitle": "Zmiana kodu grupy",
  "grp.codeChangeWarn": "Historia wydań ZOSTAJE przy starym kodzie — SPS też jej nie przepisuje, a raport za zamknięty okres ma pokazywać kod, który wtedy obowiązywał. Operacja idzie do automatu przy najbliższym cyklu agenta i wykonuje się w całości albo wcale.",
  "grp.codeChanged": "Zmiana kodu grupy {stary} → {nowy} zakolejkowana",
  "grp.codePending": "Kod jest wolny w portalu, ale czeka na niego operacja w kolejce zmian.",
  "grp.codeTaken": "Ten kod jest już zajęty przez „{name}\". SPS nie rozróżnia wielkości liter.",
  "grp.created": "Grupa utworzona",
  "grp.editTitle": "Zmiana nazwy grupy",
  "grp.inGroup": "W grupie",
  "grp.limits": "Ograniczenia",
  "grp.limitsHint": "Tyle reguł limitów celuje w tę grupę.",
  "grp.limitsWarn": "W tę grupę celuje {n} reguł limitów. Zmiana składu natychmiast przesuwa, kogo te limity obejmują — a limity liczą się na sumie wydań z całej floty, nie per automat.",
  "grp.machines": "Automaty",
  "grp.machinesAll": "Zaznacz wszystkie",
  "grp.machinesAlsoIn": "To samo powiązanie edytuje się na Przypisaniach od strony automatu.",
  "grp.machinesClear": "Odznacz wszystkie",
  "grp.machinesHeads": "osób w grupie: {n}",
  "grp.machinesNone": "Ta wyspa nie ma jeszcze żadnego automatu.",
  "grp.machinesSaved": "Zmiana dostępu do automatów zakolejkowana",
  "grp.machinesSelected": "zaznaczonych: {n} z {total}",
  "grp.machinesTitle": "Dostęp do automatów",
  "grp.members": "Członkowie",
  "grp.membersSaved": "Zmiana składu zakolejkowana",
  "grp.membersTitle": "Skład grupy",
  "grp.name": "Nazwa grupy",
  "grp.noCandidates": "Brak pracowników spełniających kryteria.",
  "grp.noMembers": "Grupa jest pusta.",
  "grp.pendingHint": "Jest niezastosowana zmiana konfiguracji dla tej grupy lub jej składu.",
  "grp.saved": "Zmiana zakolejkowana",
  "grp.withoutGroupBanner": "{n} aktywnych pracowników nie należy do żadnej grupy. Reguły limitów celują między innymi w grupy, więc tych osób nie obejmuje żadna reguła grupowa.",
  "grp.withoutGroupCount": "osób bez grupy: {n}",
  "grp.withoutGroupDesc": "Aktywni pracownicy tej wyspy, którzy nie należą do żadnej grupy. Zaznacz i przypisz do grupy — zaznaczenie przeżywa zmianę strony.",
  "grp.withoutGroupEmpty": "Każdy aktywny pracownik należy do co najmniej jednej grupy.",
  "grp.withoutGroupShow": "Pokaż listę",
  "grp.withoutGroupTitle": "Pracownicy bez grupy",
  "harm.aktywny": "Włączony",
  "harm.bezWysylki": "Wysyłka mailem jeszcze nie działa — czekamy na obsługę załączników w serwisie powiadomień. Do tego czasu przebieg SKŁADA plik i zapisuje ślad (okres, liczbę wierszy, rozmiar), żeby było widać, że powstaje poprawnie i o właściwej porze.",
  "harm.brakOdbiorcow": "bez odbiorców — sam plik i ślad w historii",
  "harm.czestotliwosc.DZIENNIE": "codziennie o {godzina}",
  "harm.czestotliwosc.MIESIECZNIE": "co miesiąc, {dzienMiesiaca}. dnia o {godzina}",
  "harm.czestotliwosc.TYGODNIOWO": "co tydzień, {dzien} o {godzina}",
  "harm.czestotliwoscNazwa.DZIENNIE": "codziennie",
  "harm.czestotliwoscNazwa.MIESIECZNIE": "co miesiąc",
  "harm.czestotliwoscNazwa.TYGODNIOWO": "co tydzień",
  "harm.dniaMiesiaca": "{n}. dnia",
  "harm.dodaj": "Nowy harmonogram",
  "harm.dzien.1": "w poniedziałek",
  "harm.dzien.2": "we wtorek",
  "harm.dzien.3": "w środę",
  "harm.dzien.4": "w czwartek",
  "harm.dzien.5": "w piątek",
  "harm.dzien.6": "w sobotę",
  "harm.dzien.7": "w niedzielę",
  "harm.edytorOpis": "Zapisujesz raz — dalej wykonuje się bez Ciebie.",
  "harm.edytuj": "Zmiana harmonogramu",
  "harm.format": "Format pliku",
  "harm.godzinaHint": "Godzina liczona w strefie wyspy, nie Twojej przeglądarki — raport o 6:00 przyjdzie o szóstej u klienta, także po zmianie czasu.",
  "harm.historia": "Historia przebiegów",
  "harm.jeszczeNieChodzil": "Jeszcze ani razu nie chodził.",
  "harm.kiedy": "Kiedy",
  "harm.kolumny": "Kolumny w pliku",
  "harm.kolumnyHint": "Wybór i kolejność zapisują się RAZEM Z HARMONOGRAMEM, nie w tej przeglądarce — ten sam układ pojedzie w każdej wysyłce.",
  "harm.naglowkiTxt": "Nagłówki kolumn w pliku .txt",
  "harm.naglowkiTxtHint": "Dotyczy tego jednego harmonogramu. Wyłącz, gdy plik zaciąga program, który wiersza z nazwami kolumn nie oczekuje.",
  "harm.naglowkiTxtNie": "Bez nagłówków",
  "harm.naglowkiTxtTak": "Z nagłówkami",
  "harm.nastepny": "następny:",
  "harm.nazwa": "Nazwa",
  "harm.nazwaHint": "np. Tygodniówka dla brygadzisty",
  "harm.oGodzinie": "o godzinie",
  "harm.odbiorcy": "Odbiorcy",
  "harm.odbiorcyHint": "Adresy po przecinku. Można zostawić puste — wtedy przebieg tylko składa plik i zapisuje ślad.",
  "harm.okres.biezacyMiesiac": "bieżący miesiąc",
  "harm.okres.ostatnie30dni": "ostatnie 30 dni",
  "harm.okres.ostatnie7dni": "ostatnie 7 dni",
  "harm.okres.poprzedniMiesiac": "poprzedni miesiąc",
  "harm.okres.poprzedniTydzien": "poprzedni tydzień (pn–nd)",
  "harm.okres.wczoraj": "wczoraj",
  "harm.okresHint": "Liczony przy każdym uruchomieniu, w czasie automatów. Dlatego nie ma tu pola „od–do”: zapisana data znaczyłaby, że co tydzień przychodzi ten sam tydzień.",
  "harm.okresPole": "Okres",
  "harm.ostatniBlad": "błąd",
  "harm.ostatniOk": "OK",
  "harm.podtytul": "Raport powstaje na serwerze i wychodzi bez klikania. Okres liczy się przy każdym uruchomieniu, więc tygodniówka zawsze opisuje ostatni tydzień.",
  "harm.pusto": "Nie ma jeszcze żadnego harmonogramu.",
  "harm.raport": "Raport",
  "harm.raport.stanAutomatow": "Stan automatów",
  "harm.raport.transactions": "Wydania",
  "harm.tytul": "Harmonogramy wysyłki",
  "harm.uruchom": "Uruchom",
  "harm.uruchomHint": "Składa plik teraz. NIE przesuwa zaplanowanej pory — sprawdzenie nie może opóźnić wysyłki.",
  "harm.uruchomionoBlad": "Przebieg nieudany",
  "harm.uruchomionoOk": "Przebieg zakończony — {n} wierszy",
  "harm.usunPytanie": "Definicja i cała historia przebiegów znikną. Sam raport zostaje — nadal pobierzesz go z ekranu.",
  "harm.usunTytul": "Usunąć harmonogram?",
  "harm.usunieto": "Harmonogram usunięty.",
  "harm.wierszy": "wierszy: {n}",
  "harm.wrocDoRaportow": "Wróć do raportów",
  "harm.wylaczony": "wyłączony",
  "harm.zaDuzy": "za duży na maila",
  "harm.zaDuzyHint": "Plik przekracza 20 MB, czyli granicę, którą standardowo przyjmuje skrzynka odbiorcy. Zawęź okres albo wybierz mniej kolumn.",
  "hist.bezKonta": "bez powiązanego konta",
  "hist.bezWartosci": "limit zdjęty",
  "hist.dojechalo": "maszyny potwierdziły",
  "hist.dymek": "Portal zmieniał ten limit {n} razy — pokaż, co było ustawione",
  "hist.pusto": "Portal nie zmieniał tego limitu.",
  "hist.rodzaj.INNE": "inna zmiana",
  "hist.rodzaj.USTAWIONY": "ustawiony",
  "hist.rodzaj.ZDJETY": "zdjęty",
  "hist.rodzaj.ZMIENIONY": "zmieniony",
  "hist.tytul": "Zmiany limitu zrobione w portalu",
  "hist.wDrodze": "jeszcze nie u maszyn ({stan})",
  "hist.zakresWiedzy": "Widać tylko zmiany złożone w portalu i najwyżej 30 ostatnich. Zmian zrobionych przy maszynie w SPSUtilities portal nie widzi.",
  "histKarty.bezKonta": "bez konta",
  "histKarty.dojechalo": "dojechało do maszyn",
  "histKarty.pokaz": "Historia numeru",
  "histKarty.pusto": "Portal nie zmieniał numeru karty tego pracownika.",
  "histKarty.tytul": "Zmiany numeru karty w portalu",
  "histKarty.wDrodze": "w drodze do maszyn ({stan}) — automat zna jeszcze stary numer",
  "histKarty.zakresWiedzy": "Widać tu wyłącznie zmiany zrobione przez portal. Numeru zmienionego przy maszynie (SPSUtilities) nie ma jak pokazać — portal takiej zmiany nie składał.",
  "ig.codeChangeAction": "Zmień kod grupy",
  "ig.codeChangeIntro": "Kod grupy jest w SPS kluczem, po którym poznaje ją siedem tabel naraz. Zmiana przenosi go razem z przypisaniem towarów, podgrupami, limitami i dostępem. Podgrupy mają klucz złożony z kodu grupy i własnego kodu, więc każda dostaje osobne przeniesienie — podgrupa z niespójnym kluczem zatrzymuje całą operację, zamiast zostać osierocona.",
  "ig.codeChangeNew": "Nowy kod grupy",
  "ig.codeChangeTitle": "Zmiana kodu grupy towarowej",
  "ig.codeChangeWarn": "Kod grupy mieści w SPS tylko 16 znaków — mniej niż numer towaru. Operacja idzie do automatu przy najbliższym cyklu agenta i wykonuje się w całości albo wcale; jeśli w kaskadzie zostałby choć jeden wiersz przy starym kodzie, agent odrzuca ją w całości.",
  "ig.codeChanged": "Zmiana kodu grupy {stary} → {nowy} zakolejkowana",
  "igrp.add": "Dodaj grupę",
  "igrp.addSub": "Dodaj podgrupę",
  "igrp.addSubTitle": "Nowa podgrupa",
  "igrp.addTitle": "Nowa grupa artykułów",
  "igrp.brakObrazkow": "Grupy z obrazkiem, którego portal nie ma: {n}",
  "igrp.code": "Kod grupy",
  "igrp.codeFree": "Kod wolny",
  "igrp.codeHint": "Kod nadaje człowiek — w SPS to tekst, np. BHP. Najwyżej 16 znaków, bez podkreślenia.",
  "igrp.codeImmutable": "Kodu nie da się tu zmienić i nie jest to przeoczenie. Towary wskazują grupę tekstową wartością kodu, a SPS nie ma kluczy obcych — zmiana kodu to przepisanie go w Items (dwie kolumny), w podgrupach (kod i klucz złożony) oraz w regułach limitów. To osobna operacja z własnym ryzykiem, nie zmiana pola.",
  "igrp.codePending": "Na ten klucz czeka operacja w kolejce zmian.",
  "igrp.codeReused": "Ten kod był już na tej wyspie usuwany. Kaskada usunięcia obejmuje wpisy dostępu (Restrictions2), ale tylko te znane read-modelowi portalu i dopiero po ZASTOSOWANIU operacji na bazie klienta. Jeśli tamta operacja jeszcze nie doszła albo synchronizacja nie przeniosła wszystkich wpisów, osierocone wpisy ze starym kodem przykleją się do tej grupy. Nie czytamy flag REST_ENABLED/REST_DENY, więc nie wiadomo, czy taki wpis zezwala, czy ZAKAZUJE — warto sprawdzić dostępy po zastosowaniu.",
  "igrp.codeTaken": "Kod {code} należy już do „{name}\". SPS nie rozróżnia wielkości liter.",
  "igrp.collapse": "Zwiń podgrupy",
  "igrp.created": "Grupa dodana do kolejki zmian",
  "igrp.delAssumedKeyAck": "Rozumiem, że klucz tabeli wpisów dostępu (Restrictions2) jest w naszym mapowaniu ZAŁOŻONY, nie potwierdzony żadnym wykonanym zapisem — jeśli jest inny, usunięcie nie dopasuje się do wiersza w bazie klienta. Rozumiem też, że kaskada usuwa tylko wpisy znane read-modelowi portalu; jeśli synchronizacja nie przeniosła wszystkich, resztę trzeba sprzątnąć osobno.",
  "igrp.delItemsDetached": "towarów zostanie ODPIĘTYCH od grupy (same towary zostają w katalogu — nie są usuwane)",
  "igrp.delItemsToParent": "towarów wróci do grupy {code} (podgrupa znika, kod grupy głównej zostaje przy towarze)",
  "igrp.delPendingWarn": "Dla tego klucza już czeka operacja w kolejce zmian. Usunięcie wejdzie do kolejki PO niej, więc sprawdź, czy nie znoszą się wzajemnie.",
  "igrp.delRationing": "reguł limitu celujących w tę grupę zostanie usuniętych — limit przestanie obowiązywać",
  "igrp.delRestrictions": "wpisów dostępu do towarów zostanie usuniętych (razem z wpisami podgrup) — portal nie wie, czy zezwalały, czy ZAKAZYWAŁY",
  "igrp.delSubGroups": "podgrup zostanie usuniętych:",
  "igrp.deleteConfirm": "Usuń",
  "igrp.deleteSubTitle": "Usuń podgrupę",
  "igrp.deleteTitle": "Usuń grupę",
  "igrp.deleted": "Usunięcie dodane do kolejki zmian",
  "igrp.doArtykulow": "Pokaż artykuły tej grupy",
  "igrp.empty": "Brak grup artykułów dla tych filtrów.",
  "igrp.emptyGroup": "W tej grupie ani w jej podgrupach nie ma żadnego towaru.",
  "igrp.emptyHint": "Grupa, w której razem z podgrupami nie ma ani jednego towaru.",
  "igrp.expand": "Rozwiń podgrupy",
  "igrp.exp.groupName": "Nazwa grupy",
  "igrp.exp.isgid": "Klucz podgrupy (ISGID)",
  "igrp.exp.items": "Towary",
  "igrp.exp.itemsSubtree": "Towary z podgrupami",
  "igrp.exp.machines": "Automaty",
  "igrp.exp.rationing": "Limity",
  "igrp.exp.subName": "Nazwa podgrupy",
  "igrp.group": "Grupa",
  "igrp.inGroup": "W grupie",
  "igrp.isgidPreview": "Do SPS pojedzie złożony klucz:",
  "igrp.isgidTaken": "Złożony klucz jest już zajęty przez „{name}\" — dla SPS to ten sam wiersz.",
  "igrp.isgidWhy": "Kluczem podgrupy jest ta zlepiona wartość (ISGID), a nie sam kod — goły kod podgrupy nie musi być unikalny, więc to ona trafia do towarów.",
  "igrp.itemsDirect": "towary",
  "igrp.obrazek": "Obrazek grupy",
  "igrp.kafelki.brak": "Portal nie zna tego ustawienia na tej wyspie.",
  "igrp.kafelki.czesc": "włączony: {n} z {m}",
  "igrp.kafelki.nigdzie": "wyłączony na wszystkich ({m})",
  "igrp.kafelki.wszedzie": "włączony na wszystkich ({m})",
  "igrp.kafelki.zmien": "Zmień",
  "igrp.kafelki.restart": "Ustawienie działa po restarcie SPSUI, nowe obrazki grup — po przelogowaniu.",
  "igrp.kafelki.starsze": "Zapis wymaga agenta {wersja}: {wezly}",
  "igrp.kafelki.tytul": "Wybór po obrazkach",
  "igrp.kafelki.wKolejce": "w kolejce",
  "igrp.kafelki.zapisano": "Zmiana w kolejce (automatów: {n})",
  "igrp.itemsSubtree": "z podgrupami",
  "igrp.kpi.emptyGroups": "Grupy bez towarów",
  "igrp.kpi.groups": "Grupy główne",
  "igrp.kpi.itemsInSubGroups": "Towary w podgrupach",
  "igrp.kpi.itemsWithoutGroup": "Towary bez grupy",
  "igrp.kpi.rationing": "Ograniczenia na grupach",
  "igrp.kpi.subGroups": "Podgrupy",
  "igrp.machines": "automaty",
  "igrp.name": "Nazwa",
  "igrp.nameHint": "Najwyżej 32 znaki. Uwaga: nazwa TOWARU ma 255, ale nazwa grupy w SPS (DESCR) tylko 32 — dłuższą SPS obciąłby bez ostrzeżenia.",
  "igrp.noGroupHint": "W SPS obie kolumny grupy mogą być puste, więc towar bez grupy to stan legalny — nie błąd.",
  "igrp.noIsgid": "brak klucza złożonego",
  "igrp.noIsgidHint": "Ta podgrupa nie ma zapisanego klucza ISGID, więc nie ma czym zaadresować jej wiersza w SPS — zmiana nazwy się nie uda. To dane do naprawy po stronie synchronizacji.",
  "igrp.orphanHint": "{n} reguł limitu celuje w kod, którego nie ma żadna grupa główna na tej wyspie.",
  "igrp.orphanNotice": "Uwaga: {n} reguł limitu celuje w kod grupy, której na tej wyspie nie ma. SPS nie ma kluczy obcych, więc taki wiersz jest tam legalny i nic go nie zgłasza — a limit nie obejmuje niczego. Do sprawdzenia, czy grupa została usunięta poza portalem.",
  "igrp.pending": "zmiana w toku",
  "igrp.pokr.brakNa": "brak: {n}",
  "igrp.pokr.braki": "brakuje u {n} grup",
  "igrp.pokr.czesciowo": "sprawdzono tylko część automatów",
  "igrp.pokr.innyNa": "inny: {n}",
  "igrp.pokr.nieSprawdzano": "nie sprawdzano",
  "igrp.pokr.rozjazd": "inny plik u {n} grup",
  "igrp.pokr.sprawdzono": "sprawdzono {kiedy}",
  "igrp.pokr.tytul": "Obrazki grup na automatach",
  "igrp.pendingHint": "Dla tego klucza czeka operacja w kolejce zmian.",
  "igrp.rationing": "limity",
  "igrp.rationingHint": "Reguły limitów celujące w kod grupy głównej (Rationing.ITEMTYPE=8).",
  "igrp.renameTitle": "Zmień nazwę",
  "igrp.renamed": "Zmiana nazwy dodana do kolejki",
  "igrp.searchPlaceholder": "Szukaj po kodzie albo nazwie…",
  "igrp.showEmpty": "Pokaż grupy bez towarów",
  "igrp.subCode": "Kod podgrupy",
  "igrp.subCodeHint": "Najwyżej 16 znaków. Podkreślenie tu wolno — klucz podgrupy rozbiera się po pierwszym, a ono należy do grupy nadrzędnej.",
  "igrp.subCreated": "Podgrupa dodana do kolejki zmian",
  "igrp.subGroup": "Podgrupa",
  "emp.importuj": "Importuj",
  "emp.usunKarty": "Usuń karty",
  "emp.usunieta": "Usunięta z automatów",
  "emp.usunietaHint": "Tylko w Vendi — usunięta z automatów {kiedy} (z portalu)",
  "emp.usunietaHintWezel": "Tylko w Vendi — usunięta z automatów {kiedy} (na {wezel})",
  "emp.filtrUsunieci": "Usunięci z automatów",
  "emp.usunZAutomatow": "Usuń z automatów",
  "emp.usunTrwale": "Usuń trwale z Vendi",
  "emp.hr.HR_PLUS": "HR+",
  "emp.hr.HR_PLUS_ZABLOKOWANA": "HR+ · zablokowana",
  "emp.hr.SPOZA_HR": "Spoza HR+",
  "emp.hr.numer": "Numer w HR+: {n}",
  "emp.hr.filtr": "HR+",
  "emp.hr.filtrZ": "Z HR+",
  "emp.hr.filtrSpoza": "Spoza HR+",
  "emp.hrPlusBaner": "Pracowników tej wyspy prowadzi HR+ — dodawanie jest wyłączone, a ręczne zmiany nazwy, MPK i blokady zostaną nadpisane danymi z HR+.",
  "emp.hrPlusZablokowane": "Ludzi dodaje HR+",
  "emp.hrPlusEdycja": "Wyspę prowadzi HR+ — nazwa, MPK i blokada zostaną nadpisane danymi z HR+.",
  "karty.tytul": "Usuwanie kart z automatów",
  "karty.opis": "Jedna karta w wierszu. Najpierw blokada, potem usunięcie; osoba zostaje w Vendi z historią wydań.",
  "karty.lista": "Numery kart",
  "karty.placeholder": "0001\n0002",
  "karty.ile": "Kart: {n}",
  "karty.zaDuzo": "Najwyżej {n} kart naraz",
  "karty.doUsuniecia": "Do usunięcia: {n}",
  "karty.juzUsuniete": "Już usunięte: {n}",
  "karty.nieznane": "Nieznane: {n}",
  "karty.powtorzenia": "Powtórzenia: {n}",
  "karty.zniknie": "Zniknie z automatów",
  "karty.przypisan": "automaty {n}",
  "karty.grup": "grupy {n}",
  "karty.mpk": "MPK {n}",
  "karty.operacji": "operacje {n}",
  "karty.limitow": "limity {n}",
  "karty.dostepow": "dostęp {n}",
  "karty.dostawcow": "dostawcy {n}",
  "karty.bazy": "Bazy: {lista}",
  "karty.operacjiWCzesciach": "Operacji: {n} (po 50 kart)",
  "karty.starsze": "Wymaga agenta {wersja} na każdej bazie. Starszego mają: {lista}",
  "karty.kolKarta": "Karta",
  "karty.kolOsoba": "Osoba",
  "karty.kolStan": "Stan",
  "karty.kolAutomaty": "Automaty",
  "karty.kolWydania": "Wydania",
  "karty.stan.DO_USUNIECIA": "do usunięcia",
  "karty.stan.JUZ_USUNIETA": "już usunięta",
  "karty.stan.NIEZNANA": "nieznana",
  "karty.iWiecej": "…i {n} więcej",
  "karty.trwale": "Usuń też z Vendi (trwale)",
  "karty.odpiecie": "Rozumiem: {n} wydań zostanie bez powiązania z osobą (z numerem i nazwą z chwili wydania), a Vending+ dostanie usunięcie osoby.",
  "karty.zmienListe": "Zmień listę",
  "karty.sprawdz": "Sprawdź",
  "karty.usun": "Usuń z automatów",
  "karty.usunTrwale": "Usuń trwale z Vendi",
  "karty.wynik": "Zakolejkowano — kart: {n}, operacji: {k}",
  "karty.wynikTrwale": "Trwale z Vendi: {n}",
  "karty.wynikBlokada": "Najpierw blokada: {n}",
  "karty.zakolejkowano": "Usunięcie kart zakolejkowane",
  "imp.grupy.brakNaWyspie": "Ta wyspa nie ma jeszcze żadnej grupy pracowniczej.",
  "imp.grupy.klik": "Kliknij, żeby zobaczyć grupy tej wyspy i wpisać właściwą",
  "imp.grupy.nicNiePasuje": "Nic nie pasuje",
  "imp.grupy.opis": "W tym wierszu stoi: {co}. Kliknij grupę, żeby wpisać ją w ten wiersz.",
  "imp.grupy.osob": "{ile} os.",
  "imp.grupy.szukaj": "nazwa albo kod grupy",
  "imp.grupy.tylkoPodglad": "Przy imporcie z arkusza grupa przychodzi z kolumny pliku — popraw ją w mapowaniu kolumn.",
  "imp.grupy.tytul": "Grupy pracownicze na tej wyspie",
  "imp.zajeta.aktywne": "aktywne",
  "imp.zajeta.bezNazwy": "(bez nazwy)",
  "imp.zajeta.klik": "Kliknij, żeby zobaczyć, kto używa tej karty",
  "imp.zajeta.konto": "Konto",
  "imp.zajeta.nadpisuj": "Nadpisuj istniejących pracowników",
  "imp.zajeta.nadpisujIle": "Dotyczy CAŁEGO wsadu: wierszy z zajętą kartą jest {ile}. Każdy z nich stanie się aktualizacją zamiast zakładania.",
  "imp.zajeta.nieWiemyKto": "Ten numer jest zajęty, ale nie wiemy przez kogo — listę kadry ciągniemy do 500 osób, a większą wyspę sprawdza dopiero instancja.",
  "imp.zajeta.opis": "Ten numer karty ma już swojego pracownika w tej wyspie.",
  "imp.zajeta.tytul": "Kto używa tej karty",
  "imp.zajeta.zablokowane": "zablokowane",
  "imp.bezZmianWiersz": "Wszystkie podane pola zgadzają się z bazą — zapis nie zmieniłby ani jednej kolumny.",
  "imp.bylo": "Tak jest teraz w bazie klienta",
  "imp.odznaczBezZmian": "Odznacz bez zmian ({ile})",
  "imp.puste": "(puste)",
  "imp.trybBezZmian": "bez zmian",
  "imp.noweCentrum": "Nowe centrum kosztowe — nikt na tej wyspie go jeszcze nie ma",
  "imp.nadpisuj": "Aktualizuj pracowników, którzy już są",
  "imp.nadpisujOpis": "Wiersz z istniejącym numerem karty nadpisze dane tej osoby zamiast zostać odrzucony. Puste pola zostają bez zmian.",
  "imp.grupyZastapuj": "Grupa z pliku zastępuje dotychczasowe",
  "imp.grupyZastapujOpis": "Stare członkostwa zostaną odebrane, zostanie tylko grupa z pliku.",
  "imp.grupyDodajOpis": "Grupa z pliku dołoży się do tych, które pracownik już ma.",
  "imp.rozbicie": "nowych: {nowych} · nadpisanych: {aktualizacji}",
  "imp.tryb": "Co się stanie",
  "imp.trybNowy": "nowy",
  "imp.trybAktualizacja": "nadpisanie",
  "imp.bezZmian": "bez zmian",
  "imp.bezZmianHint": "Pusto w pliku — zostaje to, co pracownik ma teraz",
  "imp.automatyTylkoNowym": "Dotyczy tylko nowych. {ile} nadpisywanym nie ruszamy dostępu do automatów — plik o nim nie mówi.",
  "imp.odWiersza": "Od wiersza",
  "imp.doWiersza": "Do wiersza",
  "imp.odsianeFormuly": "Pominięto {ile} wierszy, w których numer karty jest wynikiem formuły, nie numerem",
  "imp.odsianeBezKarty": "pominięto {ile} wierszy bez numeru karty",
  "imp.odznaczPowtorzone": "Odznacz powtórzone ({ile})",
  "imp.odznaczBledne": "Odznacz wiersze z błędem ({ile})",
  "imp.odznaczonych": "odznaczono: {ile}",
  "imp.przywrocWszystkie": "Przywróć wszystkie",
  "imp.wierszyZ": "wejdzie {ile} z {z}",
  "imp.wezWiersz": "Weź wiersz {nr}",
  "imp.wLewo": "Przesuń {pole} w lewo",
  "imp.wPrawo": "Przesuń {pole} w prawo",
  "imp.kolejnoscDomyslna": "Przywróć domyślną kolejność",
  "imp.usunZera": "Obetnij zera wiodące z numeru karty",
  "imp.usunZeraSaZera": "W tym wsadzie {ile} numerów zaczyna się od zera.",
  "imp.usunZeraObcieto": "Obcięto zera w {ile} numerach — w podglądzie oznaczone gwiazdką.",
  "imp.wPliku": "W pliku: {co}",
  "imp.tytul": "Import pracowników",
  "imp.zakladkaTekst": "Wklej listę",
  "imp.zakladkaPlik": "Plik Excel",
  "imp.pole.karta": "Numer karty",
  "imp.pole.nazwa": "Imię i nazwisko",
  "imp.pole.alias": "Alias",
  "imp.pole.centrum": "Centrum kosztowe",
  "imp.pole.grupa": "Grupa pracownicza",
  "imp.pole.logowanie": "Pozwól logować",
  "imp.pole.wyloguj": "Wyloguj po operacji",
  "imp.pole.przegroda": "Ograniczenie do pojedynczej przegrody",
  "imp.pole.polityka": "Polityka wydzielania",
  "imp.separator.tab": "Rozdzielone tabulatorem",
  "imp.separator.srednik": "Rozdzielone średnikiem",
  "imp.separator.przecinek": "Rozdzielone przecinkiem",
  "imp.wierszy": "wierszy: {ile}",
  "imp.wybierzPlik": "Wybierz plik",
  "imp.arkusz": "Arkusz",
  "imp.pierwszyNaglowek": "Pierwszy wiersz to nagłówki",
  "imp.przeciagnij": "Przeciągnij kolumnę na pole albo wybierz z listy.",
  "imp.kolumnaBezNazwy": "Kolumna {nr}",
  "imp.bezKolumny": "— brak —",
  "imp.domyslnie": "domyślnie",
  "imp.kartaLiczbowa": "Kolumna z numerem karty ma w tym pliku wartości LICZBOWE. Jeśli numery mają wiodące zera, w pliku ich już nie ma i nie da się ich odtworzyć — sprawdź podgląd przed importem.",
  "imp.bladPliku": "Nie udało się odczytać pliku.",
  "imp.podglad": "Podgląd",
  "imp.wiersz": "Wiersz",
  "imp.pokazanoCzesc": "Pokazuję pierwszych 200 z {ile}.",
  "imp.brakGrup": "Ta wyspa nie ma grup pracowniczych:",
  "imp.wWierszach": "wiersze",
  "imp.zaDuzy": "Najwyżej {max} pracowników w jednym imporcie — podziel wsad.",
  "imp.automaty": "Dostęp do automatów",
  "imp.automatowWybrano": "Zaznaczono {ile} z {z} — to {wierszy} przypisań w bazie klienta.",
  "imp.zaimportuj": "Zaimportuj ({ile})",
  "imp.zrobione": "Zakolejkowano import: {nowych} nowych, {aktualizacji} nadpisanych",
  "imp.blad.kartaPusta": "Brak numeru karty",
  "imp.blad.kartaDluga": "Numer karty ma najwyżej 32 znaki",
  "imp.blad.kartaZnaki": "W numerze karty tylko znaki ASCII — usuń:",
  "imp.blad.kartaZajeta": "Ten numer karty jest już używany na wyspie",
  "imp.blad.nazwaDluga": "Imię i nazwisko ma najwyżej 50 znaków",
  "imp.blad.aliasDlugi": "Alias ma najwyżej 50 znaków",
  "imp.blad.centrumDlugie": "Centrum kosztowe ma najwyżej 50 znaków",
  "imp.blad.grupaBrak": "Nie ma grupy pracowniczej:",
  "imp.blad.grupaWiele": "Ta nazwa pasuje do kilku grup:",
  "imp.blad.znacznik": "Oczekiwano 0 albo 1, jest:",
  "imp.blad.polityka": "Polityka wydzielania to 1, 2 albo 3, jest:",
  "overview.healthNoPk": "Baza bez kluczy głównych: {ile} tabel — pokaż naprawę",
  "agents.bezKlucza": "Baza bez kluczy głównych: {ile} tabel",
  "agents.bezKluczaSkutek": "Portal nie dostaje: {co}. Config-down odmówi też zapisu do tych tabel.",
  "agents.bezKluczaPokazNaprawe": "Pokaż, jak to naprawić",
  "agents.naprawaTytul": "Naprawa schematu bazy",
  "agents.naprawaTabel": "tabel bez klucza",
  "agents.naprawaOpis": "Te tabele istnieją, ale nie mają klucza głównego, więc agent nie umie zidentyfikować wiersza i pomija je w każdym cyklu. Portal nie dostaje z nich: {co}.",
  "agents.naprawaSkad": "SPS zakłada te klucze sam — brak oznacza, że zostały zdjęte w tej bazie. Kolumny poniżej są odczytane z działającej instalacji tej samej wersji SPS, nie wymyślone.",
  "agents.naprawaPolecenia": "Do uruchomienia na bazie tego węzła",
  "agents.naprawaOstrzezenie": "Portal tego nie wykonuje. Każda para to najpierw sprawdzenie powtórzeń klucza, potem założenie — jeśli pierwszy SELECT zwróci wiersze, nie zakładaj klucza, dopóki nie rozstrzygniesz, który wiersz jest prawdziwy.",
  "podm.beben": "bęben {pic} ({n})",
  "podm.blad": "Nie udało się wymienić indeksu",
  "podm.dalej": "Dalej",
  "podm.gdzieLezy": "Stary indeks leży w {n} przegródkach:",
  "podm.jednolitosc": "Zdjęta reguła jednolitej zawartości w kolumnach: {kolumny}.",
  "podm.limityPrzeniesione": "Przeniesiono {limitow} limit(ów) i {ograniczen} ograniczeń dostępu.",
  "podm.limityZostaja": "Na starym indeksie zostaje {limitow} limit(ów) i {ograniczen} ograniczeń dostępu. Ta operacja ich nie rusza — nowy indeks nie ma żadnego.",
  "podm.maks": "Pojemność",
  "podm.nicNieZostalo": "Wszystkie bębny odznaczone — nie ma czego wymienić.",
  "podm.nieWiadomo": "Nie wiadomo, czy zlecenie przeszło — sprawdź w rejestrze zmian.",
  "podm.opis": "Stary towar znika z przegródek, nowy wchodzi w te same. Przegródki liczy portal.",
  "podm.potwierdz": "Do zlecenia: „{z}\" → „{na}\" w {n} przegr.",
  "podm.potwierdzPuste": "Do zlecenia: opróżnienie {n} przegr. po „{z}\".",
  "podm.przegrodek": "{n} przegr.",
  "podm.przeniesLimity": "Przenieś limity na nowy indeks",
  "podm.przeniesLimityOpis": "Osobna operacja: przepisuje limity i ograniczenia dostępu ze starego indeksu na nowy. Zasięg WYSPOWY — te tabele nie mają numeru automatu.",
  "podm.przycisk": "Wymień indeks",
  "podm.pusta": "przegródka pusta",
  "podm.stanPrzepadnie": "Przepadnie {n} szt. stanu — SPS podmienia towar przez usunięcie i wstawienie wiersza.",
  "podm.tytul": "Wymiana indeksu w planogramie",
  "podm.wTeSame": "w te same przegródki",
  "podm.wybierz": "— wybierz —",
  "podm.wyd": "Ilość wydawana",
  "podm.wykonaj": "Wymień",
  "podm.wykonajPuste": "Opróżnij",
  "podm.zIndeksu": "Wycofywany",
  "podm.zeStarego": "jak dotąd",
  "podm.zlecona": "Zlecono wymianę „{z}\" na „{na}\" w {n} przegr. — czeka w rejestrze zmian.",
  "podm.zleconaPuste": "Zlecono opróżnienie {n} przegr. po „{z}\" — czeka w rejestrze zmian.",
  "zdj.sciagnijZMaszyny": "pobierz z automatu",
  "podgladM.zapiszWBibliotece": "Zapisz w bibliotece portalu",
  "podgladM.nazwaWBibliotece": "Nazwa pliku w bibliotece",
  "podgladM.zapisz": "Zapisz",
  "podgladM.zapiszNadpisz": "Zapisz i nadpisz",
  "podgladM.nadpiszeBiblioteke": "Biblioteka już ma plik {plik} — zapis zamaże jego zawartość. To jedyna kopia poza automatami.",
  "podgladM.zapisanoOpis": "Zapisano w bibliotece jako {plik}. Na automaty NIC nie poszło — rozesłanie jest osobnym krokiem.",
  "napraw.tytul": "Pobierz z automatu i wyślij",
  "napraw.krok1": "Portal nie ma tego pliku. Wybierz automat, z którego go pobierzemy.",
  "napraw.krok2": "Plik z {maszyna}. Sprawdź, czy to właściwe zdjęcie, i zapisz je w portalu.",
  "napraw.innaMaszyna": "Inny automat",
  "napraw.wezZtej": "pobierz z tego",
  "napraw.brakZrodla": "Żaden sprawdzony automat nie ma tego pliku. Wgraj zdjęcie z komputera w oknie artykułu.",
  "napraw.wBibliotece": "Zapisano w portalu jako {plik}. Na automaty jeszcze nic nie poszło.",
  "napraw.rozeslijOstrzezenie": "Wysłanie przypisze {plik} temu artykułowi i wyśle je na wszystkie automaty ({n}) — także te, które mają pod tą nazwą inne zdjęcie. Tamtych wersji nie da się potem odzyskać.",
  "napraw.rozeslij": "Przypisz i wyślij na automaty",
  "napraw.rozeslano": "Wysyłamy {plik} na automaty: {n}",
  "napraw.mozeszWyjsc": "Możesz zamknąć okno — plik zostaje w portalu.",
  "islands.none": "Brak dostępnych wysp synchronizacji.",
  "kod.reguly": "Maks 32 znaki, bez polskich liter",
  "grp.opsLabel": "Dozwolone operacje systemowe",
  "grp.opsWybrane": "Zaznaczono {ile} z {z}",
  "grp.opsBrakSlownika": "Ta instalacja SPS nie przysłała jeszcze słownika operacji — uprawnienia nadasz po pierwszej synchronizacji.",
  "kod.zaDlugi": "Maks 32 znaki",
  "kod.zleZnaki": "Bez polskich liter i znaków specjalnych",
  "islands.single": "Ta instancja obsługuje jedną bazę master SPS — nie ma czego przełączać.",
  "islands.smartSync": "SMART SYNC",
  "islands.sync.dociaganie": "Dociąganie historii wydań na {n} węzłach — nowe wydania jadą normalnie.",
  "islands.sync.zaleglosc": "{n} węzłów nie nadąża z wydaniami rodzeństwa.",
  "islands.smartSyncHint": "Ta wyspa działa w modelu Smart Sync: master jest w naszym MSSQL-u, a maszyny są slave’ami z własnymi bazami lokalnymi. W modelu zwykłym master stoi na maszynie klienta.",
  "islands.switch": "Aktywna wyspa (klient / grupa)",
  "itm.absent": "nie ma go w bębnie",
  "itm.absentShort": "brak w bębnie",
  "itm.activity": "Aktywność",
  "itm.add": "Dodaj towar",
  "itm.addTitle": "Nowy towar",
  "itm.allGroups": "wszystkie grupy",
  "itm.anyAssignment": "dowolne przypisanie",
  "itm.anyFill": "dowolne zapełnienie",
  "itm.assignment": "Przypisanie",
  "itm.belowThreshold": "na wyczerpaniu",
  "itm.brand": "Marka",
  "itm.breakdownTitle": "Rozbicie na automaty",
  "itm.byGroup": "Towary według grup",
  "itm.created": "Towar dodany do kolejki zmian",
  "itm.editTitle": "Edycja towaru",
  "itm.empty": "Brak towarów dla tych filtrów.",
  "itm.fill": "Zapełnienie",
  "itm.fillEmpty": "pusto (0 sztuk)",
  "itm.fillLow": "poniżej progu SPS",
  "itm.fillOk": "powyżej progu",
  "itm.group": "Grupa artykułów",
  "itm.inDrumNoLimit": "bez wpisu limitu",
  "itm.inDrumNoLimitHint": "Towar leży w bębnie, ale nie ma wpisu w tabeli limitów automatu (VendingMachineItems). SPS trzyma tam limit i próg ponownego zamówienia, więc ten towar wydaje się bez limitu i bez progu.",
  "itm.isSubGroup": "To podgrupa artykułów",
  "itm.kpi.assigned": "Przypisane",
  "itm.kpi.duplicateSupplierPart": "Powt. nr dostawcy",
  "itm.kpi.lowStock": "Na wyczerpaniu",
  "itm.kpi.obsolete": "Wycofane",
  "itm.kpi.total": "Wszystkie",
  "itm.kpi.unassigned": "Nieprzypisane",
  "itm.limits": "Ograniczenia",
  "itm.lowHint": "Liczba automatów, na których stan jest na progu ponownego zamówienia z SPS albo pod nim. Automaty bez ustawionego progu NIE są tu liczone.",
  "itm.machine": "Automat",
  "itm.machines": "Automaty",
  "itm.name": "Nazwa",
  "itm.noCapacity": "bez pojemności",
  "itm.noGroup": "bez grupy",
  "itm.noThreshold": "próg nieustawiony",
  "itm.noThresholdHint": "Ten automat nie ma ustawionego progu ponownego zamówienia (CRITICALLEVEL), więc nie da się powiedzieć „na wyczerpaniu\".",
  "itm.notAssigned": "Ten towar nie jest przypisany do żadnego automatu.",
  "itm.notAssignedShort": "nieprzypisany",
  "itm.number": "Numer towaru",
  "itm.numberChangeAction": "Zmień numer towaru",
  "itm.numberChangeIntro": "Numer towaru jest w SPS kluczem, po którym poznaje go siedem tabel naraz. Zmiana przenosi go razem z przypisaniami do automatów, zawartością przegródek, limitami, dostępem i inwentarzem zewnętrznym. Stan magazynowy w przegródkach zostaje nietknięty — dlatego nie kasujemy i nie wstawiamy wierszy od nowa, tylko przenosimy sam klucz.",
  "itm.numberChangeNew": "Nowy numer towaru",
  "itm.numberChangeTitle": "Zmiana numeru towaru",
  "itm.numberChangeWarn": "Historia wydań ZOSTAJE przy starym numerze — SPS też jej nie przepisuje, a raport za zamknięty okres ma pokazywać numer, który wtedy obowiązywał. Operacja idzie do automatu przy najbliższym cyklu agenta i wykonuje się w całości albo wcale.",
  "itm.numberChanged": "Zmiana numeru towaru {stary} → {nowy} zakolejkowana",
  "itm.numberPending": "Numer jest wolny w portalu, ale czeka na niego operacja w kolejce zmian.",
  "itm.numberTaken": "Ten numer należy już do „{name}\". SPS nie rozróżnia wielkości liter.",
  "itm.obsolete": "wycofany",
  "itm.obsoleteUnverified": "Kolumny OBSOLETE nie ma w schemacie odczytanym z produktu SPS — jest opcjonalna per instalacja. Nie potwierdziliśmy, czy baza tego klienta ją ma, więc ta operacja może się na nim nie wykonać. Rejestr zmian zapisze to wprost.",
  "itm.onlyAssigned": "tylko przypisane do automatu",
  "itm.onlyDuplicates": "Tylko towary dzielące numer u dostawcy z innym towarem",
  "itm.onlyUnassigned": "tylko nieprzypisane",
  "itm.pendingHint": "Dla tego towaru czeka operacja w kolejce zmian.",
  "itm.restoreConfirm": "Przywróć",
  "itm.restoreTitle": "Przywróć towar",
  "itm.restoreWhy": "Przywrócenie zdejmuje flagę OBSOLETE — towar wróci do wydawania na automatach.",
  "itm.restored": "Przywrócenie dodane do kolejki zmian",
  "itm.retireConfirm": "Wycofaj",
  "itm.retireTitle": "Wycofaj towar",
  "itm.retireWhy": "Wycofanie ustawia flagę OBSOLETE, a nie usuwa wiersza. To jedyny odwracalny sposób wyłączenia towaru w SPS: twarde usunięcie zostawiłoby osierocone odwołania w kilkunastu tabelach i zwróciłoby numer do obiegu.",
  "itm.retired": "Wycofanie dodane do kolejki zmian",
  "itm.saved": "Zmiana towaru dodana do kolejki",
  "itm.state": "Stan",
  "itm.status": "Status katalogowy",
  "itm.statusActive": "aktywne",
  "itm.statusAll": "wszystkie",
  "itm.statusObsolete": "wycofane",
  "itm.stock": "Stan",
  "itm.subGroupHint": "Podgrupa jedzie do SPS jako klucz złożony ISGID, a nie goły kod — goły kod podgrupy nie jest unikalny.",
  "itm.subGroupIsgid": "Podgrupa adresowana w SPS kluczem złożonym: {isgid}",
  "itm.supplierPart": "Nr u dostawcy",
  "itm.supplierPartHint": "Numer katalogowy u dostawcy. Nie musi być unikalny — portal ostrzeże, gdy dwa towary go dzielą.",
  "itm.supplierPartSharedHint": "Ten numer u dostawcy mają też inne towary. Zamówienie może przyjść na zły towar.",
  "itm.threshold": "Próg SPS",
  "itm.unitCost": "Cena jednostkowa",
  "itm.withdrawals": "wydań",
  "klucz.ponadSps": "{n} wierszy przepiszemy PONAD to, co robi SPS — kaskada producenta zostawiłaby w nich stary prefiks, czyli odwołanie do kodu, którego już nie ma.",
  "klucz.przyOkazji": "{n} wierszy zostanie przepisanych PRZY OKAZJI — kaskada SPS nie ma w tym miejscu rozróżnienia, więc rusza też wiersze o tym samym kluczu, których operacja nie dotyczy. Zostawiamy to zgodnie z SPS, żeby ta sama zmiana zrobiona z SPSConfiga dała ten sam wynik.",
  "klucz.taSama": "To jest obecna wartość.",
  "klucz.wKolejce": "Wartość jest wolna w portalu, ale czeka na nią operacja w kolejce zmian.",
  "klucz.wykonaj": "Przenieś klucz",
  "klucz.zaDlugi": "Najwyżej {n} znaków — SPS obciąłby dłuższy BEZ ostrzeżenia i rekord powstałby pod innym kluczem.",
  "klucz.zajety": "Ta wartość należy już do „{name}”.",
  "klucz.zakres": "Co ruszy ta zmiana",
  "klucz.zakresSuma": "{n} wierszy",
  "klucz.zleZnaki": "Dopuszczamy tylko znaki ASCII — usuń: {znaki}",
  "kopia.gotowa": "Gotowa",
  "kopia.plikUsuniety": "plik usunięty (trzymamy 5 ostatnich)",
  "kopia.pobierz": "Pobierz",
  "kopia.wKolejce": "w kolejce",
  "kopia.zlec": "Zrób kopię bazy",
  "kopia.zlecLokalna": "Kopia na dysku maszyny",
  "kopia.zlecLokalnaOpis": "Zrób kopię i zostaw ją na maszynie klienta — bez wysyłania do magazynu. Agent odmówi, gdy zabrakłoby miejsca.",
  "kopia.zlecona": "Zlecono kopię bazy — agent zabierze się za nią przy najbliższym cyklu",
  "kopia.zleconaLokalna": "Zlecono kopię na dysku maszyny — pojawi się na liście poniżej po zakończeniu",
  "kopie.brak": "Nie ma jeszcze ani jednej kopii tej wyspy.",
  "kopie.brakAgenta": "Ta wyspa nie ma agenta bazy — nie ma czym zrobić kopii.",
  "kopie.doPobrania": "do pobrania: {n}",
  "kopie.dysk": "Dysk {wolumen}",
  "kopie.dyskNieznany": "Agent nie podał jeszcze stanu dysku.",
  "kopie.kiedy": "Kiedy",
  "kopie.lista": "Zrobione kopie",
  "kopie.lokalneBrakPomiaru": "Ten agent nie prowadzi kopii na dysku albo jeszcze ich nie zmierzył.",
  "kopie.lokalneOpis": "Leżą u klienta, poza magazynem. Lista bez limitu — ogranicza je tylko miejsce na dysku.",
  "kopie.lokalnePusto": "Katalog kopii na maszynie jest pusty.",
  "kopie.lokalneTytul": "Kopie na dysku maszyny",
  "kopie.maloMiejsca": "Mniej niż 10% wolnego — agent odmówi kolejnej kopii, a zapchany dysk zatrzymuje SQL Servera.",
  "kopie.maszyna": "Maszyna",
  "kopie.naMaszyne": "Na maszynę",
  "kopie.naMaszyneNie.brakMaszyny": "Najpierw wybierz maszynę na liście u góry.",
  "kopie.naMaszyneNie.brakSumy": "Ta kopia powstała przed wprowadzeniem sum kontrolnych, więc maszyna nie miałaby jak sprawdzić, czy dojechała cała. Zrób nową kopię.",
  "kopie.naMaszyneNie.juzTam": "Ta maszyna ma już tę kopię (zgadza się suma kontrolna) — ściąganie nic by nie zmieniło, a kosztuje setki megabajtów przez łącze klienta.",
  "kopie.naMaszyneNie.trwa": "Poczekaj — na tej maszynie trwa już inne zadanie.",
  "kopie.naMaszyneOpis": "Ściągnij tę kopię z magazynu na dysk maszyny klienta — stamtąd da się ją odtworzyć.",
  "kopie.odtworz": "Odtwórz bazę",
  "kopie.odtworzOkno": "Paczka {plik} zostanie rozpakowana na maszynie i wgrana jako nowa baza na jej serwerze SQL.",
  "kopie.odtworzOpis": "Wgraj tę kopię na serwer SQL tej maszyny jako NOWĄ bazę",
  "kopie.odtworzPole": "Nazwa bazy docelowej",
  "kopie.odtworzTytul": "Odtworzyć bazę z tej kopii?",
  "kopie.odtworzWarunek": "Baza o tej nazwie NIE MOŻE jeszcze istnieć — nadpisywania agent nie umie z rozmysłu, bo RESTORE na istniejącą bazę jest nieodwracalny. Jeśli istnieje, zadanie wróci jako nieudane i nic się nie stanie.",
  "kopie.odtworzZlaNazwa": "Nazwa musi zaczynać się od litery lub podkreślenia i składać z liter, cyfr, „_\", „$\" i „-\".",
  "kopie.odtworzZlecone": "Zlecono odtworzenie bazy — agent zabierze się za nie przy najbliższym cyklu",
  "kopie.plik": "Plik",
  "kopie.pobranieZlecone": "Zlecono ściągnięcie kopii na maszynę",
  "kopie.podtytul": "Kopie bazy SPS robione przez agenta — zlecenie, przegląd i pobranie na komputer.",
  "kopie.przerwano": "Zadanie przerwane — przyciski odblokowane",
  "kopie.przerwij": "Przerwij",
  "kopie.przerwijOpis": "Przestań czekać na to zadanie i odblokuj przyciski. Agenta to nie zatrzyma, ale jego spóźniony wynik zostanie odrzucony.",
  "kopie.rozmiar": "Rozmiar",
  "kopie.spisSprzed": "Ta lista jest sprzed ostatniej operacji — maszyna wysyła spis razem z sygnałem życia, więc świeży przyjdzie w następnym cyklu (do minuty).",
  "kopie.stan": "Stan",
  "kopie.trwa.KOPIA_BAZY": "Kopia do magazynu w trakcie — poczekaj na zakończenie",
  "kopie.trwa.KOPIA_LOKALNA": "Kopia na dysku maszyny w trakcie — poczekaj na zakończenie",
  "kopie.trwa.KOPIA_ODTWORZ": "Odtwarzanie bazy w trakcie — poczekaj na zakończenie",
  "kopie.trwa.KOPIA_POBIERZ": "Ściąganie kopii na maszynę w trakcie — poczekaj na zakończenie",
  "kopie.trwa.KOPIA_WYSLIJ": "Wysyłka kopii do magazynu w trakcie — poczekaj na zakończenie",
  "kopie.sprzatnij": "Wyczyść wpisy bez pliku ({n})",
  "kopie.sprzatnijOpis": "Usuń z listy wiersze po kopiach, których plik już nie istnieje. Ekran ukrywa je sam po {d} dniach — ten przycisk robi to od razu.",
  "kopie.sprzatnijPytanie": "Usunąć {n} wpisów po kopiach bez pliku?\n\nPlików to nie dotyczy — już ich nie ma. Ślad, kto i kiedy zrobił oraz skasował kopię, zostaje w dzienniku audytu.",
  "kopie.sprzatnieto": "Usunięto wpisów: {n}",
  "kopie.ukryte": "Ukryte wpisy po kopiach, których pliku już nie ma: {n} (starsze niż {d} dni). Kto i kiedy skasował kopię — zakładka Logi.",
  "kopie.usun": "Usuń",
  "kopie.usunLokalnaOpis": "Plik {plik} ({mb}) zostanie skasowany z dysku maszyny klienta.",
  "kopie.usunLokalnaSkutek": "Jeśli tej kopii nie ma w magazynie, po skasowaniu nie będzie jej nigdzie. Usunięcie wykona agent przy najbliższym cyklu.",
  "kopie.usunLokalnaTytul": "Usunąć kopię z dysku maszyny?",
  "kopie.usunOpis": "Kopia z {kiedy} zniknie z magazynu bezpowrotnie — nie ma kosza ani drugiego egzemplarza.",
  "kopie.usunTytul": "Usunąć plik kopii?",
  "kopie.usunWpis": "Wpis w liście zostaje, żeby było widać, kto i kiedy tę kopię robił. Zniknie sam plik.",
  "kopie.usuniecieZlecone": "Zlecono usunięcie kopii z dysku maszyny",
  "kopie.usunieta": "Kopia usunięta z magazynu",
  "kopie.utknelo": "To zadanie stoi od {minut} min.",
  "kopie.utknelo.bezAgenta": "Nie wiemy, kiedy agent odezwał się ostatni raz. Portal zwolni zadanie sam po 30 minutach ciszy — przyciskiem obok zrobisz to teraz.",
  "kopie.utknelo.cisza": "Agent ostatni raz odezwał się {minut} min temu. Portal zwolni zadanie sam po 30 minutach ciszy — przyciskiem obok zrobisz to teraz.",
  "kopie.wPlanie": "Odtworzenie bazy jest przy kopiach leżących na maszynie: paczkę z magazynu najpierw wrzuca się na maszynę, potem odtwarza pod nową nazwą. Brakuje jeszcze różnicówki po odtworzeniu i ustawień synchronizacji Smart Sync.",
  "kopie.wgraj": "Wgraj paczkę z komputera",
  "kopie.wgrajOpis": "Wyślij kopię (.bak albo .zip) ze swojego dysku prosto do magazynu — z pominięciem maszyny. Stamtąd da się ją wrzucić na maszynę i odtworzyć.",
  "kopie.wgrana": "Paczka wgrana do magazynu jako {plik}",
  "kopie.wgrywanie": "Wysyłam {plik}",
  "kopie.wgrywanieKoniec": "Bajty doszły — czekam na potwierdzenie z magazynu.",
  "kopie.wolne": "wolne {wolne} z {calkowite}",
  "kopie.wyczysc": "Wyczyść nieudane ({n})",
  "kopie.wyczyscOpis": "Usuń z listy wpisy po nieudanych zadaniach. Pliku żadne z nich nie zostawiło, a ślad kto i kiedy je zlecił zostaje w dzienniku audytu.",
  "kopie.wyczyszczono": "Usunięto nieudanych wpisów: {n}",
  "kopie.wyslanieZlecone": "Zlecono wysłanie kopii do magazynu",
  "kopie.wyslijDoMagazynu": "Wyślij do magazynu",
  "kopie.wyslijDoMagazynuOpis": "Wyślij tę paczkę z dysku maszyny do magazynu instancji — stamtąd pobierzesz ją na komputer.",
  "kopie.wyslijNie.juzTam": "Ta kopia jest już w magazynie (zgadza się suma kontrolna) — wysyłanie jej drugi raz nic by nie zmieniło.",
  "kopie.zKomputera": "wgrana z komputera",
  "kopie.zZadania": "z zadania",
  "kopie.zZadaniaOpis": "Ta paczka jest na maszynie, bo portal ją tam pobrał — nazwę, rozmiar i sumę znamy z tego zadania. Spisu z maszyny jeszcze nie ma (agent przysyła go razem z sygnałem życia udanego cyklu), więc licznik miejsca i reszta katalogu pozostają nieznane.",
  "kopie.zadnaDoPobrania": "Żadna z tych pozycji nie ma pliku w magazynie — dopiero gotowa kopia daje przyciski „Pobierz\" i „Na maszynę\". Zrób nową kopię albo wgraj paczkę z komputera.",
  "kopie.zmierzono": "Zmierzono: {kiedy}",
  "poczek.tytul": "Poczekalnia",
  "poczek.ile": "paczek: {ile}",
  "poczek.wgraj": "Wgraj kopię do poczekalni",
  "poczek.wgrajOpis": "Ta wyspa nie ma jeszcze maszyny — paczka poczeka w magazynie.",
  "poczek.wgrana": "Paczka {plik} czeka w magazynie.",
  "poczek.brakAgentaAle": "Kopię można już wgrać — poczeka na pierwszą maszynę.",
  "poczek.zKodu": "dla wyspy {wyspa}",
  "poczek.zKoduOpis": "Przypięta do kodu rejestracyjnego, który tę wyspę założy.",
  "poczek.zPolki": "z półki",
  "poczek.zPolkiOpis": "Wgrana bez przypięcia do wyspy ani do kodu.",
  "poczek.przejmij": "Wprowadź do magazynu",
  "poczek.przejmijOpis": "Paczka stanie się kopią tej wyspy — stamtąd wrzucisz ją na maszynę.",
  "poczek.przejeta": "Paczka {plik} jest w magazynie wyspy.",
  "poczek.brakWezla": "Najpierw wyspa musi mieć węzeł bazy.",
  "poczek.brakWyspy": "Nie ma jeszcze wyspy — nie ma czym zrobić kopii.",
  "poczek.usunOpis": "Usuń z poczekalni razem z plikiem",
  "poczek.usunTytul": "Usunąć paczkę z poczekalni?",
  "poczek.usunTresc": "Plik zniknie z magazynu. Nie mamy drugiego egzemplarza.",
  "poczek.usunieta": "Paczka usunięta z poczekalni.",
  "poczek.naZapas": "Kopia na zapas",
  "poczek.naZapasOpis": "Wgraj kopię bazy dla wyspy, która powstanie z tego kodu.",
  "poczek.juzCzeka": "czeka: {ile}",
  "korekta.biezaca": "Ustaw tę cenę także jako bieżącą na towarze",
  "korekta.biezacaHint": "To ona jest przyczyną rozjazdu — bez niej kolejne wydania znów pójdą po starej i za miesiąc będzie druga korekta.",
  "korekta.brakTowarow": "Żaden towar nie pasuje do tej frazy.",
  "korekta.byloCeny": "Ceny przed korektą:",
  "korekta.cena": "Nowa cena (zł)",
  "korekta.cenaBiezacaTeraz": "Cena bieżąca towaru:",
  "korekta.do": "Do dnia",
  "korekta.doZmiany": "Do poprawienia: {n} wydań",
  "korekta.dodatkowe": "Dodatkowe (występujące w danych tej wyspy)",
  "korekta.eksport": "Eksportuj te wydania",
  "korekta.eksportGotowy": "Pobrano {n} wydań",
  "korekta.juzPoprawne": "pomijamy {n} już poprawnych",
  "korekta.nicDoZmiany": "W tym zakresie nie ma wydań do poprawienia — albo wszystkie mają już tę cenę, albo zakres jest pusty.",
  "korekta.od": "Od dnia",
  "korekta.opis": "Poprawia cenę na wydaniach jednego towaru w wybranym okresie — tam, gdzie w automacie stała nieaktualna. Zmiana pojedzie do bazy automatu i od razu odbije się w portalu.",
  "korekta.ostrzezenie": "SPS nie wersjonuje rejestru wydań: po zatwierdzeniu poprzednich cen nie da się odtworzyć inaczej niż drugą korektą. Sprawdź okres i kwoty.",
  "korekta.podstawowe": "Podstawowe",
  "korekta.pokaz": "Pokaż, co się zmieni",
  "korekta.przycisk": "Zmiana cen",
  "korekta.szukajTowaru": "Zacznij pisać nazwę albo indeks…",
  "korekta.towar": "Towar",
  "korekta.tytul": "Korekta ceny w historii wydań",
  "korekta.wartosc": "Wartość w tym okresie:",
  "korekta.wszystkieTypy": "Wszystkie typy operacji",
  "korekta.zWiersza": "Popraw cenę tego towaru w historii",
  "korekta.zatwierdz": "Zatwierdź korektę",
  "korekta.zrobione": "Poprawiono {n} wydań — zmiana jedzie do automatu",
  "login.email": "E-mail",
  "login.failed": "Logowanie nieudane",
  "login.modeDev": "Tryb DEV (bez Keycloaka)",
  "login.modeKeycloak": "Uwierzytelnianie: Keycloak",
  "login.password": "Hasło",
  "login.submit": "Zaloguj",
  "login.subtitle": "Portal zarządzania automatami",
  "login.title": "Zaloguj się",
  "logs.action": "Zdarzenie (lub jego początek)",
  "logs.actor": "Kto",
  "logs.aktor.AGENT": "agent",
  "logs.aktor.API": "integracja API",
  "logs.aktor.BEZ_KONTA": "konto usunięte albo nieznane",
  "logs.aktor.PANEL": "token panelu",
  "logs.aktor.PORTAL": "portal, automatycznie",
  "logs.anyLevel": "dowolny",
  "logs.anyOutcome": "dowolny",
  "logs.count": "wpisów",
  "logs.denied": "ODMOWA",
  "logs.emptyAudit": "Brak wpisów audytu dla tych filtrów.",
  "logs.emptyDiagnostic": "Brak wpisów diagnostycznych dla tych filtrów.",
  "logs.instanceWide": "cała instancja",
  "logs.limitDays": "limit dni",
  "logs.limitRows": "limit wierszy",
  "logs.live.co": "Co przyszło",
  "logs.live.kiedy": "Godzina",
  "logs.live.opis": "Co wleciało ze Smart Synca — tylko to, co się zmieniło. Odświeża się samo.",
  "logs.live.pusto": "Nic się nie zmieniło. Na pracującej wyspie to normalny stan: wpis powstaje dopiero, gdy paczka od agenta coś wniosła.",
  "logs.live.wezel": "Węzeł",
  "logs.live.wydan": "{n} wydań",
  "logs.live.wydanie": "{n} wydanie",
  "logs.live.zachowane": "zachowane {n}",
  "logs.minLevel": "Poziom co najmniej",
  "logs.noAccount": "bez powiązanego konta",
  "logs.notRotated": "Bez rotacji — nic nie usuwa tych wpisów automatycznie",
  "logs.onlyIsland": "tylko wybrana wyspa",
  "logs.outcome": "Skutek",
  "logs.rotated": "Rotowany — te wpisy z czasem znikną",
  "logs.search": "Szukaj w treści",
  "logs.source": "Źródło",
  "logs.tabAudit": "Ślad audytu",
  "logs.tabDiagnostic": "Log diagnostyczny",
  "logs.tabLive": "Live",
  "logs.tabSpsLog": "Logi SPS",
  "logs.tabTraffic": "Zużycie danych",
  "logs.title": "Logi i statystyki",
  "machines.add": "Dodaj automat",
  "machines.addTitle": "Nowy automat",
  "machines.agentVersion": "Wersja agenta",
  "machines.bazaBrakPomiaru": "Agent tej maszyny nie melduje stanu bazy — starsza wersja. Sama plakietka mówi tylko tyle, że baza wyspy fizycznie stoi tutaj.",
  "machines.bazaNieaktualny": "Ostatni pomiar mówił, że baza odpowiada, ale agent tej maszyny milczy — więc nikt jej teraz nie sprawdza. To stan sprzed jego zamilknięcia, nie stan bieżący.",
  "machines.bazaNieaktualnyBlad": "Ostatni pomiar mówił, że baza NIE odpowiada, ale agent tej maszyny milczy — więc nikt jej teraz nie sprawdza. To stan sprzed jego zamilknięcia, nie stan bieżący.",
  "machines.bazaNieodpowiada": "BAZA WYSPY NIE ODPOWIADA — agent jej nie otworzył. Dopóki to trwa, stoi synchronizacja CAŁEJ wyspy, nie tylko tego automatu.",
  "machines.bazaOdpowiada": "Baza wyspy ODPOWIADA — ostatni cykl agenta ją przeczytał.",
  "machines.code": "Kod",
  "machines.compartments": "Przegródki",
  "machines.compartmentsFilled": "Przegródki z towarem",
  "machines.compartmentsHint": "Przegródki z przypisanym towarem / wszystkie przegródki automatu. Mianownik pochodzi z planogramu.",
  "machines.createNotice": "Kreator zakolejkuje atomowo dwie zmiany: wpis automatu oraz PICAddressMode (MODETYPE=9) — bez tego drugiego automat nie wystartuje. Agent pobierze kolejkę w ciągu ~10 s; stan operacji widać w „Zmianach”.",
  "machines.created": "Automat utworzony",
  "machines.drums": "Bębny",
  "machines.drumsHint": "Metadana portalu — realną liczbę bębnów wyznacza planogram.",
  "machines.editNotice": "Zmiana pójdzie jako patch (tylko zmienione kolumny), żeby nie nadpisać pozostałych. Agent pobierze kolejkę w ciągu ~10 s; stan operacji widać w „Zmianach”.",
  "machines.editTitle": "Edycja automatu",
  "machines.fill": "Zapełnienie",
  "machines.hasDatabase": "BAZA WYSPY",
  "machines.hasDatabaseHint": "Na tym automacie stoi baza wyspy — wyłączenie go zatrzyma synchronizację całej wyspy",
  "machines.lastSeen": "Ostatni kontakt",
  "machines.mode25": "25 — DynaBox",
  "machines.mode9": "9 — bęben natywny (BiPoint)",
  "machines.modeType": "Tryb adresowania bębnów",
  "machines.modeTypeHint": "Rozstrzyga RODZAJ maszyny. Współrzędne przegródki liczą się w tych trybach inaczej, więc zła wartość sprawia, że planogram wskazuje inną fizyczną komórkę, niż klikasz.",
  "machines.name": "Nazwa",
  "machines.noPlanogram": "brak planogramu",
  "machines.onlyOnline": "Tylko online",
  "machines.pending": "w kolejce",
  "machines.pendingHint": "Jest niezastosowana zmiana konfiguracji dla tego automatu.",
  "machines.presence.NEVER_CONNECTED": "Nigdy się nie połączył",
  "machines.presence.NO_AGENT": "Bez agenta",
  "machines.presence.ONLINE": "Online",
  "machines.presence.SILENT": "Nie odpowiada",
  "machines.presence.awaiting": "czeka na potwierdzenie",
  "machines.presence.awaitingHint": "Agent melduje się prawidłowo, ale portal nie przyjmuje od niego konfiguracji ani wydań, dopóki nie potwierdzisz węzła na ekranie „Agenci\".",
  "machines.presence.contradiction": "SPRZECZNOŚĆ",
  "machines.presence.contradictionHint": "Automat raportuje, że jest podłączony, a jego agent milczy — jedna z tych informacji jest nieaktualna.",
  "machines.saved": "Zmiana zakolejkowana",
  "machines.spsui": "SPSUI",
  "machines.spsui.brakPomiaru": "Agent tej maszyny nie sprawdza procesu — starsza wersja albo maszyna, na której SPS nie stoi. To nie znaczy, że automat nie działa.",
  "machines.spsui.dolaczone": "Uruchomienie było już zlecone — czekamy na jego wynik",
  "machines.spsui.dziala": "działa",
  "machines.spsui.maint": "MAINT — baza padła",
  "machines.spsui.maintByl": "Maint {n} min temu",
  "machines.spsui.maintHint": "Chodzi narzędzie naprawcze SPS-a. Startuje wtedy, gdy SPS-owi rozsypuje się połączenie z bazą, więc znaczy to „automat stracił bazę\" — stan gorszy niż wyłączony interfejs, bo nikt go nie uruchamia umyślnie.",
  "machines.spsui.nieznany": "stan nieznany",
  "machines.spsui.nieznanyHint": "Ostatni pomiar mówił: {stan}. Agent tej maszyny milczy, więc nikt SPSUI teraz nie sprawdza — to stan sprzed jego zamilknięcia, nie stan bieżący.",
  "machines.spsui.stoi": "nie działa",
  "machines.spsui.stoiHint": "Interfejs automatu nie chodzi — pracownik przed nim nic nie pobierze. Bywa wyłączany celowo (serwis, przenosiny), dlatego żółty, a nie czerwony.",
  "machines.spsui.uruchom": "Uruchom interfejs automatu (SPSUI)",
  "machines.spsui.uruchomDziala": "SPSUI działał przy ostatnim meldunku — kliknij, jeśli mimo to ekran automatu jest pusty",
  "machines.spsui.uruchomOffline": "Agent tej maszyny nie jest online — nie ma komu uruchomić interfejsu",
  "machines.spsui.zlecone": "Zlecono uruchomienie interfejsu — wynik zobaczysz na liście zadań maszyny",
  "machines.spsui.zmierzono": "sprawdzono:",
  "machines.status": "Łączność",
  "machines.willGetVmid": "Otrzyma VMID",
  "machines.zakladka.lista": "Lista",
  "machines.zakladka.ustawienia": "Ustawienia",
  "mcard.brakAgenta": "Na tej maszynie nie ma agenta — portal wie o niej tylko to, co przyniósł inny węzeł wyspy.",
  "mcard.brakParametrow": "Portal nie ma jeszcze parametrów tego automatu — przyjdą z synchronizacją konfiguracji.",
  "mcard.brakWydan": "Brak wydań z rozpoznanym towarem.",
  "mcard.czekaDociagniecie": "czeka dociągnięcie (obce do {n})",
  "mcard.dyskZajete": "Zajęte {proc}%",
  "mcard.f.baza": "Baza SPS",
  "mcard.f.bebny": "Bębny",
  "mcard.f.bladWpisu": "Błąd wpisywania",
  "mcard.f.czasMaszyny": "Czas maszyny",
  "mcard.f.ipMaszyny": "Adres maszyny",
  "mcard.f.ipPortalu": "Adres widziany przez portal",
  "mcard.f.kod": "Kod maszyny",
  "mcard.f.kolumny": "Kolumny (DynaBox)",
  "mcard.f.komputer": "Komputer",
  "mcard.f.kontakt": "Ostatni kontakt",
  "mcard.f.korekta": "Korekta przez agenta",
  "mcard.f.kursor": "Kursor wydań rodzeństwa",
  "mcard.f.meldunek": "Ostatni meldunek",
  "mcard.f.nazwa": "Nazwa",
  "mcard.f.problem": "Problem",
  "mcard.f.przegrodki": "Przegródki",
  "mcard.f.pytal": "Ostatnio pytał o wydania",
  "mcard.f.razem": "Razem",
  "mcard.f.rodzenstwo": "Rozsyłanie wydań rodzeństwa",
  "mcard.f.rola": "Rola",
  "mcard.f.rozjazd": "Odchylenie od czasu portalu",
  "mcard.f.serwer": "Serwer SQL",
  "mcard.f.sqlWersja": "SQL Server",
  "mcard.f.stan": "Stan",
  "mcard.f.strefa": "Strefa maszyny",
  "mcard.f.system": "System",
  "mcard.f.szuflady": "Szuflady",
  "mcard.f.tryb": "Tryb wyspy",
  "mcard.f.uwagi": "Uwagi z cyklu",
  "mcard.f.vmid": "VMID",
  "mcard.f.w32time": "Synchronizacja zegara (W32Time)",
  "mcard.f.wersja": "Wersja agenta",
  "mcard.f.wezel": "Węzeł",
  "mcard.f.wolne": "Wolne miejsce",
  "mcard.f.wpisanych": "Wpisanych wierszy rodzeństwa",
  "mcard.f.wyspa": "Wyspa",
  "mcard.f.zadan": "Żądań",
  "mcard.f.zmierzono": "Zmierzono",
  "mcard.innaNizMaster": "inna niż master wyspy ({baza})",
  "mcard.k.przegrodek": "Przegródek",
  "mcard.k.towarow": "Towarów w maszynie",
  "mcard.k.wydan": "Wydań z tego automatu",
  "mcard.korektaOd": "od {n} s",
  "mcard.korektaWyl": "(próg {n} s — tylko zgłaszanie)",
  "mcard.nadaza": "nadąża",
  "mcard.nieustalone": "nieustalone",
  "mcard.nieustawiony": "nieustawiony",
  "mcard.nigdy": "nigdy",
  "mcard.oczekuje": "oczekuje",
  "mcard.ostatnieWydanie": "Ostatnie",
  "mcard.p.never": "nigdy się nie zgłosił",
  "mcard.p.noAgent": "bez agenta",
  "mcard.p.online": "online",
  "mcard.p.silent": "milczy",
  "mcard.portalZna": "(portal zna {n})",
  "mcard.potwierdzony": "potwierdzony",
  "mcard.przegrodkiHint": "Przegródki znane portalowi z konfiguracji",
  "mcard.ruchBrak": "Maszyna bez agenta — nie ma czego liczyć",
  "mcard.s.dyskZegar": "Dysk i zegar",
  "mcard.s.ruch": "Zużycie danych",
  "mcard.s.setup": "Ustawienia SPS tego automatu",
  "mcard.s.sprzet": "Maszyna i sprzęt",
  "mcard.s.sync": "Stan synchronizacji",
  "mcard.s.towary": "Co się stąd bierze",
  "mcard.s.wezel": "Węzeł i system",
  "mcard.svc.auto": "automatyczny",
  "mcard.svc.disabled": "wyłączona",
  "mcard.svc.manual": "ręczny",
  "mcard.svc.running": "działa",
  "mcard.svc.stopped": "zatrzymana",
  "mcard.svc.unknown": "nie wiadomo, czy działa",
  "mcard.th.nadpisanie": "Nadpisanie",
  "mcard.th.opis": "Opis",
  "mcard.th.param": "Parametr",
  "mcard.th.sztuk": "Sztuk",
  "mcard.th.towar": "Towar",
  "mcard.th.wartosc": "Wartość",
  "mcard.th.wydan": "Wydań",
  "mcard.trybZwykly": "zwykły",
  "mcard.w32timeOff": "Maszyna nie wyrówna zegara sama — rozjazd będzie narastał",
  "mcard.wDol": "w dół",
  "mcard.wGore": "w górę",
  "mcard.wlaczona": "włączona",
  "mcard.wlaczone": "włączone",
  "mcard.wrocDoListy": "Nie widzę tego automatu na wybranej wyspie. Jeśli przełączyłeś wyspę, wróć na listę i wejdź w automat z niej.",
  "mcard.wylaczoneNaWyspie": "wyłączone na tej wyspie",
  "mcard.wyspaOczekuje": "wyspa oczekuje {strefa}",
  "mcard.zakladka.moduly": "Moduły",
  "mcard.zakladka.ogolne": "Ogólne",
  "mcard.zakladka.ustawienia": "Ustawienia",
  "ust.tytul": "Ustawienia automatu",
  "ust.licznik": "{n} ustawień",
  "ust.szukaj": "Szukaj nazwy, opisu albo wartości",
  "ust.wszystkieGrupy": "Wszystkie grupy",
  "ust.bezGrupy": "Bez grupy",
  "ust.tylkoRozne": "Tylko różne od innych automatów",
  "ust.zapisBlokuje": "Zapis wymaga agenta {wersja} na każdej bazie wyspy — starszego mają: {wezly}",
  "ust.brak": "Portal nie ma jeszcze ustawień tego automatu — przyjdą z agentem {wersja}.",
  "ust.tak": "Tak",
  "ust.nie": "Nie",
  "ust.zmien": "Zmień",
  "ust.wszystkieAutomaty": "Na wszystkich automatach ({n})",
  "ust.naWszystkich": "zawsze na wszystkich",
  "ust.wKolejce": "w kolejce",
  "ust.inneNa": "inna na: {lista}",
  "ust.zakolejkowano": "Zakolejkowano {param} na {n} automatach",
  "ust.calaWyspa": "Cała wyspa",
  "ustW.licznik": "{n} ustawień na {automatow} automatach",
  "ustW.tylkoRozne": "Tylko różniące się między automatami",
  "ustW.ustawienie": "Ustawienie",
  "ustW.brakParametru": "Tego parametru nie ma na tym automacie",
  "ustW.nowaWartosc": "Nowa wartość",
  "ustW.naKtorych": "Na których automatach",
  "ustW.wszystkie": "wszystkie",
  "ustW.odstajace": "tylko odstające",
  "moduly.brak": "Portal nie zna jeszcze żadnego bębna tej maszyny — poczekaj na synchronizację konfiguracji.",
  "moduly.brakWcale": "{wezel}: nie ma wcale",
  "moduly.brakWcaleGrupa": "nie ma wcale — {wezly}",
  "moduly.brakujeGrupa": "brakuje {ile} — {wezly}",
  "moduly.brakujeIle": "{wezel}: brakuje {ile}",
  "moduly.czekaNa": "czeka na",
  "moduly.deklarowanych": "konstrukcja obiecuje {n}",
  "moduly.dojezdza": "zmiana jeszcze dojeżdża",
  "moduly.domkniecie.nazwa": "Nadpisz ten automat w innych bazach",
  "moduly.domkniecie.pytanie": "Nadpisać automat {nazwa} w bazach pozostałych maszyn?\n\nKażda z nich dostanie dokładną kopię zapisu z maszyny, która ten automat obsługuje: brakujące zostanie dopisane, inne poprawione, a wszystko, czego tam NIE MA, zostanie USUNIĘTE — razem ze stanem magazynowym tych pozycji.\n\nMaszyna obsługująca ten automat tej operacji nie dostanie: u niej te wiersze są prawdą. Innych automatów to nie zmienia.\n\nTego się nie cofa. Kontynuować?",
  "moduly.domkniecieDymek": "Każda maszyna wyspy ma w swojej bazie zapis tego automatu: bębny, szuflady, przegródki i towary w przegródkach. Ten przycisk zastępuje go w bazach pozostałych maszyn dokładną kopią z maszyny, która ten automat obsługuje. Innych automatów nie zmienia.\n\nDodaje: tak · Zmienia: tak · Usuwa: tak, razem ze stanem magazynowym. Nie da się cofnąć.",
  "moduly.innaTresc": "ta sama liczba wierszy, INNA ZAWARTOŚĆ — poprawia to dopiero „Nadpisz ten automat w innych bazach”",
  "moduly.kolumn": "Kolumn DynaBox",
  "moduly.kolumnRoto": "Kolumn",
  "moduly.mozeszWyrownac": "Część maszyn nie ma tego automatu w bazie WCALE. Przycisk „Uzupełnij ten automat w innych bazach” na górze ekranu dopisze im brakujące wiersze.",
  "moduly.nadmiar": "{wezel}: {ile} ponad właściciela — usuwa to dopiero „Nadpisz ten automat w innych bazach”",
  "moduly.nieznanaKonstrukcja": "Konstrukcja nieznana",
  "moduly.odrzucone": "Odrzucone przez węzeł: {ile}",
  "moduly.odrzuconeWyjasnienie": "Odrzucona operacja NIE wraca do kolejki — nikt jej sam nie powtórzy. Sprawdź powód i zdecyduj, czy wysłać ponownie, czy przyjąć stan z maszyny.",
  "moduly.pic": "Bęben",
  "moduly.pokazLiczby": "pokaż surowe liczby wierszy",
  "moduly.pominieteBebny": "Pominięto bębny, które nie mieszczą się w jednej transakcji: {bebny}. Zgłoś to — taki bęben trzeba rozesłać szufladami.",
  "moduly.pozaWyrownaniem": "poza wyrównaniem",
  "moduly.propagacjaWToku": "Maszyny wyspy chwilowo widzą różne liczby — to normalne, gdy zmiana właśnie do nich dojeżdża. Jeśli utrzyma się dłużej niż {minut} min, będzie zgłoszone jako rozjazd.",
  "moduly.przegrod": "Przegród",
  "moduly.rozjazd": "Konfiguracja mówi o {konfiguracja} bębnach, portal zna {portal}. Liczby niżej opisują tylko te znane.",
  "moduly.rozjazdWezlow": "Maszyny wyspy nie zgadzają się co do konfiguracji tego automatu. Liczby niżej opisują to, co widzi jego własna maszyna.",
  "moduly.swobodne": "Wydawanie swobodne",
  "moduly.szuflad": "Szuflad",
  "moduly.typSzuflady": "Typ szuflady",
  "moduly.ukryjLiczby": "ukryj surowe liczby wierszy",
  "moduly.wDrodze": "W drodze: {ile} zmian(y) czeka na węzły",
  "moduly.wstrzymane": "Wstrzymane do aktualizacji agenta",
  "moduly.wstrzymaneWyjasnienie": "Nic nie trzeba robić — te operacje wykonają się same, gdy agent się zaktualizuje.",
  "moduly.wymagaWersji": "potrzebuje wersji {wersja}",
  "moduly.wyrownaj": "Uzupełnij ten automat w innych bazach",
  "moduly.wyrownajDymek": "Każda maszyna wyspy ma w swojej bazie zapis tego automatu: bębny, szuflady, przegródki i towary w przegródkach. Ten przycisk dopisuje w bazach pozostałych maszyn tylko to, czego tam brakuje. Innych automatów nie zmienia.\n\nDodaje: tak · Zmienia: nie · Usuwa: nie",
  "moduly.wyrownajPytanie": "Uzupełnić automat {nazwa} w bazach pozostałych maszyn?\n\nPortal dopisze brakujące bębny, szuflady, przegródki, kanały i drzwiczki oraz brakujące pozycje planogramu, czyli to, co leży w przegródkach. Maszyny, które te wiersze już mają, pominą zmianę same — nic się im nie nadpisze.\n\nStan magazynowy NIE jedzie z portalu: nowa pozycja dostaje zero, bo stan należy do automatu.\n\nTo NIE prostuje wierszy, które gdzieś istnieją z inną treścią — do tego jest „Nadpisz ten automat w innych bazach”.",
  "moduly.wyrownanieZlecone": "Zlecono uzupełnienie: {zmian} zmian.",
  "moduly.wyrownanieZleconeBebny": "Zlecono: {operacji} operacje (po jednej na bęben), razem {zmian} zmian.",
  "moduly.zrodloDomysl": "Najwięcej wierszy ma {wezel} — ale portal nie wie, który węzeł obsługuje ten automat, więc to domysł, nie źródło.",
  "moduly.zrodloZmian": "Ten automat obsługuje {wezel} — z tej maszyny pójdą zmiany przy wyrównaniu, bo tam jego konfiguracja jest prawdą.",
  "nagr.automat": "Automat",
  "nagr.bezPodgladu": "Bez podglądu",
  "nagr.brak": "Brak nagrań w tym okresie",
  "nagr.do": "Do",
  "nagr.kolAutomat": "Automat",
  "nagr.kolDlugosc": "Długość",
  "nagr.kolKiedy": "Kiedy",
  "nagr.kolOperacja": "Operacja",
  "nagr.kolOsoba": "Osoba",
  "nagr.kolRozmiar": "Rozmiar",
  "nagr.kolStan": "Stan",
  "nagr.kolTowary": "Towary",
  "nagr.limit": "Limit pliku (MB)",
  "nagr.od": "Od",
  "nagr.odtworz": "Odtwórz",
  "nagr.okres": "Okres (mies.)",
  "nagr.pobieraj": "Pobieraj",
  "nagr.pobierz": "Pobierz",
  "nagr.pobierzOryginal": "Pobierz oryginał",
  "nagr.przygotowuje": "Przygotowuję…",
  "nagr.rodzaj.doRegeneracji": "Pobranie do regeneracji",
  "nagr.rodzaj.inne": "Inne",
  "nagr.rodzaj.korekta": "Korekta stanu",
  "nagr.rodzaj.pobranie": "Pobranie",
  "nagr.rodzaj.uzupelnienie": "Uzupełnienie",
  "nagr.rodzaj.wrzut": "Wrzut do regeneracji",
  "nagr.rodzaj.zRegeneracji": "Z regeneracji",
  "nagr.rodzaj.zlom": "Złom",
  "nagr.rodzaj.zwrot": "Zwrot",
  "nagr.sek": "{n} s",
  "nagr.stan.OCZEKUJE": "W drodze",
  "nagr.stan.WYSLANE": "Na instancji",
  "nagr.stan.ZA_DUZE": "Za duże",
  "nagr.ustawienia": "Ustawienia",
  "nagr.wszystkie": "Wszystkie",
  "nagr.usunPoDniach": "Usuń z maszyny po (dni)",
  "nagr.usunZMaszyny": "Usuń z maszyny",
  "nagr.usunOstrzezenie": "Nagrania {kody} znikną z komputera maszyny po {n} dniach — nie da się ich przywrócić",
  "nagr.katalogi": "Katalog nagrań na maszynach",
  "nagr.katalogBrak": "Agenci nie zmierzyli jeszcze katalogów nagrań",
  "nagr.katalog": "Katalog",
  "nagr.plikow": "Plików",
  "nagr.usunieto": "Usunięto",
  "nagr.zmierzono": "Zmierzono",
  "nagr.zapisano": "Ustawienia nagrań zapisane",
  "hr.stan.podglad": "Tylko podgląd — nic nie trafia do automatów",
  "hr.sprawdzono": "Sprawdzono {kiedy}",
  "hr.polaczenie": "Połączenie",
  "hr.brakSejfu": "Instancja bez SESSION_SECRET — klucza nie da się zapisać",
  "hr.kluczNieczytelny": "Zapisanego klucza nie da się odczytać — wpisz go ponownie",
  "hr.adres": "Adres HR+",
  "hr.serwis": "ID serwisu",
  "hr.serwisPodpowiedz": "UUID albo adres feedu z HR+",
  "hr.klucz": "Klucz",
  "hr.kluczJest": "Wpisany: {p}…",
  "hr.kolejnosc": "Nazwa",
  "hr.kolejnosc.IMIE_NAZWISKO": "Imię Nazwisko",
  "hr.kolejnosc.NAZWISKO_IMIE": "Nazwisko Imię",
  "hr.zrodlo": "Numer karty z",
  "hr.zrodlo.employeeNo": "numer ewidencyjny (employeeNo)",
  "hr.zrodlo.atrybut": "pole dodatkowe",
  "hr.zrodlo.inne": "inna ścieżka",
  "hr.atrybut": "Nazwa pola dodatkowego",
  "hr.sciezka": "Ścieżka pola",
  "hr.zapisz": "Zapisz",
  "hr.zapisano": "Zapisano",
  "hr.sprawdz": "Sprawdź połączenie",
  "hr.wHr": "W HR+: {n}",
  "hr.polaDodatkowe": "Pola dodatkowe: {a}",
  "hr.brakPolDodatkowych": "Brak pól dodatkowych",
  "hr.przyklad": "Przykład: {nazwa} · karta {numer}",
  "hr.przykladBezKarty": "Przykład: {nazwa} · bez numeru karty",
  "hr.podglad": "Podgląd",
  "hr.porownaj": "Pobierz i porównaj",
  "hr.dopasowani": "Dopasowani: {n}",
  "hr.bezZmian": "bez zmian: {n}",
  "hr.kat.zmiany": "Ze zmianami",
  "hr.kat.nowi": "Nowi",
  "hr.kat.przywroceni": "Do przywrócenia",
  "hr.kat.bezAutomatu": "Bez automatu",
  "hr.kat.bezKarty": "Bez numeru karty",
  "hr.kat.zlyNumer": "Błędny numer karty",
  "hr.kat.zdublowani": "Ta sama karta w HR+",
  "hr.kat.tylkoUNas": "Tylko w Vendi",
  "hr.zmianyNazwy": "nazwa: {n}",
  "hr.zmianyMpk": "MPK: {n}",
  "hr.doOdblokowania": "odblokowanie: {n}",
  "hr.doZablokowania": "blokada: {n}",
  "hr.noweMpk": "MPK spoza słownika: {n}",
  "hr.dlugieNazwy": "Nazwy obcięte do 50 znaków: {n}",
  "hr.zaDlugieMpk": "MPK dłuższe niż 50 znaków: {n}",
  "hr.zakladkaJest": "Zakładka Vending: jest",
  "hr.zakladkaBrak": "HR+ nie wysyła zakładki Vending — w serwisie Vendi (Dane) odznacz wszystkie pola. Do tego czasu nikogo nie zakładamy",
  "hr.zmianyAliasu": "dodatkowe informacje: {n}",
  "hr.zmianyFlag": "flagi: {n}",
  "hr.zmianyGrup": "grupy: {n}",
  "hr.zmianyAutomatow": "automaty: {n}",
  "hr.obceIdentyfikatory": "Grupa albo automat spoza tej wyspy — lista bez zmian: {n}",
  "hr.zlyBlok": "Nieczytelna zakładka Vending — bez zmian: {n}",
  "hr.bezBloku": "Bez zakładki Vending: {n}",
  "hr.kol.numer": "Karta",
  "hr.kol.nazwa": "Nazwa z HR+",
  "hr.kol.uwagi": "Zmiany / powód",
  "hr.pierwsze": "Pierwsze {n} z {z}",
  "hr.stan.wlaczona": "Włączona — HR+ prowadzi pracowników tej wyspy",
  "hr.wlaczonaOd": "od {kiedy}",
  "hr.nadpisze": "Dane z HR+ (nazwa, MPK, blokada) nadpisują ręczne zmiany — poprawki rób w HR+.",
  "hr.wstrzymane": "Wstrzymane: paczka odcięłaby od automatów {n} osób (próg {p})",
  "hr.wstrzymaneZ": "Wstrzymane: paczka odcięłaby od automatów {n} z {z} osób ({pct}%)",
  "hr.powod.PUSTA_LISTA": "HR+ podał pustą listę pracowników",
  "hr.powod.PROG": "Ponad próg {p} osób",
  "hr.powod.PROCENT": "Ponad {pct}% osób z HR+",
  "hr.czekaOd": "czeka od {kiedy}",
  "hr.zgodaTytul": "Zezwolić na tę paczkę?",
  "hr.kol.osoba": "Osoba",
  "hr.kol.jak": "Co traci",
  "hr.jak.BLOKADA": "Blokada",
  "hr.jak.AUTOMATY": "Wszystkie automaty",
  "hr.wylaczonaPoZmianie": "Zmieniono adres lub serwis — integracja wyłączona",
  "hr.liczby": "Z HR+: {z} (zablokowanych {zb}) · Spoza HR+: {s} (aktywnych {sa}, wyjątki {w}, zablokowanych przez przełącznik {sz})",
  "hr.eksport": "Eksport dla HR+",
  "emp.hr.WYJATEK": "Wyjątek HR+",
  "emp.hr.SPOZA_ZABLOKOWANA": "Spoza HR+ · zablokowana",
  "emp.hr.filtrWyjatki": "Wyjątki",
  "emp.hr.ustawWyjatek": "Nie blokuj (poza HR+)",
  "emp.hr.zdejmijWyjatek": "Zdejmij wyjątek HR+",
  "emp.hr.wyjatekUstawiony": "Wyjątek ustawiony — osoba spoza HR+ nie będzie blokowana",
  "emp.hr.wyjatekZdjety": "Wyjątek zdjęty",
  "hr.blokujSpoza": "Blokuj osoby spoza HR+",
  "hr.wyjatkiGrup": "Nie blokuj członków grup:",
  "hr.spozaPodglad": "Spoza HR+: do blokady {b} · wyjątki {w} · do odblokowania {o}",
  "hr.jak.SPOZA": "Spoza HR+",
  "hr.przepusc": "Zezwól",
  "hr.przepuszczono": "Zezwolono — synchronizacja w toku",
  "hr.ostatniPrzebieg": "Ostatni przebieg {kiedy}: {opis}",
  "hr.uzgodnienie": "Pełne wyrównanie: {kiedy}",
  "hr.synchronizuj": "Synchronizuj teraz",
  "hr.zsynchronizowano": "Zsynchronizowano",
  "hr.wlacz": "Włącz integrację",
  "hr.wlaczTytul": "Włączyć integrację z HR+?",
  "hr.wlaczOpis": "HR+ będzie dodawać, nadpisywać i blokować pracowników tej wyspy. Ręczne zmiany tych danych zostaną nadpisane.",
  "hr.wlaczBezpiecznik": "Paczka, która odcięłaby od automatów więcej niż {p} osób albo ponad 20% ludzi z HR+ (blokada albo odebranie wszystkich automatów), poczeka na zatwierdzenie. Pusta lista z HR+ — zawsze.",
  "hr.wlaczono": "Włączono — pierwsza synchronizacja w toku",
  "hr.wylacz": "Wyłącz",
  "hr.wylaczono": "Wyłączono",
  "hr.progBlokad": "Bezpiecznik: odciętych w paczce",
  "hr.zakladajMpk": "Wpisuj nowe MPK",
  "nav.accounts": "Konta i API",
  "nav.agents": "Agenci",
  "nav.alerts": "Alerty",
  "nav.assignments": "Dostęp do automatów",
  "nav.authoring": "Działania na bazie",
  "nav.backups": "Kopia zapasowa",
  "nav.changes": "Zmiany w toku",
  "nav.costCenters": "Centra kosztowe",
  "nav.dashboard": "Pulpit",
  "nav.employees": "Pracownicy",
  "nav.groups": "Grupy",
  "nav.itemGroups": "Grupy artykułów",
  "nav.items": "Artykuły",
  "nav.machines": "Automaty",
  "nav.limits": "Limity",
  "nav.permissions": "Limity",
  "nav.planogram": "Planogram",
  "nav.programy": "Programy",
  "nav.recordings": "Nagrania",
  "nav.hrplus": "HR+",
  "nav.reports": "Raportowanie",
  "nav.section.admin": "Administracja",
  "nav.section.people": "Ludzie",
  "nav.section.stock": "Asortyment",
  "nav.service": "Logi i statystyki",
  "nav.settings": "Ustawienia instancji",
  "nav.smartSync": "Smart Sync",
  "nav.transactions": "Transakcje",
  "obraz.akcja": "Zdjęcie artykułu",
  "obraz.brakWBibliotece": "portal nie ma tego pliku",
  "obraz.dodajZKomputera": "Dodaj z komputera",
  "obraz.dodano": "Dodano {plik} do portalu ({kb} kB). Na automaty trafi po przypisaniu do artykułu.",
  "obraz.dodanoNadpisano": "Podmieniono {plik} w portalu ({kb} kB). Automaty mają starą wersję, dopóki nie wyślesz go ponownie.",
  "obraz.galeriaBrakWynikow": "Nic nie pasuje.",
  "obraz.galeriaObecny": "— obecne",
  "obraz.galeriaPusta": "W portalu nie ma jeszcze zdjęć. Pobierz je z automatu w „Zarządzaj zdjęciami” albo wgraj z komputera.",
  "obraz.galeriaSzukaj": "Szukaj po nazwie pliku, np. P0496",
  "obraz.galeriaUzywa": "artykułów: {n}",
  "obraz.galeriaGrup": "grup: {n}",
  "obraz.tytulGrupy": "Obrazek grupy",
  "obraz.zaDlugaDlaGrupy": "Nazwa pliku dla grupy: najwyżej {n} znaków",
  "obraz.galeriaWiecej": "Lista jest ucięta — wpisz więcej znaków.",
  "obraz.galeriaWybrany": "To zdjęcie trafi na wszystkie automaty.",
  "obraz.indeks": "nr u dostawcy",
  "obraz.indeksHint": "Szukaj zdjęcia po tym numerze",
  "obraz.nadpiszZgoda": "Zastąp",
  "obraz.nadpiszeNiezmierzone": "Nie sprawdzono: {maszyny}.",
  "obraz.nadpiszeOstrzezenie": "Plik {plik} jest już na tych automatach i zostanie zastąpiony:",
  "obraz.nazwa": "Nazwa pliku",
  "obraz.nazwaHint": "Zwykle nr u dostawcy, np. P04966198.jpg — litery, cyfry, kropka, myślnik i podkreślenie.",
  "obraz.nazwaPytanie": "Zmienić nazwę {z} → {na} tylko w portalu?\n\nArtykuły z tym zdjęciem zostaną przy starej nazwie, a automaty dalej pokażą stary plik.",
  "obraz.nazwaPytanieZPrzypisaniem": "Zmienić nazwę {z} → {na}?\n\nArtykuły ({n}) dostaną nową nazwę, a plik pojedzie na wszystkie automaty. Zmiana wejdzie, gdy potwierdzą wszystkie. Stary plik zostaje na automatach.",
  "obraz.nazwaZmieniona": "Zmieniono nazwę w portalu: {z} → {na}",
  "obraz.nazwaZmienionaZPrzypisaniem": "Zmieniono nazwę: {z} → {na}. Plik jedzie na automaty ({automatow}), artykuły ({n}) zmienią się po potwierdzeniu.",
  "obraz.nowaNazwa": "Nowa nazwa pliku",
  "obraz.poprawionoNazwe": "Zapisano jako {na} zamiast {z}, bo plik jest w formacie {format}.",
  "obraz.postep": "Na automatach: {n} z {m}",
  "obraz.szczegolyBezBajtow": "Portal zna tylko nazwę tego pliku — nie ma samego zdjęcia.",
  "obraz.szczegolyNaAutomatach": "Na automatach:",
  "obraz.szczegolyNiezmierzone": "Nie sprawdzono: {maszyny}.",
  "obraz.szczegolyNigdzie": "na żadnym ze sprawdzonych",
  "obraz.szczegolyPlik": "{kb} kB · skąd: {zrodlo} · zmieniono {kiedy}",
  "obraz.szczegolyTowary": "Artykuły ({n}):",
  "obraz.takzePrzypisane": "Zmień też w artykułach",
  "obraz.takzePrzypisaneOpis": "Artykuły z tym zdjęciem dostaną nową nazwę pliku, a plik pojedzie na automaty. Bez tego zmieni się tylko nazwa w portalu.",
  "obraz.tytul": "Zdjęcie artykułu",
  "obraz.usun": "Usuń z portalu",
  "obraz.usunGrupy": "Kafelek tracą też grupy artykułów ({n}).",
  "obraz.usunPytanie": "Usunąć {plik} z portalu?\n\nKorzystają z niego artykuły ({n}) — stracą zdjęcie, a automaty pokażą puste miejsce. Pliki na automatach zostają. Tego nie da się cofnąć jednym kliknięciem.",
  "obraz.usunieto": "Usunięto {plik}; artykuły bez zdjęcia: {n}",
  "obraz.syn.bezBajtow": "Portal nie ma tych plików, więc ich nie wyśle ({n}): {pliki}",
  "obraz.syn.bezPomiaru": "Nie sprawdzono: {maszyny}. Bez tego nie wiadomo, czego im brakuje — sprawdź je albo pomiń.",
  "obraz.syn.coRobi": "Kładzie brakujące pliki na automatach. Nie zmienia zdjęć przypisanych do artykułów — „inne zdjęcie” zostanie.",
  "obraz.syn.nicDoWyslania": "Nie ma czego wysyłać",
  "obraz.syn.odznaczWszystko": "Odznacz wszystko",
  "obraz.syn.opis": "Wysyła z portalu pliki, których brakuje na automatach.",
  "obraz.syn.pomijajBezPomiaru": "Pomiń niesprawdzone",
  "obraz.syn.pominieteBezBajtow": "Pominięte, bo portal ich nie ma: {pliki}",
  "obraz.syn.podsumowanie": "plików: {plikow}, wysyłek: {par}",
  "obraz.syn.przycisk": "Wyślij brakujące na automaty",
  "obraz.syn.tytul": "Wysyłanie brakujących zdjęć",
  "obraz.syn.wiersz": "brakuje na ({maszyn}): {gdzie} · artykułów: {towarow}",
  "obraz.syn.wszystkoZgodne": "Wszystkie pliki są na wszystkich sprawdzonych automatach.",
  "obraz.syn.wyslij": "Wyślij",
  "obraz.syn.zaDuzoPar": "To {par} wysyłek, a naraz można {limit}. Odznacz część plików.",
  "obraz.syn.zaznaczWszystko": "Zaznacz wszystko",
  "obraz.syn.zlecone": "Wysyłamy plików: {plikow}, na automaty: {automatow}",
  "obraz.wyslany": "Wysyłamy zdjęcie na automaty: {n}",
  "obraz.wyslij": "Wyślij na automaty",
  "obraz.zaDuzy": "Zdjęcie jest za duże — najwyżej {n} MB.",
  "obraz.skad.najwiecej": "najwięcej zdjęć",
  "obraz.skad.nieSprawdzano": "nie sprawdzano",
  "obraz.skad.niezmierzone": "poza ostatnim sprawdzeniem: {n}",
  "obraz.skad.niktNieMierzony": "Żaden automat nie był sprawdzany — sprawdź je w zakładce „Na automatach”.",
  "obraz.skad.pomiar": "zdjęć: {ma}, braków: {brak} — sprawdzono {kiedy}",
  "obraz.skad.tytul": "Z którego automatu pobrać",
  "obraz.skad.wybranyBezSpisu": "Tego automatu nie sprawdzano.",
  "obraz.skad.wybranyPusty": "Ten automat nie ma żadnego zdjęcia — pobieranie nic nie da.",
  "obraz.skad.zgraj": "Pobierz z tego automatu",
  "obraz.zgraj": "Pobierz z automatu do portalu",
  "obraz.zgrajOpis": "Pobiera do portalu zdjęcia przypisane do artykułów na wybranym automacie.",
  "obraz.zgraneNicNowego": "Portal ma już wszystkie zdjęcia z tego automatu ({n}).",
  "obraz.zgraneZlecone": "Pobieramy plików: {plikow} ({wezel}).",
  "obraz.zmienNazwe": "Zmień nazwę",
  "obraz.teraz": "Teraz na automatach",
  "obraz.brakZdjecia": "Ten artykuł nie ma jeszcze zdjęcia.",
  "obraz.brakObrazkaGrupy": "Ta grupa nie ma jeszcze obrazka.",
  "obraz.zPortalu": "Zdjęcia w portalu",
  "obraz.zKomputera": "Z komputera",
  "obraz.upusc": "Przeciągnij zdjęcie tutaj albo kliknij, żeby wybrać plik",
  "obraz.zapiszeJako": "Zapisze się jako",
  "obraz.zmienNazwePliku": "Zmień nazwę",
  "obraz.wybierzInne": "Wybierz inne zdjęcie",
  "obraz.gotowe": "Gotowe — zdjęcie jest na wszystkich automatach.",
  "obraz.zmieniSie": "Zdjęcie zmieni się, gdy dotrze do wszystkich automatów.",
  "obraz.ponow": "Ponów",
  "obraz.ponowiono": "Ponawiamy wysyłkę na automaty: {n}",
  "obraz.stan.DONE": "jest",
  "obraz.stan.QUEUED": "czeka w kolejce",
  "obraz.stan.OFFLINE": "czeka — automat nie odzywa się od {kiedy}",
  "obraz.stan.W_TOKU": "w trakcie",
  "obraz.stan.FAILED": "nie udało się",
  "obraz.lista.czeka": "Zdjęcie w drodze — czeka na: {automaty}",
  "obraz.lista.blad": "Zdjęcie nie dotarło na: {automaty} — otwórz, żeby ponowić",
  "obraz.lista.bladKrotko": "błąd",
  "ops.action": "Operacje systemowe",
  "ops.card": "Numer karty",
  "ops.code.AML": "Przypisanie automatu do lokalizacji",
  "ops.code.CC": "Inwentaryzacja cykliczna",
  "ops.code.CPV": "Zmiana uprawnień",
  "ops.code.CPW": "Zmiana hasła",
  "ops.code.DBS": "RFID Insta-track",
  "ops.code.DD": "Odpięcie towaru od szuflady",
  "ops.code.FIW": "Wydanie bez rozliczenia (free issue)",
  "ops.code.FPR": "Skanowanie odcisku palca",
  "ops.code.IA": "Korekta stanu magazynowego",
  "ops.code.IST": "Rozpoczęcie przesunięcia magazynowego",
  "ops.code.LR": "Załadunek po regeneracji",
  "ops.code.MOV": "Przesunięcie magazynowe",
  "ops.code.OML": "Otwarcie lokalizacji w automacie",
  "ops.code.REG": "Uzupełnienie — artykuł ogólny",
  "ops.code.REN": "Uzupełnienie — artykuł nowy",
  "ops.code.REU": "Uzupełnienie — artykuł używany",
  "ops.code.REX": "Zapisanie zapytania zewnętrznego",
  "ops.code.RG": "Zwrot do ogólnych",
  "ops.code.RK": "Zwrot klucza",
  "ops.code.RN": "Zwrot do nowych",
  "ops.code.RR": "Zwrot do regeneracji",
  "ops.code.RRG": "Zwrot z regeneracji do ogólnych",
  "ops.code.RRN": "Zwrot z regeneracji do nowych",
  "ops.code.RRS": "Zwrot z regeneracji do złomowania",
  "ops.code.RRU": "Zwrot z regeneracji do używanych",
  "ops.code.RS": "Zwrot do złomowania",
  "ops.code.RS1": "Rezerwacja narzędzia",
  "ops.code.RS2": "Pobranie zarezerwowanego narzędzia",
  "ops.code.RSI": "Zwrot narzędzia z numerem seryjnym",
  "ops.code.RU": "Zwrot do używanych",
  "ops.code.R_R": "Przyjęcie i uzupełnienie",
  "ops.code.SCL": "Ważenie sztuki",
  "ops.code.SCS": "RFID — skanowanie szafy statycznej",
  "ops.code.STD": "Przyjęcie przesunięcia magazynowego",
  "ops.code.SU": "Anulowanie przez administratora",
  "ops.code.UU": "Anulowanie przez użytkownika",
  "ops.code.WEX": "Pobranie z zapytania zewnętrznego",
  "ops.code.WG": "Pobranie — artykuł ogólny",
  "ops.code.WI": "Pobranie do przeglądu",
  "ops.code.WKT": "Pobranie kompletu",
  "ops.code.WN": "Pobranie — artykuł nowy",
  "ops.code.WP": "Pobranie priorytetowe",
  "ops.code.WR": "Pobranie regeneracji — ze skrzyni",
  "ops.code.WRD": "Pobranie regeneracji — z szuflady",
  "ops.code.WS": "Pobranie złomu — ze skrzyni",
  "ops.code.WSD": "Pobranie złomu — z szuflady",
  "ops.code.WU": "Pobranie — artykuł używany",
  "ops.extra": "Dodatkowe operacje",
  "ops.extraCount": "· zaznaczone {n} z {total}",
  "ops.fromGroupsOutside": "Grupy tego pracownika nadają jeszcze kody, których nie ma w słowniku tej instalacji SPS — nie mają swojego wiersza na liście powyżej:",
  "ops.noDictionary": "Portal nie ma jeszcze słownika kodów tej wyspy — agent nie przyniósł tabeli Transactions. Do tego czasu nie ma z czego wybierać.",
  "ops.outsideDictionary": "Te kody są nadane, ale nie ma ich w słowniku tej instalacji. Mogły powstać ręcznie w SPS albo słownik jest odpytywany rzadziej. Odebrać można, nadać ponownie już nie.",
  "ops.saved": "Zmiana dozwolonych operacji zakolejkowana",
  "ops.selected": "nadanych: {n} z {total}",
  "ops.title": "Dozwolone operacje systemowe",
  "ops.unnamedHint": "Znaczenia tego kodu nie potwierdziliśmy — SPS nie trzyma opisów, więc pokazujemy sam kod.",
  "ops.viaGroupCount": "{n} z grup",
  "ops.viaGroupHint": "To uprawnienie wynika też z grupy — odznaczenie tutaj NIE odbierze dostępu. Grupy:",
  "overview.alertsOpen": "Otwarte alerty",
  "overview.cdc": "Tryb CDC",
  "overview.cdcHint": "Jaki mechanizm śledzenia zmian MA baza klienta: „dziennik\" to starsze triggery piszące do SyncChangeTracking, „natywny CT\" to Change Tracking MSSQL. To informacja o bazie, NIE o naszej synchronizacji — agent tego pola nie czyta i czyta tabele własnym kursorem.",
  "overview.changesQueued": "Zmiany w kolejce",
  "overview.client": "Klient",
  "overview.clients": "klientów",
  "overview.clockSkewTitle": "Rozjechany zegar na {n} z {outOf} automatów (próg {min} min).",
  "overview.clockSkewWhy": "Wydania niosą godzinę z zegara automatu, więc trafiają do złego okresu rozliczeniowego, a limity z oknem kroczącym liczą się od przesuniętej granicy. Przy samej maszynie nic tego nie widać.",
  "overview.confirmed": "potwierdzonych",
  "overview.critical": "krytyczne",
  "overview.employees": "Pracownicy",
  "overview.groups": "Wyspy",
  "overview.health": "Stan",
  "overview.healthAgents": "agenci {odpowiada}/{wszystkich}",
  "overview.healthAllOk": "Wszystkie wyspy ({ile}) bez zastrzeżeń — agenci odpowiadają.",
  "overview.healthShowFailed": "Pokaż {ile} nieudanych operacji",
  "overview.healthAttention": "wymaga uwagi",
  "overview.healthDown": "Nie działa: {ile} — {wyspy}",
  "overview.healthFail": "nie działa",
  "overview.healthOk": "bez zastrzeżeń",
  "overview.healthWaiting": "czeka na potwierdzenie: {ile}",
  "overview.healthWarn": "Wymaga uwagi: {ile} — {wyspy}",
  "overview.island": "Wyspa",
  "overview.islands": "Wyspy synchronizacji",
  "overview.items": "Artykuły",
  "overview.last7d": "w ostatnich 7 dniach",
  "overview.lowStock": "Przegródki na wyczerpaniu",
  "overview.machines": "Automaty",
  "overview.noAgent": "bez agenta",
  "overview.online": "online",
  "overview.selected": "wybrana",
  "overview.transactions": "Transakcje",
  "perm.nolimitPotwierdz": "Zdejmij limit",
  "perm.nolimitPytanie": "Zdjąć limit {limit} z „{zakres}\" dla „{kto}\"?\n\nDostęp ZOSTAJE — po tej zmianie ten adresat pobiera ten towar bez ograniczenia ilości.\n\nStarego limitu nie da się przywrócić jednym kliknięciem: trzeba go nadać od nowa. Poprzednie ustawienia zostaną w historii limitu.",
  "picker.more": "Doczytaj kolejnych",
  "planogram.addsMachineItem": "Towaru nie ma jeszcze na tym automacie — zostanie dopisany do VendingMachineItems z wyzerowanymi limitami, tak jak robi to SPS.",
  "planogram.assignDone": "Zakolejkowano zmianę dla {n} przegr.",
  "planogram.assignSelected": "Ustaw zaznaczone",
  "planogram.clearHint": "Usuwa towar z zaznaczonych przegródek. Stan magazynowy przepada razem z wierszem.",
  "planogram.clearItem": "Wyczyść wybór towaru",
  "planogram.clearSelected": "Opróżnij",
  "planogram.column": "Kolumna",
  "planogram.columnExport": "Kolumna (SPS DRAWERNUMBER)",
  "planogram.columnRules": "Reguły kolumny {n}:",
  "planogram.columnsShort": "kolumn:",
  "planogram.compartment": "Przegródka",
  "planogram.compartments": "Przegródki zajęte",
  "planogram.confirmAssign": "Ustawić towar w zaznaczonych przegródkach?",
  "planogram.confirmAssignDesc": "„{item}” trafi do {n} przegr. tego automatu.",
  "planogram.confirmClear": "Opróżnić zaznaczone przegródki?",
  "planogram.confirmClearDesc": "Towar zniknie z {n} przegr. tego automatu.",
  "planogram.confirmSend": "Wyślij zmianę",
  "planogram.confirmStockLoss": "Przepadnie {n} szt. stanu magazynowego. Numer towaru jest częścią klucza w SPS, więc podmiana to skasowanie wiersza i wstawienie nowego — dokładnie tak samo robi to SPS i tak samo ostrzega.",
  "planogram.d3.labels": "Etykiety",
  "planogram.d3.reset": "Wyśrodkuj bęben",
  "planogram.d3.restock": "do uzupełnienia",
  "planogram.d3.rotate": "Obrót bębna",
  "planogram.d3.threshold": "próg SPS:",
  "planogram.d3v2.awaria": "Nie udało się uruchomić widoku 3D",
  "planogram.d3v2.awariaOpis": "Reszta ekranu działa normalnie — przełącz się na siatkę albo na starszy widok bębna. Poniżej treść błędu; przyda się przy zgłoszeniu.",
  "planogram.d3v2.brakWebgl": "Ta przeglądarka nie udostępnia grafiki 3D (WebGL)",
  "planogram.d3v2.brakWebgl.krok1": "Ustawienia → Ogólne → Wydajność: odznacz „Używaj zalecanych ustawień wydajności\" i zaznacz „Używaj przyspieszenia sprzętowego, jeśli jest dostępne\".",
  "planogram.d3v2.brakWebgl.krok2": "Wpisz w pasku adresu about:support i znajdź sekcję Grafika — tam widać wprost, czy WebGL jest zablokowany i z jakiego powodu (zwykle wersja sterownika karty).",
  "planogram.d3v2.brakWebgl.krok3": "Uruchom przeglądarkę ponownie. Jeśli nadal nie działa, powód z about:support wystarczy do zgłoszenia.",
  "planogram.d3v2.brakWebglOpis": "To ustawienie przeglądarki albo sterownika karty, nie usterka portalu — reszta ekranu działa normalnie, a bęben obejrzysz w starszym widoku albo na siatce. W Firefoksie najczęściej wystarczy:",
  "planogram.d3v2.ladowanie": "Wczytuję widok 3D…",
  "planogram.d3v2.przejdzDoStarego": "Pokaż starszy widok bębna",
  "planogram.d3v2.sterowanie": "lewy przycisk = obrót bębna · prawy = orbita kamery · kółko = zbliżenie · klik = zaznaczenie przegródki",
  "planogram.deselect": "Odznacz",
  "planogram.detailsTitle": "Szczegóły przegródki",
  "planogram.dispense": "Wyd.",
  "planogram.dispenseHint": "Ile sztuk zabiera jedno pobranie (SPS QTYDISP). Towar pakowany po pięć i wyjmowany w całości ma tu 5, nie 1.",
  "planogram.drawer": "Szuflada",
  "planogram.drawers": "Szuflady",
  "planogram.drum": "Bęben {n}",
  "planogram.drumExport": "Bęben (PICNUMBER)",
  "planogram.drumExtension": "dostawka",
  "planogram.drumMain": "szafa maszyny",
  "planogram.editSection": "Zmiana w {n} przegr.",
  "planogram.effectEmptyNow": "Przegródki dziś puste",
  "planogram.effectReplaced": "Podmiana towaru (DELETE + INSERT)",
  "planogram.effectSameItem": "Już mają ten towar (same limity)",
  "planogram.emptySlot": "przegródka pusta",
  "planogram.enforceHint": "Reguła SPS „pełne wydanie”: pobranie zabiera całą ilość maksymalną, a nie pojedynczą sztukę.",
  "planogram.enforceHintDrum": "Reguła SPS „pełne wydanie”. UWAGA: na tej konstrukcji (DynaBox) mieszka ona w jednym wierszu Drawers na cały bęben, więc zmiana obejmie WSZYSTKIE kolumny tego bębna, nie tylko zaznaczoną.",
  "planogram.enforceLabel": "Wydawanie całej zawartości",
  "planogram.enforceOff": "Wyłącz wydawanie całości",
  "planogram.enforceOn": "Włącz wydawanie całości",
  "planogram.enforceScopeDrum": "pełne wydanie dotyczy całego bębna",
  "planogram.fill": "Zapełnienie",
  "planogram.findClear": "Wyłącz podświetlanie",
  "planogram.findHits": "podświetlone: {n}",
  "planogram.findItem": "Znajdź towar…",
  "planogram.grid": "Siatka (kolumny × wiersze)",
  "planogram.group": "Grupa",
  "planogram.isolateHint": "Kliknij, aby wyróżnić tylko tę grupę",
  "planogram.item": "Towar",
  "planogram.itemNumber": "Numer towaru",
  "planogram.itemsNarrow": "wpisz fragment nazwy, żeby zobaczyć pozostałe",
  "planogram.itemsShown": "pokazano {n} z {total}",
  "planogram.keepCurrent": "bez zmian",
  "planogram.lastColumnAssumed": "Ostatnia kolumna: szerokości nie da się wyznaczyć, bo nie ma za nią następnej. Przyjęto jedno miejsce.",
  "planogram.legendGroups": "Trzy najliczniejsze grupy mają własny kolor, pozostałe są neutralne — więcej odcieni w siatce przestaje być rozróżnialne. Kliknij dowolną grupę, żeby wyróżnić ją samą.",
  "planogram.low": "Na wyczerpaniu",
  "planogram.lowWithThreshold": "Na wyczerpaniu (≤{pct}% zapełnienia)",
  "planogram.machine": "Automat",
  "planogram.mapa": "Mapa",
  "planogram.mapaBezGrupy": "bez grupy",
  "planogram.mapaBrakWiersza": "brak wiersza",
  "planogram.mapaLegenda": "Legenda — numer w przegródce odpowiada numerowi tutaj",
  "planogram.mapaLegendaPusta": "W tym bębnie nie ma ani jednego przypisanego towaru.",
  "planogram.mapaPoGrupie": "Kolor po grupie artykułów",
  "planogram.mapaPoGrupieOpis": "kilka kolorów zamiast kilkudziesięciu — widać rodzaj towaru",
  "planogram.mapaPoTowarze": "Kolor po towarze",
  "planogram.mapaPoTowarzeOpis": "każdy towar innym kolorem — widać, gdzie leży ten jeden",
  "planogram.mapaSzt": "szt.",
  "planogram.mapaTytul": "Mapa szafy do PDF — jedna strona na bęben",
  "planogram.mapaWLegendzie": "przegródek: {n} · maks. {m} szt.",
  "planogram.mapaWygenerowano": "Wygenerowano: {data} · towarów: {t} · zajętych przegródek: {p}",
  "planogram.max": "Maks.",
  "planogram.maxHint": "Pojemność przegródki. Puste = zostaje tyle, ile było; przy pustej przegródce trzeba podać.",
  "planogram.mode.groups": "Grupy",
  "planogram.mode.stock": "Zapełnienie",
  "planogram.moduleOnlyOne": "Ten automat ma tylko jeden moduł",
  "planogram.modulePick": "Moduł:",
  "planogram.needsMachinesPermission": "Ten ekran potrzebuje listy automatów, a Twoje konto nie ma uprawnienia „Automaty”. Poproś administratora o dodanie go — bez niego nie da się wybrać automatu.",
  "planogram.noCompartment": "w tej kolumnie nie ma takiego wiersza",
  "planogram.noItemsFound": "Nic nie pasuje",
  "planogram.noMachines": "Ta wyspa nie ma jeszcze żadnego automatu, więc nie ma czego pokazać.",
  "planogram.orientationNotice": "Kolumny to przegrody bębna (standardowo 36), wiersze to szuflady (13). Kolumna poszerzona blachą zajmuje 2 albo 3 miejsca i wtedy numeracja przeskakuje — po kolumnie 1 ×2 następna jest 3. Uwaga na nazwy: SPS nazywa kolumnę „szufladą” (DRAWERNUMBER), a wiersz „przegródką” (COMPARTMENTNUMBER), czyli odwrotnie niż fizycznie.",
  "planogram.other": "Inne",
  "planogram.qty": "Stan",
  "planogram.queuedNotice": "Zmiana trafi do kolejki i pojedzie na automat przy najbliższej synchronizacji. Planogram pokaże ją od razu.",
  "planogram.row": "Wiersz",
  "planogram.rowExport": "Wiersz (SPS COMPARTMENTNUMBER)",
  "planogram.rulesDone": "Zakolejkowano zmianę reguł kolumny.",
  "planogram.rulesDoneDrum": "Zakolejkowano zmianę reguł — pełne wydanie objęło cały bęben.",
  "planogram.sameAsMax": "= Maks.",
  "planogram.searchItem": "Szukaj towaru...",
  "planogram.selectColumnHint": "Kliknij numer kolumny, żeby zaznaczyć albo odznaczyć całą kolumnę",
  "planogram.selectWholeColumns": "Zaznacz całe kolumny",
  "planogram.selectedBreakdown": "{withItem} z towarem, {empty} pustych",
  "planogram.selectedCount": "Zaznaczono: {n} przegr.",
  "planogram.slots": "Miejsc w bębnie",
  "planogram.slotsAtMost": "miejsc: co najwyżej {n}",
  "planogram.slotsExact": "miejsc: {n}",
  "planogram.slotsTotal": "Miejsc w bębnach (razem)",
  "planogram.spsCoords": "Współrzędne SPS",
  "planogram.stock": "Stan",
  "planogram.stock.low": "krytycznie mało (≤25%)",
  "planogram.stock.mid": "mało (≤50%)",
  "planogram.stock.ok": "w normie (>50%)",
  "planogram.stock.out": "brak (0)",
  "planogram.stockLost": "utracony stan: {n} szt.",
  "planogram.stockNotice": "Stan magazynowy (QTYCURRENT) należy do automatu i portal go nie ustawia — pokazujemy go, ale zmieniać można towar i limity. Podmiana towaru kasuje stan przegródki, bo numer towaru jest częścią klucza w SPS.",
  "planogram.suspiciousColumns": "Kolumny {list} mają przeskok większy niż 3 miejsca. To raczej brakujący wiersz w bazie klienta niż poszerzenie — rysujemy je na trzy miejsca, ale liczba w nagłówku jest prawdziwa.",
  "planogram.tooManySelected": "Zaznaczenie przekracza {limit} przegr. — jedna operacja tyle nie obejmie. Odznacz część i wyślij w kilku turach.",
  "planogram.uniformColumnHint": "Kolumna ma regułę jednolitej zawartości: w SPS wszystkie jej przegródki trzymają ten sam towar, a skasowanie jednej kasuje wszystkie.",
  "planogram.uniformDropped": "Z kolumn {list} zostanie ZDJĘTA reguła „jeden towar w kolumnie”. Inaczej ta zmiana skasowałaby całą ich zawartość — SPS przy tej regule usuwa wszystkie 13 przegródek, gdy zniknie jedna. Regułę można włączyć z powrotem jednym kliknięciem.",
  "planogram.uniformLabel": "Jeden towar w całej kolumnie",
  "planogram.uniformOff": "Wyłącz jeden towar w kolumnie",
  "planogram.uniformOn": "Włącz jeden towar w kolumnie",
  "planogram.uniformPartialWarning": "Kolumny {list} mają regułę „jeden towar w kolumnie”, a zaznaczenie obejmuje tylko ich część. Reguła zostanie z nich ZDJĘTA — inaczej SPS przy tej zmianie skasowałby całą zawartość kolumny, bo usunięcie jednej przegródki usuwa przy niej wszystkie 13. Zaznaczone przegródki dostaną nowy towar, reszta kolumny zostaje bez zmian.",
  "planogram.uniformToggleHint": "Reguła SPS „jednolita zawartość”: cała kolumna trzyma ten sam towar. Przy włączonej regule skasowanie jednej przegródki kasuje wszystkie 13. Nie da się jej włączyć na kolumnie, w której leżą różne towary — SPS też tego nie pozwala.",
  "planogram.uniformUnknown": "reguły tej kolumny jeszcze nie znamy — agent nie przysłał ustawień kolumn",
  "planogram.view.beben": "Bęben 3D",
  "planogram.view.beben3dv2": "3D_V2",
  "planogram.view.siatka": "Siatka",
  "planogram.wide": "Kolumna poszerzona blachą — zajmuje {n} miejsca bębna",
  "podgladM.czekamy": "Poprosiliśmy agenta o ten plik — obraz przyjdzie w jego cyklu (do kilku minut).",
  "podgladM.nieudane": "Agent nie oddał pliku i nie podał powodu.",
  "podgladM.opis": "{maszyna} — plik „{plik}\" czytany wprost z katalogu grafik tej maszyny.",
  "podgladM.ponow": "Poproś ponownie",
  "podgladM.stopka": "{plik} · {wezel} · {kb} kB · obraz nie jest u nas przechowywany, wygasa po kwadransie",
  "podgladM.tytul": "Co leży na maszynie",
  "podgladM.wygasl": "Obraz już wygasł — trzymamy go kwadrans, bo to plik z dysku klienta. Poproś o niego ponownie.",
  "potw.nieodwracalne": "Tej operacji nie da się cofnąć.",
  "profile.access": "Dostęp do produktów",
  "profile.accessNone": "Brak wpisów dostępu obejmujących tę osobę. Czy to blokuje pobranie, zależy od ustawień automatu (REST_ENABLED / REST_DENY) — pokazuje je ekran Uprawnień.",
  "profile.accessUnknown": "Dodatkowo {n} wpisów o masce, której nie rozpoznajemy — mogły dotyczyć tej osoby, więc ich nie pomijamy po cichu. Szczegóły w Uprawnieniach.",
  "profile.allTransactions": "Wszystkie transakcje",
  "profile.back": "Pracownicy",
  "profile.blockedWarn": "Konto zablokowane (ALLOWLOGIN = 0). Ta osoba nie zaloguje się do żadnego automatu, niezależnie od limitów i przypisań poniżej.",
  "profile.data": "Dane pracownika",
  "profile.dateRange": "Konto ważne w zakresie dat: od {od} do {do}. Poza nim automat nie wpuści tej osoby.",
  "profile.direct": "osobiście",
  "profile.flagsNone": "żaden",
  "profile.flagsOn": "Znaczniki włączone",
  "profile.fromAll": "wpis na wszystkich pracowników",
  "profile.fromGroup": "przez grupę {name}",
  "profile.fromPerson": "wpis na tę osobę",
  "profile.groupMembers": "{n} os.",
  "profile.groups": "Grupy pracownicze",
  "profile.history": "Ostatnie operacje",
  "profile.historyLast": "(ostatnie {n})",
  "profile.historyNone": "Ta osoba nie ma ani jednego wydania w rejestrze.",
  "profile.kpi.issues": "Wydania ({d} dni)",
  "profile.kpi.last": "Ostatnie wydanie",
  "profile.kpi.limits": "Reguły limitu",
  "profile.kpi.limitsHint": "W nawiasie liczba reguł, na których ta osoba nie ma już nic do pobrania.",
  "profile.kpi.machines": "Automaty",
  "profile.kpi.units": "Sztuk",
  "profile.kpi.value": "Wartość",
  "profile.limitEditPersonal": "Limit imienny — zmienia się w Limitach, w sekcji tej osoby.",
  "profile.limitFromGroupEdit": "Limit z grupy — zmienia się w Uprawnieniach, ze skutkiem dla całej grupy.",
  "profile.limitEmpty": "wyczerpany",
  "profile.limitFromIssues": "z {n} wydań",
  "profile.limitLeft": "zostało {n}",
  "profile.limitOver": "przekroczony",
  "profile.limitPerWindow": "szt. w oknie {okno}",
  "profile.limitUnenforced": "Automat (SPSUI) egzekwuje tylko okna minutowe, godzinowe, dzienne i tygodniowe. Ta reguła istnieje w bazie, ale nikt jej nie pilnuje.",
  "profile.limits": "Limity wydawania",
  "profile.limitsNone": "Żadna reguła limitu nie obejmuje tej osoby — ani wprost, ani przez jej grupy. Automat nie ogranicza jej ilości.",
  "profile.limitsOutOfScope": "Ta wyspa ma dodatkowo {n} reguł celujących w zadanie albo automat — nie da się ich przypisać do osoby, ale przy wydaniu mogą obowiązywać.",
  "profile.machines": "Dostęp do automatów",
  "profile.narrowed": "zawężony",
  "profile.narrowedHint": "Ten wpis jest dodatkowo zawężony kolumnami: {cols}. Obowiązuje więc węziej, niż widać tutaj — zmieniać go można tylko w SPSUtilities.",
  "profile.noAccess": "bez dostępu",
  "profile.noLimit": "bez limitu",
  "profile.noMachineWarn": "Ta osoba nie ma dostępu do ŻADNEGO automatu — ani bezpośrednio, ani przez grupę. Nie pobierze niczego nigdzie.",
  "profile.notFound": "Nie znaleziono tego pracownika",
  "profile.notFoundHint": "Karta należy do innej wyspy albo pracownik został usunięty. Sprawdź wybraną wyspę w prawym górnym rogu.",
  "profile.open": "Otwórz kartę pracownika",
  "profile.opsNone": "Ta osoba nie ma nadanej żadnej operacji systemowej — ani własnej, ani z grupy.",
  "profile.orphanIssues": "Dodatkowo {n} wydań z tym numerem karty nie ma w portalu dowiązanego pracownika (trafiły do rejestru, zanim katalog znał tę kartę). Nie wchodzą do liczb powyżej ani do limitów.",
  "profile.pending": "zmiana w kolejce",
  "profile.rationOffWarn": "RATIONEFFECT = {n}: automat NIE pilnuje limitów tej osoby. Reguły niżej istnieją w bazie, ale przy maszynie nikt ich nie egzekwuje.",
  "profile.scopeAll": "wszystkie produkty",
  "profile.scopeGroup": "grupa produktów",
  "profile.scopeItem": "produkt",
  "profile.scopeSubGroup": "podgrupa produktów",
  "profile.viaGroup": "przez grupę",
  "profile.withLimit": "z limitem",
  "ptok.colCreated": "Wydany",
  "ptok.colLabel": "Opis",
  "ptok.colLastUsed": "Ostatnie użycie",
  "ptok.colScopes": "Zakres",
  "ptok.colStatus": "Stan",
  "ptok.colUses": "Użyć",
  "ptok.copied": "Token skopiowany do schowka",
  "ptok.copy": "Kopiuj",
  "ptok.copyFailed": "Nie udało się skopiować — przepisz token z ekranu",
  "ptok.create": "Wydaj token",
  "ptok.empty": "Nie wydano jeszcze żadnego tokenu — żaden zewnętrzny system nie sięgnie po API tej instancji.",
  "ptok.hide": "Ukryj",
  "ptok.label": "Opis",
  "ptok.labelHint": "np. Vending+ — produkcja",
  "ptok.noScope": "brak zakresu",
  "ptok.noScopeHint": "Token bez zakresu nie wejdzie na żadną trasę. Odwołaj go i wydaj nowy z zakresem.",
  "ptok.onceWarning": "Ten token widzisz JEDEN RAZ. Nie da się go odzyskać — serwer przechowuje wyłącznie skrót. Zgubiony token się odwołuje i wydaje nowy.",
  "ptok.revoke": "Odwołaj",
  "ptok.revokePytanie": "Odwołać token „{label}\" ({prefiks}…)?\n\nOdwołanie działa NATYCHMIAST i nie da się go cofnąć — integracja, która tym tokenem chodzi, dostanie 401 przy następnym wywołaniu i wróci dopiero z nowym tokenem po swojej stronie.\n\nUżyć do tej pory: {uzyc}.",
  "ptok.revokeHint": "Odwołanie działa natychmiast i jest nieodwracalne. Wpis zostaje, żeby nie zginął ślad, że token istniał.",
  "ptok.revoked": "Token odwołany",
  "ptok.scopeEdit": "Zakres",
  "ptok.scopeEditHint": "Zmień uprawnienia tego tokenu bez wydawania nowego — sekret zostaje ten sam",
  "ptok.scopeEditTitle": "Uprawnienia tokenu",
  "ptok.scopeEditWhat": "Zmiana działa natychmiast i nie rusza sekretu — druga strona nie musi nic przeklejać ani odświeżać. Zdjęcie uprawnienia też działa od razu: kolejne żądanie w tym zakresie dostanie 403.",
  "ptok.scopeEmpty": "Token bez ani jednego uprawnienia przechodzi uwierzytelnienie i odbija się od każdej trasy — czyli wygląda na sprawny i nie działa. Żeby go wyłączyć, użyj „Odwołaj\".",
  "ptok.scopeSaved": "Zakres tokenu zmieniony — obowiązuje od następnego żądania.",
  "ptok.scopesHint": "Zakres decyduje, co ten token może przeczytać I ZAPISAĆ w bazie klienta. Nadaj wyłącznie to, czego integracja realnie potrzebuje — odwołanie tokenu nie cofa tego, co już zrobił.",
  "ptok.status.AKTYWNY": "aktywny",
  "ptok.status.NIEUZYWANY": "nigdy nieużyty",
  "ptok.status.ODWOLANY": "odwołany",
  "ptok.status.WYGASL": "wygasł",
  "ptok.title": "Tokeny maszynowe (dostęp po API)",
  "ptok.usageHint": "Integracja wysyła go w nagłówku X-Api-Token na /api/v1/... tej instancji; przy zapisie dodaje X-Acting-User z nazwą osoby. Pierwsze wywołanie: GET /api/v1/self — oddaje zakres tokenu i identyfikatory wysp.",
  "ptok.vp.confirmDo": "Wydaj i unieważnij poprzednie",
  "ptok.vp.confirmKills": "Przestaną działać (integracja dostanie 401 przy następnym żądaniu):",
  "ptok.vp.confirmNone": "Nie ma teraz żadnego działającego tokenu — nic nie zostanie unieważnione.",
  "ptok.vp.confirmTitle": "Wydać nowy token Vending+?",
  "ptok.vp.confirmUses": "· użyty {ile}×",
  "ptok.vp.confirmWhat": "Nowy token dostaniesz raz, na ekranie. Poprzednie przestaną działać natychmiast.",
  "ptok.vp.issue": "Wydaj token Vending+",
  "ptok.vp.title": "Token Vending+",
  "ptok.sb.title": "Token SmartBox",
  "ptok.sb.issue": "Wydaj token SmartBox",
  "ptok.sb.confirmDo": "Wydaj i unieważnij poprzednie",
  "ptok.sb.confirmKills": "Przestaną działać (integracja dostanie 401 przy następnym żądaniu):",
  "ptok.sb.confirmNone": "Nie ma teraz żadnego działającego tokenu — nic nie zostanie unieważnione.",
  "ptok.sb.confirmTitle": "Wydać nowy token SmartBox?",
  "ptok.sb.confirmUses": "· użyty {ile}×",
  "ptok.sb.confirmWhat": "Nowy token dostaniesz raz, na ekranie. Poprzednie przestaną działać natychmiast. Klucz Vending+ zostaje nietknięty.",
  "ptok.hr.title": "Token HR+",
  "ptok.hr.issue": "Wydaj token HR+",
  "ptok.hr.label": "Nazwa",
  "ptok.hr.labelHint": "np. HR+ kadry",
  "ptok.hr.labelShort": "Nazwa: co najmniej 3 znaki.",
  "ptok.hr.island": "Wyspa",
  "ptok.hr.confirmDo": "Wydaj i unieważnij poprzedni",
  "ptok.hr.confirmKills": "Przestanie działać (integracja dostanie 401 przy następnym żądaniu):",
  "ptok.hr.confirmNone": "Ta wyspa nie ma teraz działającego tokenu HR+ — nic nie zostanie unieważnione.",
  "ptok.hr.confirmTitle": "Wydać nowy token HR+?",
  "ptok.hr.confirmUses": "· użyty {ile}×",
  "ptok.hr.confirmWhat": "Działa tylko na wybranej wyspie. Token dostaniesz raz, na ekranie. Poprzedni token HR+ tej wyspy przestanie działać natychmiast.",
  "ptok.island": "Wyspa: {nazwa}",
  "ptok.islandGone": "wyspa usunięta",
  "ptok.islandGoneHint": "Wyspę tego tokenu usunięto — token nie działa. Odwołaj go.",
  "ptok.vp.zabite": "Unieważniono poprzednie tokeny: {lista}. Jeśli integracja jeszcze ich używa, przestanie działać do czasu wklejenia nowego.",
  "rap.agentProblem": "Agent zgłasza problem — dane mogą być nieaktualne.",
  "rap.allEmployees": "Wszyscy pracownicy",
  "rap.allGroups": "Wszystkie grupy",
  "rap.allMachines": "Wszystkie automaty",
  "rap.col.capacity": "Maks. pojemność",
  "rap.col.card": "Numer karty",
  "rap.col.code": "Kod",
  "rap.col.employee": "Pracownik",
  "rap.col.item": "Towar",
  "rap.col.itemNumber": "Numer towaru",
  "rap.col.machine": "Automat",
  "rap.col.missing": "Do uzupełnienia",
  "rap.col.places": "Miejsca (szuflada/przegródka)",
  "rap.col.qty": "Ilość",
  "rap.col.stock": "Na stanie",
  "rap.col.supplierPart": "Numer części dostawcy",
  "rap.col.value": "Wartość",
  "rap.col.when": "Kiedy",
  "rap.employee": "Pracownik",
  "rap.employeeNone": "Brak pasujących pracowników",
  "rap.employeePickHint": "Wybierz osobę z listy — sam wpisany tekst zawęża tylko listę, a raport obejmie wszystkich",
  "rap.empty": "Brak pozycji do pokazania.",
  "rap.emptyIssues": "Brak wydań w tym okresie dla wybranych filtrów.",
  "rap.exportTooBig": "Raport ma {total} wierszy, a {format} przyjmuje {limit} — zawęź okres albo filtry. Nie ucinamy pliku po cichu.",
  "rap.fresh": "Dane od agenta „{node}\", sygnał {minut} min temu.",
  "rap.from": "Od",
  "rap.generate": "Generuj raport",
  "rap.godzinaDo": "Godzina końcowa — puste znaczy do końca doby",
  "rap.godzinaOd": "Godzina początkowa — puste znaczy od północy",
  "rap.group": "Grupa pracownicza",
  "rap.harmonogramy": "Harmonogramy",
  "rsps.przycisk": "Raporty w SPS",
  "rsps.tytul": "Raporty w SPS",
  "rsps.tylkoWlaczone": "Tylko włączone",
  "rsps.brakWlaczonych": "Żaden raport nie ma włączonego zadania w Harmonogramie.",
  "rsps.skonfigurowanyNa": "Skonfigurowany na",
  "rsps.innaWersja": "Na tej maszynie ten raport ma inną konfigurację niż pokazana",
  "rsps.zrodlo": "Konfiguracja z {maszyna}, zgłoszona {kiedy}",
  "rsps.brak": "Żaden agent nie zgłosił jeszcze raportów SPS. Potrzebny agent 0.7.226 lub nowszy; odczyt idzie raz na godzinę.",
  "rsps.bezRaportu": "Zadania Harmonogramu bez raportu w konfiguracji",
  "rsps.zbiorczy": "zbiorczy",
  "rsps.tylkoSumy": "tylko sumy",
  "rsps.dataWNazwie": "data w nazwie pliku",
  "rsps.topN": "top {n} wg {pole}",
  "rsps.naglowek": "Nagłówek",
  "rsps.kolumny": "Kolumny",
  "rsps.grupuj": "grupowanie",
  "rsps.suma": "suma",
  "rsps.warunki": "Warunki",
  "rsps.brakWarunkow": "brak",
  "rsps.od": "od",
  "rsps.do": "do",
  "rsps.wysylka": "Wysyłka",
  "rsps.brakWysylki": "bez szablonu wysyłki",
  "rsps.szablonNieznany": "szablonu nie ma w SPS",
  "rsps.dw": "DW:",
  "rsps.harmonogram": "Harmonogram zadań Windows",
  "rsps.brakZadan": "nie ma zadania, które uruchamia ten raport",
  "rsps.maszyna": "Maszyna",
  "rsps.zadanie": "Zadanie",
  "rsps.kiedy": "Kiedy",
  "rsps.parametry": "Parametry",
  "rsps.ostatnio": "Ostatnio",
  "rsps.nastepne": "Następne",
  "rsps.wlaczone": "włączone",
  "rsps.wylaczone": "wyłączone",
  "rsps.konto": "konto",
  "rsps.ok": "OK",
  "rsps.o": "o",
  "rsps.codziennie": "codziennie",
  "rsps.coDni": "co {n} dni",
  "rsps.coTydzien": "co tydzień",
  "rsps.coTygodni": "co {n} tyg.",
  "rsps.coMiesiacDnia": "co miesiąc, dnia {dni}",
  "rsps.coMiesiacTygodnia": "co miesiąc, tydzień {tygodnie}: {dni}",
  "rsps.jednorazowo": "jednorazowo",
  "rsps.przyLogowaniu": "przy logowaniu",
  "rsps.przyStarcie": "przy starcie systemu",
  "rsps.powtarzaj": "powtarzaj co",
  "rsps.dzien.Monday": "pn",
  "rsps.dzien.Tuesday": "wt",
  "rsps.dzien.Wednesday": "śr",
  "rsps.dzien.Thursday": "czw",
  "rsps.dzien.Friday": "pt",
  "rsps.dzien.Saturday": "sob",
  "rsps.dzien.Sunday": "nd",
  "rsps.miesiac.January": "sty",
  "rsps.miesiac.February": "lut",
  "rsps.miesiac.March": "mar",
  "rsps.miesiac.April": "kwi",
  "rsps.miesiac.May": "maj",
  "rsps.miesiac.June": "cze",
  "rsps.miesiac.July": "lip",
  "rsps.miesiac.August": "sie",
  "rsps.miesiac.September": "wrz",
  "rsps.miesiac.October": "paź",
  "rsps.miesiac.November": "lis",
  "rsps.miesiac.December": "gru",
  "rsps.makro.today": "dziś",
  "rsps.makro.yesterday": "wczoraj",
  "rsps.makro.tomorrow": "jutro",
  "rsps.makro.startoflastmonth": "początek poprzedniego miesiąca",
  "rsps.makro.endoflastmonth": "koniec poprzedniego miesiąca",
  "rsps.makro.startofthismonth": "początek bieżącego miesiąca",
  "rsps.makro.startofmonth": "początek miesiąca",
  "rsps.makro.endofmonth": "koniec miesiąca",
  "rsps.makro.startofthisweek": "początek bieżącego tygodnia",
  "rsps.makro.startoflastweek": "początek poprzedniego tygodnia",
  "rsps.makro.endoflastweek": "koniec poprzedniego tygodnia",
  "rsps.makro.startofweek": "początek tygodnia",
  "rsps.makro.endofweek": "koniec tygodnia",
  "rsps.makro.lastrun": "ostatnie uruchomienie",
  "rsps.makro.daybeforelastrun": "dzień przed ostatnim uruchomieniem",
  "rsps.makro.weekagoyesterday": "tydzień przed wczoraj",
  "rsps.makro.weekagotoday": "tydzień temu",
  "rsps.makro.monthagotoday": "miesiąc temu",
  "rsps.makro.monthagoyesterday": "miesiąc przed wczoraj",
  "rap.issuesSummary": "Wierszy: {ile} · wydano {szt} szt. za {wartosc}",
  "rap.kind": "Rodzaj raportu",
  "rap.kind.issues": "Wydania",
  "rap.kind.issuesHint": "Kto co pobrał w zadanym okresie, z filtrami i kolumną automatu.",
  "rap.kind.stock": "Zatowarowanie",
  "rap.kind.stockHint": "Co dowieźć: różnica do pełna. Podsumowanie do magazynu i osobno każdy automat.",
  "rap.machine": "Automat",
  "rap.machineHint": "Do dowiezienia: {brakuje} szt., pozycji na zero: {zero}.",
  "rap.noAgent": "Ta wyspa nie ma agenta bazy, więc stany nie mają skąd się odświeżać.",
  "rap.noEmployee": "nierozpoznany",
  "rap.noItem": "nierozpoznany",
  "rap.notGenerated": "Ustaw parametry i kliknij „Generuj raport\".",
  "rap.outsideRange": "Poza wybranym okresem najnowsze pasujące wydanie jest z {kiedy}.",
  "rap.skipped": "Pominięto przegródek bez pojemności i bez stanu",
  "rap.subtitle": "Co dowieźć: różnica do pełna, per automat i razem do zabrania.",
  "rap.summaryHint": "Suma ze wszystkich automatów wyspy — to jest lista do magazynu.",
  "rap.summaryTitle": "Do zabrania — razem",
  "rap.szybkiZakres": "Szybko:",
  "rap.title": "Stan automatów",
  "rap.to": "Do",
  "rap.zakres.dzis": "Dziś",
  "rap.zakres.miesiac": "Ten miesiąc",
  "rap.zakres.poprzedniMiesiac": "Poprzedni miesiąc",
  "rap.zakres.tydzien": "Ten tydzień",
  "rap.zakres.wczoraj": "Wczoraj",
  "rapw.domyslne": "przywróć domyślne",
  "rapw.dostepne": "Do dołożenia",
  "rapw.gotowe": "Raport gotowy — {n} wierszy",
  "rapw.nizej": "Niżej",
  "rapw.opis": "Plik składa serwer — dokładnie tak, jak pojedzie mailem z harmonogramu. Filtry bierzemy z tego ekranu.",
  "rapw.poza": "poza domyślnymi",
  "rapw.przycisk": "Własne kolumny",
  "rapw.pusto": "Nie wybrano żadnej kolumny — plik nie miałby czego zawierać.",
  "rapw.tytul": "Raport z wybranymi kolumnami",
  "rapw.usun": "Wyjmij z pliku",
  "rapw.wszystkieWybrane": "Wszystkie kolumny są już w pliku.",
  "rapw.wybrane": "W pliku, w tej kolejności",
  "rapw.wyzej": "Wyżej",
  "role.ADMIN": "Administrator",
  "role.USER": "Użytkownik",
  "rozj.bezNazwy": "automat nieznany portalowi",
  "rozj.brakWcale": "nie ma ani jednego wiersza u: {wezly}",
  "rozj.brakuje": "brakuje {ile} u: {wezly}",
  "rozj.dojezdza": "w drodze, jeszcze nie rozjazd",
  "rozj.dojezdzaInfo": "{n} pozycji jest jeszcze „w drodze\" — odśwież za kilka minut, zanim cokolwiek naprawisz.",
  "rozj.dosli": "Dośli brakujące ({n})",
  "rozj.dosliNic": "Nie ma czego dosłać.",
  "rozj.tylkoWKopiach": "{n} tylko w kopiach innych baz — nie rozsyłamy",
  "rozj.zajete": "{n} w przegródkach z innym towarem — nie dosyłamy",
  "rozj.dosliOpis": "Zakolejkuje brakujące wiersze do pozostałych węzłów. Nic nie kasuje — nadmiar zostaje.",
  "rozj.dosliWynik": "Zakolejkowano {n} — dojadą przy najbliższym cyklu agentów.",
  "rozj.grupaBezSkrotu": "bez skrótu (starszy agent): {wezly}",
  "rozj.grupaTresci": "{skrot}: {wezly}",
  "rozj.grupaWlasciciela": " — właściciel",
  "rozj.grupyTresci": "kto ma jaką treść",
  "rozj.innaTresc": "ta sama liczba wierszy, INNA ZAWARTOŚĆ",
  "rozj.innyUklad": "— te same wartości w innych przegródkach",
  "rozj.kolumnyNieznane": "— której kolumny, dowiemy się w kolejnym cyklu (agent 0.7.165+)",
  "rozj.kolumnyRozne": "— różni się: {kolumny}",
  "rozj.nadmiar": "o {ile} wierszy WIĘCEJ u {wezel} — wyrównanie tego nie usunie",
  "rozj.podtytul": "{tabel} tabel na {automatow} automatach.",
  "rozj.pokaz": "pokaż rozjazd",
  "rozj.pozaWyrownaniem": "poza wyrównaniem",
  "rozj.tenBrakuje": "brakuje {ile}",
  "rozj.tenMaPelny": "pełny obraz",
  "rozj.tytul": "Co dokładnie jest rozjechane",
  "rozj.wlasciciel": "właściciel: {wezel}",
  "rozj.wlascicielNieznany": "właściciel nieznany — źródło zgadujemy po liczbie wierszy",
  "rozj.wszystkieAutomaty": "Nadpisz wszystkie automaty w innych bazach ({n})",
  "rozj.wszystkieLiczby": "wszystkie liczby",
  "rozj.wszystkieOdmowy": "Bez zmian: {lista}",
  "rozj.wszystkiePytanie": "Nadpisać {n} automatów w bazach pozostałych maszyn?\n\nDla każdego portal weźmie zapis z maszyny, która ten automat obsługuje, i zastąpi nim zapis w bazach pozostałych maszyn: dopisze brakujące wiersze, poprawi inną treść i usunie nadmiar — razem ze stanem magazynowym tych pozycji. Operacje wejdą do kolejki.",
  "rozj.wszystkieWynik": "Zakolejkowano dla {ok} z {razem} automatów ({zmian} zmian)",
  "rozj.wyrownanieNiePomoze": "Naprawi to „Nadpisz ten automat w innych bazach” na karcie automatu — dopisuje brakujące, poprawia inną treść i usuwa nadmiar.",
  "rozj.wyrownaniePomoze": "Naprawi to „Uzupełnij ten automat w innych bazach” na karcie automatu.",
  "rozj.zrodlo": "pełny obraz: {wezel} ({wierszy} wierszy)",
  "ss.k7.nieBlokuje": "nie blokuje",
  "rozj.zapiszPlik": "Zapisz plik",
  "rozj.tylkoPozaWyrownaniem": "Tego rozjazdu nie rusza przycisk wyrównania — brakujące wiersze dośle przycisk pod odczytem baz. Nowe zmiany z maszyn rozchodzą się już same; nadmiar u jednego węzła zostaje.",
  "rozj.odpytaj": "Odpytaj bazy",
  "rozj.odpytajCzekam": "czekam na węzły",
  "poczekalnia.tytul": "Poczekalnia węzłów",
  "poczekalnia.poCo": "Węzeł milczący dłużej niż {prog} min przestaje blokować kolejkę — reszta floty nie czeka na maszynę, której nie ma. Możesz też odłożyć go od razu, gdy wiesz, że jedzie na serwis.",
  "poczekalnia.zaleglosciZostaja": "Odłożenie nie odbiera uprawnień ani zaległości — węzeł dostanie je po powrocie.",
  "poczekalnia.licznik": "{ile} w poczekalni",
  "poczekalnia.brakWezlow": "Ta wyspa nie ma jeszcze potwierdzonych węzłów.",
  "poczekalnia.czeka": "kolejka czeka",
  "poczekalnia.powod.CISZA": "milczy",
  "poczekalnia.powod.RECZNIE": "odłożony ręcznie",
  "poczekalnia.powod.NIGDY_NIE_ODPOWIEDZIAL": "nigdy się nie odezwał",
  "poczekalnia.powod.NADRABIA": "nadrabia zaległość",
  "poczekalnia.cisza": "cisza {min} min",
  "poczekalnia.nigdy": "brak kontaktu",
  "poczekalnia.zalega": "zalega {ile} operacji",
  "poczekalnia.odloz": "Odłóż",
  "poczekalnia.przywroc": "Przywróć",
  "poczekalnia.odlozony": "Węzeł odłożony — kolejka na niego nie czeka",
  "poczekalnia.przywrocony": "Węzeł przywrócony do kolejki",
  "pelnyOdczyt.tytul": "Odśwież portal z baz",
  "pelnyOdczyt.poCo": "Każe węzłom przysłać śledzone tabele w całości, zamiast samych zmienionych wierszy. Przydaje się, gdy portal odrzucił meldunki albo ktoś zmieniał bazy z pominięciem portalu.",
  "pelnyOdczyt.niePisze": "Na maszynach nic nie zapisujemy — to prośba o odczyt.",
  "pelnyOdczyt.przycisk": "Poproś o pełny odczyt",
  "pelnyOdczyt.potwierdz": "Tak, poproś",
  "pelnyOdczyt.anuluj": "Anuluj",
  "pelnyOdczyt.zlecony": "Poproszono o {tabel} tabel od {wezlow} węzłów — przyjdą przy najbliższych meldunkach.",
  "pelnyOdczyt.przerwij": "Przerwij pełny odczyt",
  "pelnyOdczyt.przerwijPotwierdz": "Przerwij",
  "pelnyOdczyt.przerwanieCena": "Portal zapisze „dostarczone\" mimo niedokończonego odczytu — może mu brakować kolumn. Poproś ponownie, gdy wyspa będzie zdrowa.",
  "pelnyOdczyt.przerwany": "Przerwano odczyt {tabel} tabel na {wezlow} węzłach — agenci przestaną je czytać w całości.",
  "pelnyOdczyt.wszystkie": "Wszystkie",
  "pelnyOdczyt.wszystkieTabele": "wszystkie tabele",
  "pelnyOdczyt.calaWyspa": "Cała wyspa",
  "pelnyOdczyt.wezel": "Węzeł",
  "pelnyOdczyt.zakres": "Zakres: {tabele} · {wezel}",
  "pelnyOdczyt.nieUdaloSie": "Nie udało się poprosić o pełny odczyt",
  "rozj.zaStareWezly": "Nie pytaliśmy: {wezly} — agent starszy niż {wersja}.",
  "pulpit.action": "Pulpit na żywo",
  "pulpit.offline": "Agent milczy — pulpit nie ma skąd przyjść",
  "pulpit.agentMowi": "Agent zgłosił",
  "pulpit.agentRobi": "Agent",
  "pulpit.zadanieStan": "Zadanie",
  "pulpit.zablokowane": "Przeglądarka zablokowała nowe okno — zezwól na wyskakujące okna dla tej strony.",
  "pulpit.zlyAdres": "Adres okna pulpitu jest niepełny — otwórz je z listy automatów.",
  "pulpit.tytul": "Pulpit maszyny",
  "pulpit.podtytul": "Obraz i sterowanie przez agenta",
  "pulpit.plikiNieTedy": "Pliki nie przechodzą przez pulpit",
  "pulpit.wysylkaWToku": "Poczekaj — jedna wysyłka już trwa",
  "pulpit.naMaszynie": "jest na maszynie",
  "pulpit.skroty": "Skróty",
  "pulpit.skrot.sps": "SPS",
  "pulpit.skrot.spsui": "SPSUI",
  "pulpit.skrot.utilities": "Utilities",
  "pulpit.skrot.raporty": "Raporty",
  "pulpit.skrot.pliki": "Pliki",
  "pulpit.skrot.zadania": "Zadania",
  "pulpit.skrot.uruchom": "Uruchom",
  "pulpit.ctrlAltDel": "Ctrl+Alt+Del",
  "pulpit.ctrlAltDelWyslane": "Wysłano Ctrl+Alt+Del",
  "pulpit.blokada": "Blokada",
  "pulpit.konserwacja": "Konserwacja",
  "pulpit.schowek": "Schowek",
  "pulpit.schowekNaEkran": "Skopiowano na maszynie",
  "pulpit.schowekPodpowiedz": "Wklej tutaj — poleci na maszynę",
  "pulpit.restart": "Restart",
  "pulpit.wylacz": "Wyłącz",
  "pulpit.system": "System",
  "pulpit.napewnoRestart": "Uruchomić maszynę ponownie?",
  "pulpit.napewnoWylacz": "Zamknąć maszynę?",
  "pulpit.tak": "Tak",
  "pulpit.nie": "Nie",
  "pulpit.klikniPonownie": "Kliknij ponownie",
  "pulpit.wylaczOstrzezenie": "Maszyna nie wstanie sama — zdalnie jej nie włączysz. Upewnij się, że wiesz, jak uruchomić ją na miejscu.",
  "pulpit.pelnyEkran": "Pełny ekran",
  "pulpit.pelnyEkranOdmowa": "Przeglądarka nie wpuściła w pełny ekran.",
  "pulpit.zlecone": "Zlecone agentowi.",
  "pulpit.otwieram": "Otwieram sesję…",
  "pulpit.czekamNaAgenta": "Czekam, aż agent podniesie pulpit i otworzy tunel…",
  "pulpit.sterujesz": "Klikasz i piszesz na maszynie — tak samo jak przy niej.",
  "pulpit.obszar": "Obraz pulpitu maszyny",
  "pulpit.zamkniete": "Sesja zamknięta.",
  "pulpit.zerwane": "Połączenie zerwane.",
  "pulpit.odmowa": "Maszyna odmówiła połączenia.",
  "pulpit.nieUdaloSie": "Nie udało się otworzyć sesji pulpitu.",
  "rozj.odpytajOpis": "Świeży SELECT na każdym węźle z bazą — pokaże, których wierszy brakuje i które mają inną treść.",
  "rozj.odczytCzeka": "Zlecone — węzły odpowiadają w swoim cyklu.",
  "rozj.odczytZgodne": "Wiersze zgodne we wszystkich bazach ({n} kluczy).",
  "rozj.portalWierszy": "portal: {n}",
  "rozj.portalBrak": "portalowi brakuje {n}",
  "rozj.portalNadmiar": "portal ma dodatkowo {n}",
  "rozj.portalBrakPrzyklady": "brak w portalu:",
  "rozj.portalNadmiarPrzyklady": "tylko w portalu:",
  "rozj.portalNieUmie": "portal nie odtwarza klucza tej tabeli — porównane są same węzły",
  "rozj.portalNiepewne": "Odczyt był obcięty limitem, więc „dodatkowo w portalu\" może być pozorne.",
  "rozj.odczytBrak": "nie ma u: {nieMaja}",
  "rozj.odczytBlad": "odczyt się nie udał",
  "rozj.odczytWiecej": "Lista ucięta — pełna w pliku.",
  "ruch.all": "wszystkie",
  "ruch.avgTime": "Śr. czas",
  "ruch.avgTimeWhat": "odpowiedzi poprawnych",
  "ruch.chartTitle": "Ruch · ostatnie 48 h (co 1 h)",
  "ruch.colAvg": "Śr. czas",
  "ruch.colCalls": "Wywołania",
  "ruch.colDuration": "Czas trw.",
  "ruch.colEndpoint": "Endpoint",
  "ruch.colIp": "IP",
  "ruch.colLast": "Ostatnio",
  "ruch.colLastStatus": "Ostatni status",
  "ruch.colRequest": "Żądanie",
  "ruch.colResult": "Wynik",
  "ruch.colTime": "Czas",
  "ruch.colToken": "Token",
  "ruch.empty": "Brak zapytań w tym zakresie.",
  "ruch.endpoints": "Wykorzystywane endpointy ({n}) · z 7 dni",
  "ruch.err24h": "Błędy / 24 h",
  "ruch.errShare": "{p}% wywołań",
  "ruch.errors": "błędne",
  "ruch.filterIp": "IP",
  "ruch.filterMethod": "Metoda",
  "ruch.filterStatus": "Status",
  "ruch.next": "Następne",
  "ruch.noToken": "bez tokenu",
  "ruch.now": "teraz",
  "ruch.ok": "poprawne",
  "ruch.pageOf": "Pokazuję {od}–{do} z {total}",
  "ruch.perDay": "≈ {n}/dobę",
  "ruch.perHour": "≈ {n}/godz.",
  "ruch.perToken": "Średnio na token",
  "ruch.prev": "Poprzednie",
  "ruch.req24h": "Zapytań / 24 h",
  "ruch.req7d": "Zapytań / 7 dni",
  "ruch.title": "Ruch API",
  "ruch.tokensActive": "tokeny w ruchu: {n}",
  "screenshot.action": "Zrzut ekranu maszyny",
  "screenshot.expired": "Obraz już wygasł. Zleć nowy zrzut.",
  "screenshot.failed": "Nie udało się zrobić zrzutu.",
  "screenshot.offline": "Agent tej maszyny nie odpowiada — zrzut nie ma skąd przyjść",
  "screenshot.ordering": "Zlecam zrzut agentowi…",
  "screenshot.save": "Zapisz na dysk",
  "screenshot.timeout": "Agent nie odesłał zrzutu. Sprawdź, czy nadal się melduje, i spróbuj ponownie.",
  "screenshot.title": "Zrzut ekranu",
  "screenshot.waiting": "Czekam na agenta — zrzut przyjdzie w najbliższym cyklu.",
  "set.api.tytul": "Integracje (API)",
  "set.api.usunieci": "Pokazuj osoby usunięte z automatów",
  "set.api.usunieciHint": "Wyłączone: integracja ich nie widzi i dostaje je jako usunięte.",
  "set.brandingTitle": "Logo i nazwa",
  "set.logoHint": "PNG, JPEG albo WebP, do 512 kB. SVG nie jest przyjmowany, bo może zawierać skrypt wykonywany na ekranie logowania.",
  "set.name": "Nazwa instancji",
  "set.nameHint": "Puste pole = nazwa produktu.",
  "set.noLogo": "brak logo",
  "set.readFailed": "Nie udało się odczytać pliku",
  "set.removeLogo": "Usuń logo",
  "set.saveName": "Zapisz nazwę",
  "set.saved": "Zapisano",
  "set.subtitle": "Wygląd tej instancji — logo i nazwa widoczne w portalu oraz na ekranie logowania.",
  "set.title": "Ustawienia instancji",
  "set.tooBig": "Plik jest za duży:",
  "set.upload": "Wgraj logo",
  "sledz.automatStoi": "AUTOMAT NIE WYDAJE — interfejs (SPSUI) nie wstał po zmianie. Uruchom go przyciskiem „Uruchom SPSUI” albo ręcznie na maszynie.",
  "sledz.brakPomiaru": "Agent jeszcze tego nie mierzył (mierzy raz na godzinę) albo jest starszy niż ten pomiar.",
  "sledz.cdcCoTo": "CDC (Change Data Capture) to drugi, cięższy mechanizm MSSQL-a: czytnik logu i zadania Agenta SQL zapisujące zmiany do tabel w schemacie „cdc\". Nie widzieliśmy go dotąd włączonego na żadnej maszynie, dlatego nie ma tu przycisku.",
  "sledz.cdcWlaczony": "CDC włączony",
  "sledz.cdcWylaczony": "CDC wyłączony",
  "sledz.ctSzczegoly": "Retencja CT: {retencja} {jednostka}, autoczyszczenie {cleanup}.",
  "sledz.ctWlaczony": "Change Tracking włączony",
  "sledz.ctWylaczony": "Change Tracking wyłączony",
  "sledz.gdzie": "Objętych tabel: {objete} z {wszystkie}, z tego {nasze} to tabele, które portal i tak czyta.",
  "sledz.jednoNaraz": "Na tym węźle trwa już wyłączanie — te dwa polecenia nie mogą iść naraz.",
  "sledz.kolMechanizm": "Mechanizm",
  "sledz.kolRozmiar": "Rozmiar",
  "sledz.kolTabela": "Tabela",
  "sledz.kolWierszy": "Wierszy",
  "sledz.kolWpisow": "Wpisów",
  "sledz.myNieUzywamy": "Portal z tych mechanizmów nie korzysta — agent liczy różnicę lokalnie.",
  "sledz.nicNieSledzi": "Ani Change Tracking, ani CDC nie są tu włączone.",
  "sledz.nieZmierzono": "nie zmierzono",
  "sledz.pokazTabele": "Pokaż tabele ({n})",
  "sledz.przerwij": "Przerwij i podnieś SPS",
  "sledz.przerwijGdyTrwa": "wyłączanie trwa — automat może nie wydawać",
  "sledz.przerwijOpis": "Zamyka zaległe zadania wyłączania i zleca start interfejsu automatu. Działa też wtedy, gdy portal nic nie widzi w toku.",
  "sledz.rozmiar": "Zajmuje {ile}",
  "sledz.rozmiarNieznany": "Rozmiar: nie zmierzono",
  "sledz.spsCzyste": "SyncChangeTracking SPS: pusty",
  "sledz.spsJest": "SyncChangeTracking SPS: {wierszy} wpisów",
  "sledz.spsNicDoRoboty": "nie ma czego wyłączać",
  "sledz.spsNieMa": "SyncChangeTracking SPS: nie ma",
  "sledz.spsNieMierzone": "SyncChangeTracking SPS: nie zmierzono",
  "sledz.spsOdbierane": "Wpisy są odbierane: {relacji} relacji, {przetworzonych} przetworzonych.",
  "sledz.spsOpis": "Replikacja SupplyPointa: {triggery} czynnych triggerów pisze do SyncChangeTracking.",
  "sledz.spsPiszacyTytul": "Kto pisze (z {probka} ostatnich wpisów)",
  "sledz.spsProgramy": "Programy kanału: {obecnych} z {wszystkich} w {katalog}.",
  "sledz.spsSieroty": "Programy kanału usunięte, a triggery zostały — zapis kosztuje, wynik nie jedzie nigdzie.",
  "sledz.spsTabeleTytul": "Tabele replikacji SupplyPointa",
  "sledz.spsTempo": "Rośnie o ~{naDobe} wpisów na dobę, najstarszy z {najstarszy}.",
  "sledz.spsToNieCt": "To własny mechanizm SPS-a, nie Change Tracking MSSQL-a.",
  "sledz.spsWProznie": "Nikt tych wpisów nie odbiera: 0 relacji replikacji i 0 przetworzonych.",
  "sledz.tabeleTytul": "Tabele objęte śledzeniem zmian",
  "sledz.triggerWylaczony": "wyłączony",
  "sledz.triggery": "Triggery: {czynne} czynnych z {wszystkie}",
  "sledz.triggeryInne": "Inne triggery: {ile}",
  "sledz.triggeryTytul": "Triggery na tabelach",
  "sledz.tytul": "Śledzenie zmian w bazie",
  "sledz.wylacz": "Wyłącz replikację SPS-a",
  "sledz.wylaczCt": "Wyłącz Change Tracking",
  "sledz.wylaczCtPotwierdz": "Wyłącz Change Tracking",
  "sledz.wylaczCtTresc": "Agent zdejmie Change Tracking z wszystkich objętych tabel, a potem z bazy. Automat pracuje przez cały czas — to zmiana metadanych, nie przebudowa bazy.\n\nWęzeł: {wezel}. Objętych tabel: {tabel}.\n\nUWAGA: jeśli cokolwiek poza nami czyta CHANGETABLE na tej bazie, przestanie działać i nie zostawi po sobie śladu. Portal z Change Trackingu nie korzysta — agent liczy różnicę lokalnie.",
  "sledz.wylaczCtTytul": "Wyłączyć natywny Change Tracking?",
  "sledz.wylaczCtZlecone": "Zlecono wyłączenie Change Trackingu",
  "sledz.wylaczPotwierdz": "Wyłącz i wyczyść",
  "sledz.wylaczTresc": "Agent zatrzyma interfejs automatu (SPSUI), uruchomi spsdbupdate.exe -removereplication, wyczyści tabele mechanizmu, usunie programy kanału i uruchomi interfejs z powrotem.\n\nAutomat nie wydaje przez czas trwania procedury. Węzeł: {wezel}. Do usunięcia: {wierszy} wpisów i {triggery} triggerów.",
  "sledz.wylaczTytul": "Wyłączyć replikację SupplyPointa?",
  "sledz.wylaczZlecone": "Zlecono wyłączenie replikacji — postęp widać w zadaniach maszyny",
  "sledz.wynikBlad": "błąd",
  "sledz.wynikCtLiczby": "Objęte tabele: {tPrzed} → {tPo}. Na bazie: {bPrzed} → {bPo}.",
  "sledz.wynikCtNarzedziem": "Wyłączone narzędziem SPS-a — nasze konto nie ma prawa zmieniać struktury na tej maszynie.",
  "sledz.wynikCtTytul": "Ostatnie wyłączenie CT:",
  "sledz.wynikDelete": "Czyszczenie poszło DELETE partiami, nie TRUNCATE — konto agenta nie dostało prawa na tej maszynie.",
  "sledz.wynikGotowe": "gotowe",
  "sledz.wynikLiczby": "Triggery: {tPrzed} → {tPo}. Wpisy: {wPrzed} → {wPo}.",
  "sledz.wynikPelne": "Mechanizm wyłączony w całości: triggery zdjęte, tabele puste, programy kanału usunięte.",
  "sledz.wynikPrzerwane": "przerwane",
  "sledz.wynikPrzerwaneAleZrobione": "Zadanie zostało przerwane, ale według bieżącego pomiaru mechanizm jest już wyłączony — nie ma tu nic do zrobienia.",
  "sledz.wynikTytul": "Ostatnie wyłączenie:",
  "sledz.zmierzono": "pomiar: {kiedy}",
  "spsLog.alarm": "Alarmuj",
  "spsLog.allFiles": "wszystkie pliki",
  "spsLog.day": "doba",
  "spsLog.days": "dni",
  "spsLog.empty": "Nic się nie zmieniło w pilnowanych plikach — i to dobra wiadomość. Pusta lista znaczy „SPS się nie wywalił i nikt nie włączał debugowania”, a nie „dozór nie działa”.",
  "spsLog.file": "Plik",
  "spsLog.fileTime": "plik z",
  "spsLog.footnote": "Zmianę wykrywa agent w swoim cyklu, więc czas wykrycia bywa późniejszy od czasu pliku. Pliki i zakres zbieranych danych ustawia się w Ustawieniach wyspy.",
  "spsLog.hideContent": "ukryj treść",
  "spsLog.kind.OBCIETY": "obcięty lub podmieniony",
  "spsLog.kind.POJAWIL_SIE": "plik się pojawił",
  "spsLog.kind.UROSL": "nowe wpisy",
  "spsLog.kind.ZNIKL": "plik zniknął",
  "spsLog.node": "Węzeł",
  "spsLog.pickIsland": "Wybierz wyspę, żeby zobaczyć zmiany w logach SPS.",
  "spsLog.retention": "Wpisy trzymamy {dni} dni. „Treść” znaczy, że agent przysyła dopisane wiersze — ta treść opuszcza wtedy maszynę klienta i ląduje w bazie instancji, więc włączamy ją tam, gdzie naprawdę pomaga.",
  "spsLog.settingsTitle": "Pliki logów SPS pod dozorem",
  "spsLog.showContent": "pokaż treść",
  "spsLog.size": "Rozmiar",
  "spsLog.tail": "Treść",
  "spsLog.truncated": "[…] treść ucięta — to końcówka dopisku, nie całość.",
  "spsLog.watch": "Pilnuj",
  "spsLog.what": "Co się stało",
  "spsLog.when": "Wykryto",
  "spscfg.action": "Baza i numer automatu",
  "spscfg.baza": "Baza SPS (SQLServerDB)",
  "spscfg.inFlight": "Ta maszyna ma już zlecony zapis SPSConfig.XML — poczekaj na jego wynik.",
  "spscfg.offline": "Agent tej maszyny nie jest online, więc nie ma kto wykonać zapisu.",
  "spscfg.queued": "Zlecono zapis ({n} zmiany) — stan zobaczysz na liście zadań maszyny.",
  "spscfg.reported": "Wartości poniżej to ostatni meldunek agenta ({kiedy}), a nie odczyt pliku na żywo. W portalu ten automat ma numer {vmid}.",
  "spscfg.restartBody": "Agent zamyka SPSUI, robi kopię zapasową pliku obok oryginału, zapisuje, czyta z powrotem i uruchamia interfejs w sesji zalogowanego użytkownika. Przez tę chwilę automat nie wydaje. Gdy plik już ma te wartości, nic się nie dzieje — restartu nie ma.",
  "spscfg.restartTitle": "Zapis ZATRZYMA interfejs automatu",
  "spscfg.save": "Zapisz i zrestartuj interfejs",
  "spscfg.serwer": "Serwer SQL (SQLServerName)",
  "spscfg.title": "Baza i numer automatu (SPSConfig.XML)",
  "spscfg.vmid": "Numer automatu (VMID)",
  "spscfg.vmidAck": "Rozumiem, że historia wydań zostanie pod starym numerem, i chcę zmienić numer.",
  "spscfg.vmidWarnTitle": "⚠️ Zmiana numeru automatu — do decyzji",
  "spscfgview.action": "Pokaż cały plik",
  "spscfgview.expired": "Treść już wygasła — otwórz podgląd na nowo",
  "spscfgview.failed": "Nie udało się odczytać pliku",
  "spscfgview.masked": "Zamaskowane na maszynie, do portalu nie trafiły: {pola}",
  "spscfgview.ordering": "Zlecam odczyt pliku…",
  "spscfgview.readonly": "Tylko odczyt — podgląd nie dotyka pliku ani interfejsu automatu",
  "spscfgview.timeout": "Agent nie oddał pliku w ciągu trzech minut",
  "spscfgview.title": "SPSConfig.XML",
  "spscfgview.waiting": "Czekam, aż agent odczyta plik…",
  "ss.bezBazy": "bez własnej bazy (maszyna podległa)",
  "ss.brakWyspy": "Wybierz wyspę u góry — kreator prowadzi wdrożenie jednej wyspy.",
  "ss.cofnij": "cofnij",
  "ss.czekaNaPotwierdzenie": "czeka na potwierdzenie",
  "ss.dociaganie": "Dociąganie zaległej historii wydań na {wezly} węzłach. Nowe wydania jadą normalnie — limity liczą się z bieżących.",
  "ss.k1.p1": "Baza, która nadaje się na mastera — kompletna i sprawdzona. To ona stanie się punktem wyjścia całej wyspy.",
  "ss.k1.p2": "Numery automatów (VMID) uzgodnione i RÓŻNE na każdej maszynie. Dwa te same numery mieszają wydania dwóch automatów i nie da się tego rozplątać.",
  "ss.k1.p3": "Ta sama wersja SupplyPointa na wszystkich maszynach. Różne wersje mają różne kolumny i konfiguracja nie przechodzi między nimi w całości.",
  "ss.k1.poCo": "Robota przy maszynach, zanim ktokolwiek uruchomi instalator. Portal tego nie zmierzy — nie ma jeszcze od kogo.",
  "ss.k1.potwierdz": "Potwierdzam przygotowanie",
  "ss.k1.title": "Przygotuj maszyny i bazę",
  "ss.k2.doAgentow": "Wydaj kod i pobierz instalator",
  "ss.k2.komplet": "To już wszystkie maszyny",
  "ss.k2.poCo": "Jeden kod rejestracyjny na całe wdrożenie. ⚠️ PRZY WYDAWANIU KODU wybierasz „Model wdrożenia tej wyspy\" — i to jest moment, w którym przesądza się tryb. Pierwsze użycie kodu zakłada wyspę już w nim, każde następne dołącza maszynę do tej samej.",
  "ss.k2.title": "Zainstaluj agentów",
  "ss.k3.juzWTrybie": "Wyspa urodziła się w tym trybie (wybór przy kodzie rejestracyjnym) albo została do niego przełączona — nie ma tu nic do zrobienia.",
  "ss.k3.poCo": "Ta karta zwykle tylko POKAZUJE WYNIK kroku 2: tryb wchodzi do wyspy przy jej narodzinach, razem z pierwszą rejestracją. Przycisk pojawia się wyłącznie na wyspie założonej starym kodem, jeszcze bez wyboru trybu.",
  "ss.k3.przelacz": "Przełącz na Smart Sync",
  "ss.k3.pytanie": "Przełączyć wyspę na Smart Sync?\n\nMaszyny JUŻ zarejestrowane tego nie zauważą: prawo do synchronizacji rozstrzyga się przy rejestracji i nie jest przeliczane. Jeżeli któraś zarejestrowała się w trybie zwykłym z własną nazwą bazy, trzeba ją będzie zainstalować ponownie.\n\nNowe wyspy zakładaj od razu w trybie Smart Sync — wybór jest przy wydawaniu kodu rejestracyjnego.",
  "ss.k3.title": "Tryb wyspy",
  "ss.k4.czekaNaPotwierdzenie": "Węzeł {wezel} zgłosił się i czeka na potwierdzenie — do tego czasu portal przyjmuje od niego tylko sygnał życia.",
  "ss.k4.poCo": "Token, którym sidecar MSSQL-a wejdzie do portalu. Wyślij go BillVisowi razem z nazwą bazy master — sidecar zgłosi się sam.",
  "ss.k4.potwierdz": "Potwierdź węzeł",
  "ss.k4.potwierdzony": "Węzeł potwierdzony",
  "ss.k4.title": "Klucz dla chmurowego mastera",
  "ss.k5.brakChmury": "Nie widzę węzła chmurowego (krok 4) — bez niego nie ma gdzie wysłać paczki.",
  "ss.k5.brakKopii": "Magazyn jest pusty — wgraj paczkę z komputera albo zrób kopię na ekranie kopii zapasowych.",
  "ss.k5.brakWezla": "Na tej wyspie nie ma jeszcze potwierdzonego węzła — paczki nie ma czemu przypisać w magazynie.",
  "ss.k5.doKopii": "Przejdź do kopii zapasowych",
  "ss.k5.lub": "lub",
  "ss.k5.naChmure": "Wyślij na węzeł chmurowy",
  "ss.k5.poCo": "Kopia jednej maszyny jedzie do magazynu, a stamtąd na dysk widziany przez chmurowy MSSQL.",
  "ss.k5.title": "Baza do chmury",
  "ss.k5.wMagazynie": "Gotowe paczki w magazynie",
  "ss.k5.wgrano": "Wgrano „{plik}\" ({mb} MB) do magazynu",
  "ss.k5.wiecejPaczek": "W magazynie jest jeszcze {n} — pełna lista na ekranie Kopie.",
  "ss.k5.wysylka": "Wysyłam „{plik}\" — {procent}%",
  "ss.k5.zPliku": "Wgraj kopię zapasową z pliku",
  "ss.k5.zPlikuHint": "Zwykła droga przy Smart Sync: paczka .bak albo .zip z komputera. Ląduje w magazynie instancji, a stamtąd wysyła się ją na węzeł chmurowy przyciskiem na liście poniżej.",
  "ss.k5.zrodloMaszyna": "kopia z {wezel}",
  "ss.k5.zrodloPlik": "wgrana z komputera",
  "ss.k6.brakPaczki": "Na węźle chmurowym nie ma jeszcze paczki — wykonaj krok 5.",
  "ss.k6.nazwa": "Nazwa bazy docelowej",
  "ss.k6.nazwaInna": "Ta nazwa jest inna niż baza master tej wyspy. Odtworzenie pod inną nazwą nie ustawi mastera i trzeba by zmieniać SPS_DB u BillVisa.",
  "ss.k6.nazwaWhat": "Przepisz dokładnie: {baza}. To ta sama nazwa, którą BillVis ma w SPS_DB. Odtworzenie ODMAWIA na nazwę, która już istnieje, więc drugiego podejścia nie będzie.",
  "ss.k6.odtworz": "Odtwórz bazę",
  "ss.k6.paczka": "Paczka na węźle chmurowym: {nazwa}",
  "ss.k6.poCo": "To odtworzenie ustawia plakietkę \"master wyspy\". Portal dowiaduje się o masterze wyłącznie tą drogą.",
  "ss.k6.pytanie": "Odtworzyć bazę pod nazwą „{baza}\"?\n\nBEZ ODWROTU: odtworzenie odmawia na nazwę, która już istnieje, więc drugiego zasiania nie będzie. Poprawka wymagałaby nowej nazwy bazy i zmiany SPS_DB po stronie BillVisa.",
  "ss.k6.stoi": "Master wyspy stoi na węźle {wezel}.",
  "ss.k6.title": "Odtwórz bazę jako master",
  "ss.k7.juzWlaczone": "Rozsyłanie wydań rodzeństwa jest włączone.",
  "ss.k7.poCo": "Po to istnieje Smart Sync: maszyny liczą limity także z wydań rodzeństwa. Przycisk czynny dopiero, gdy wszystkie sprawdzenia wyszły.",
  "ss.k7.przewinButton": "Rozeslij",
  "ss.k7.przewinNic": "Nie ma wydań od tej chwili — nic nie zmieniono",
  "ss.k7.przewinOd": "Rozeslij zaległe wydania od",
  "ss.k7.przewinPoCo": "Włączenie rozsyłania startuje od bieżącej chwili, więc pobrania z czasu instalacji nie zjechały na pozostałe węzły ani na mastera. Tu wybierasz, od kiedy je dosłać. Wpisy są idempotentne — to, co gdzieś już leży, nie zdubluje się.",
  "ss.k7.przewinWezel": "dostanie {n} wydań",
  "ss.k7.przewinWynik": "Przewinięto {wezly} węzłów, {n} wydań od tej chwili",
  "ss.k7.pytanie": "Włączyć rozsyłanie wydań rodzeństwa?\n\nTo jedyna funkcja portalu, która DOPISUJE wiersze do dziennika wydań u klienta. Wyłączenie zatrzymuje kolejne, ale NIE COFA tych, które już poszły.\n\nHistoria nie pojedzie: kursory maszyn ustawią się na „teraz\", więc maszyny dostaną tylko to, co wydarzy się od tej chwili.",
  "ss.k7.skadDymek": "Pokaż, z których automatów składa się ta liczba",
  "ss.k7.skadPozycja": "z {automat} (VMID {vmid}) — {n}",
  "ss.k7.skadStopka": "Bez własnych wydań tego węzła — te już u niego leżą.",
  "ss.k7.title": "Sprawdź i włącz rozsyłanie wydań",
  "ss.k7.wlacz": "Włącz rozsyłanie wydań",
  "ss.k7.granicaBrak": "Nie było granicy czasu.",
  "ss.k7.granicaJest": "Nadrobienie sięga do {data} — bieżące wydania jadą bez względu na datę.",
  "ss.k7.granicaZdejmij": "Zdejmij granicę",
  "ss.k7.granicaZdjeta": "Zasięg nadrobienia zdjęty — zaległość pojedzie w całości.",
  "ss.k7.porzucButton": "Przerwij rozsyłanie zaległych wydań",
  "ss.k7.porzucPoCo": "Historia sprzed granicy nie pojedzie do maszyn; bieżące wydania jadą dalej.",
  "ss.k7.porzucPytanie": "Zaległa historia NIE pojedzie do baz maszyn i nie da się tego cofnąć jednym ruchem. Bieżące wydania jadą dalej. Przerwać?",
  "ss.k7.porzuconoWynik": "Porzucono {n} zaległych wydań.",
  "ss.zalegle.tytul": "Zaległe wydania",
  "ss.zalegle.W_TOKU": "Rozsyłanie zaległych wydań od {od} trwa",
  "ss.zalegle.ZAKONCZONE": "Zaległe wydania od {od} rozesłane",
  "ss.zalegle.PRZERWANE": "Rozsyłanie zaległych wydań od {od} przerwane",
  "ss.zalegle.zlecone": "zlecone {data}",
  "ss.kopia.zlecona": "Kopia zlecona — potrwa chwilę.",
  "ss.zakladka.wdrozenie": "Wdrożenie",
  "ss.zakladka.synchronizacje": "Synchronizacje",
  "ss.odtworzenie.zlecone": "Odtworzenie bazy zlecone.",
  "ss.paczka.zlecona": "Wysyłka paczki na węzeł chmurowy zlecona.",
  "ss.potwierdzil": "Potwierdził(a): {kto}, {kiedy}.",
  "ss.rozsylanie.wlaczone": "Rozsyłanie wydań rodzeństwa włączone.",
  "ss.stan.CZEKA": "czeka",
  "ss.stan.TERAZ": "teraz",
  "ss.stan.UWAGA": "uwaga",
  "ss.stan.ZROBIONE": "zrobione",
  "ss.title": "Smart Sync",
  "ss.tryb.zmieniony": "Wyspa przełączona na Smart Sync.",
  "table.actions": "Akcje",
  "table.clearFilters": "Wyczyść filtry",
  "table.cooldownIn": "Ponowne pobranie za",
  "table.cooldownWait": "Ten raport był właśnie pobierany — chwilę odczekaj.",
  "table.empty": "Brak wyników",
  "table.exportDone": "Eksport gotowy",
  "table.exportEmpty": "Nie ma czego eksportować",
  "table.exportFailed": "Eksport nieudany",
  "table.filters": "Filtry",
  "table.filtersActive": "Zastosowany filtr",
  "table.next": "Następna strona",
  "table.of": "z",
  "table.pageSize": "Wierszy na stronę",
  "table.prev": "Poprzednia strona",
  "table.refresh": "Odśwież",
  "table.search": "Szukaj…",
  "table.showing": "Pokazuję",
  "table.txtBezNaglowkow": "Bez nagłówków",
  "table.txtBezNaglowkowOpis": "same dane — dla programu, który zaciąga plik",
  "table.txtWybierz": "TXT (tab delimited) — wybierz, czy plik ma mieć wiersz z nazwami kolumn",
  "table.txtZNaglowkami": "Z nagłówkami",
  "table.txtZNaglowkamiOpis": "pierwszy wiersz to nazwy kolumn",
  "theme.toDark": "Motyw nocny",
  "theme.toLight": "Motyw dzienny",
  "tokchm.baza": "Nazwa bazy chmurowej (SPS_DB)",
  "tokchm.bazaBrak": "Ta wyspa nie ma jeszcze bazy master — przyniesie ją pierwszy agent z maszyny klienta. Do tego czasu nie ma czego podać w SPS_DB.",
  "tokchm.bazaNiepotwierdzona": "niepotwierdzona",
  "tokchm.bazaPodpis": "Pod tą nazwą sidecar odtworzy kopię. Nazwy baz na maszynach nie mają tu znaczenia — w Smart Syncu każda ma własną.",
  "tokchm.bazaPotwierdzona": "potwierdzona",
  "tokchm.bazaWhat": "Bierze się z wyspy, nie wpisuje. Pod tą nazwą trzeba odtworzyć kopię — tylko wtedy portal uzna ten węzeł za mastera wyspy.",
  "tokchm.bazaWzorzec": "Nazwa bazy: litera albo podkreślenie na początku, dalej litery, cyfry, _ $ -",
  "tokchm.bazaZapisana": "Nazwa bazy chmurowego mastera: „{baza}\"",
  "tokchm.bazaZapisz": "Zapisz nazwę",
  "tokchm.bazaZasiana": "master stoi na węźle {wezel}",
  "tokchm.bladOdwolania": "Nie udało się odwołać tokenu.",
  "tokchm.bladWydania": "Nie udało się wydać tokenu.",
  "tokchm.blokBrakBazy": "Bloku do wklejenia nie składamy, bo nie znamy jeszcze nazwy bazy master. Token jest ważny — SPS_DB podaj, gdy wyspa dostanie mastera.",
  "tokchm.blokOpis": "Dokładnie te dwa wiersze idą do sekretu instancji. Resztę kontraktu (AGENT_ROLE, AGENT_PORTAL_URL, MSSQL_*) platforma ustawia sama.",
  "tokchm.dowod": "Wydany token: prefiks {prefiks}, długość {dlugosc}. Token agenta ma zawsze „sva_\" i 47 znaków — kod rejestracyjny („sve_\") do tej zmiennej NIE pasuje.",
  "tokchm.dowodZly": "to nie wygląda na token agenta, zgłoś to nam",
  "tokchm.kopiaNieudana": "Nie udało się skopiować — przepisz wartość z ekranu.",
  "tokchm.kopiujOba": "Kopiuj token i nazwę bazy",
  "tokchm.kopiujToken": "Kopiuj sam token",
  "tokchm.label": "Chmurowy master — {wyspa}",
  "tokchm.listaPusto": "Ten węzeł nie ma jeszcze tokenu — wydaj go przyciskiem wyżej.",
  "tokchm.listaTytul": "Token tego węzła",
  "tokchm.nadpisze": "Wydanie nowego tokenu natychmiast odwoła ten, którym ten węzeł teraz pisze.",
  "tokchm.stanNieznany": "Nie wiadomo, czy ten węzeł ma już token — portal nie wczytał jeszcze listy. Odczekaj chwilę, zanim wydasz nowy.",
  "tokchm.nadpiszePytanie": "Wydać nowy token dla węzła „{wezel}\"?\n\nDotychczasowy token ({prefiks}…) przestanie działać W TEJ SEKUNDZIE, a agent chmurowego mastera przestanie zapisywać dane, dopóki nie wkleisz nowego tokenu do sekretu instancji.\n\nStan dotychczasowego: {stan}.",
  "tokchm.nodeId": "Nazwa węzła",
  "tokchm.nodeIdWhat": "Tożsamość chmurowego mastera w portalu — zostaje na stałe, więc powinna dać się przeczytać po miesiącach. Puste = wpiszemy podpowiedź.",
  "tokchm.odwolaj": "Odwołaj",
  "tokchm.odwolajPytanie": "Odwołać token węzła „{wezel}\" ({prefiks}…)?\n\nOdwołanie działa NATYCHMIAST i nie da się go cofnąć — agent z tym tokenem przestanie być wpuszczany, a chmurowy master przestanie zapisywać dane, dopóki nie dostanie nowego tokenu.\n\nStan dotychczasowego: {stan}.",
  "tokchm.odwolany": "Token odwołany — nie wpuści już żadnego agenta.",
  "tokchm.razWarning": "Zapisz to TERAZ — tokenu nie da się odczytać ponownie.",
  "tokchm.skopiowanoOba": "Skopiowano token i nazwę bazy — wklej oba wiersze do sekretu instancji.",
  "tokchm.skopiowanoToken": "Token skopiowany.",
  "tokchm.stanNieuzyty": "nigdy nie użyty",
  "tokchm.stanOdwolany": "odwołany",
  "tokchm.stanUzywany": "używany",
  "tokchm.title": "Chmurowy master — token i nazwa bazy",
  "tokchm.tylkoSmart": "Ta wyspa pracuje w trybie zwykłym, czyli jej master stoi na maszynie klienta i chmurowego agenta nie ma. Token wydaje się dopiero po przełączeniu wyspy na Smart Sync (Ustawienia → „Model wdrożenia i baza wyspy\").",
  "tokchm.ukryj": "Ukryj",
  "tokchm.wydaj": "Wydaj token dla chmurowego mastera",
  "traffic.day": "doba",
  "traffic.days": "dni",
  "traffic.empty": "Brak ruchu w tym okresie.",
  "traffic.footnote": "Mierzone na instancji: bajty żądań i odpowiedzi kanału agenta razem z nagłówkami. Nie obejmuje narzutu TLS i TCP/IP, więc rachunek operatora będzie o ~10–15% wyższy.",
  "traffic.in": "do portalu",
  "traffic.kind.aktualizacje": "aktualizacje agenta",
  "traffic.kind.heartbeat": "sygnał życia",
  "traffic.kind.inne": "inne",
  "traffic.kind.pliki": "pliki i kopie",
  "traffic.kind.rodzenstwo": "wydania rodzeństwa",
  "traffic.kind.wydania": "wydania",
  "traffic.kind.zadania": "zadania",
  "traffic.kind.zmiany": "zmiany w dół",
  "traffic.noThreshold": "próg alarmu nieustawiony",
  "traffic.node": "Węzeł",
  "traffic.out": "z portalu",
  "traffic.perDay": "Średnio na dobę",
  "traffic.perKind": "Na co idzie ruch",
  "traffic.perNode": "Per agent",
  "traffic.pickIsland": "Wybierz wyspę, żeby zobaczyć zużycie danych.",
  "traffic.requests": "Żądań",
  "traffic.requestsShort": "żądań",
  "traffic.retention": "historia",
  "traffic.threshold": "próg alarmu",
  "traffic.tlsNote": "bez narzutu TLS i TCP/IP (~10–15% więcej u operatora)",
  "traffic.total": "Razem",
  "tx.allCodes": "wszystkie typy",
  "tx.allCostCenters": "Wszystkie centra",
  "tx.allGroups": "wszystkie grupy",
  "tx.allMachines": "wszystkie automaty",
  "tx.code": "Typ",
  "tx.code.IA": "korekta",
  "tx.code.REN": "uzupełnienie",
  "tx.code.WN": "wydanie",
  "tx.costCenter": "Centrum kosztowe",
  "tx.costCenterHint": "Wartość zamrożona w chwili wydania — dokładnie taka, jak zapisał ją automat. Nie scalamy różnych zapisów tej samej nazwy.",
  "tx.employee": "Pracownik",
  "tx.emptyForRange": "Brak transakcji w wybranym zakresie ({range}).",
  "tx.exportTooBig": "Zestawienie ma {total} wierszy, a {format} przyjmuje {limit} — zawęź okres albo filtry. Nie ucinamy pliku po cichu.",
  "tx.from": "Od",
  "tx.groupAtIssue": "Grupa z chwili wydania",
  "tx.groupAtIssueHint": "Grupa pracownicza ZAMROŻONA przez SPS w chwili wydania (USERGROUP01..10). Filtr po niej daje tę samą odpowiedź także po przeniesieniu ludzi między grupami — inaczej zeszłoroczne wydania przepisywałyby się do nowej grupy pracownika.",
  "tx.groupAtIssueUnknown": "Brak informacji o grupie na tym wydaniu. Pusta wartość znaczy „nie wiemy\" (starsza synchronizacja nie przenosiła tych kolumn) ALBO „poza grupami\" — tych przypadków nie da się rozróżnić, więc portal nie zgaduje.",
  "tx.issued": "Wydano",
  "tx.item": "Towar",
  "tx.machine": "Automat",
  "tx.machineFilterUnavailable": "Nie mogę wczytać listy automatów (Twoje konto nie ma uprawnienia „Automaty”), więc filtrowanie po automacie jest niedostępne.",
  "tx.newestOutsideRange": "Najnowsze wydanie pasujące do pozostałych filtrów: {date} — wybierz szerszy zakres albo „Wszystko”.",
  "tx.noCostCenter": "bez centrum",
  "tx.period": "Okres",
  "tx.preset.all": "Wszystko",
  "tx.preset.d30": "30 dni",
  "tx.preset.d7": "7 dni",
  "tx.preset.mtd": "Ten miesiąc",
  "tx.preset.today": "Dziś",
  "tx.qty": "Ilość",
  "tx.summaryFor": "Dla wybranych filtrów:",
  "tx.to": "Do",
  "tx.totalValue": "Wartość razem (moduł kwot: wydania, uzupełnienia i korekty)",
  "tx.unitCost": "Cena jedn.",
  "tx.value": "Wartość",
  "tx.when": "Data i godzina",
  "user.logout": "Wyloguj",
  "zderz.bladWczytania": "Nie udało się sprawdzić, czy któryś limit nie przepuszcza pełnego wydania — czujnik NIE odpowiedział, więc ta lista nie znaczy „nie ma blokad\".",
  "zderz.brakRoli": "Zmiana limitu wymaga roli administratora.",
  "zderz.grupa": "grupa „{nazwa}”",
  "zderz.grupaOsob": "grupa „{nazwa}” · {osob} os.",
  "zderz.iInne": " · pozostałe {n} wydają tyle samo albo więcej",
  "zderz.lead": "Zgłaszamy tylko blokady CAŁKOWITE: gdy KAŻDA przegródka z tym towarem wydaje za jednym pobraniem więcej, niż pozwala limit — czyli człowiek nie ma żadnej drogi pobrania i automat odmawia „wydzielanie przekroczone” za każdym razem. Ten sam towar po 7 i po 4 przy limicie 4 NIE jest błędem: bęben zakręci się na tę z czterema. Sprawdzono {limitow} limitów wobec {miejsc} przegródek. ⚠️ Czujnik nie patrzy na przypisanie ludzi do automatów ani na zawężenie przegródki grupą lokalizacji, więc kogoś odciętego od tej jednej mieszczącej się przegródki nie zgłosi.",
  "zderz.limitLinia": "limit {maxQty} szt. / {okno} · najmniejsze wydanie tego towaru w wyspie",
  "zderz.miejsce": "{towar} — najbliżej: {automat} (VMID {vmid}), bęben {pic}, szuflada {szuflada}, przegroda {przegroda}",
  "zderz.miejsceKrotkie": "{automat} · szuflada {szuflada}, przegroda {przegroda} — {wydanie} szt.",
  "zderz.niesprawdzone": "{n} limitów czujnik NIE sprawdza:",
  "zderz.podnies": "Podnieś limit do {n}",
  "zderz.podniesOpis": "Ustawi limit na {n} szt. w tym samym okresie — tyle, ile zabiera NAJMNIEJSZE wydanie tego towaru, czyli dokładnie tyle, by człowiek miał jedną drogę pobrania. Okno pozostaje bez zmian.",
  "zderz.pytanieGrupa": "Podnieść limit do {n} szt. / {okno} dla CAŁEJ grupy „{kto}” ({osob} osób)?\n\nZakres: {zakres}. Zmiana obejmie każdego członka tej grupy.",
  "zderz.pytanieOsoba": "Podnieść limit do {n} szt. / {okno} dla „{kto}”?\n\nZakres: {zakres}.",
  "zderz.sztuk": "szt.",
  "zderz.title": "Limit nie przepuści pełnego wydania",
  "zderz.tylkoOdczyt": "Ten wiersz wydzielania jest zawężony w SPS (zadanie, automat albo pola AUX) — portal go nie edytuje. Popraw limit w SPSUI.",
  "zderz.wszyscy": "wszyscy",
  "zderz.zlecone": "Zakolejkowano podniesienie limitu — zmiana pojedzie do automatu w kolejce zmian.",
  "zdj.bezPliku": "bez zdjęcia",
  "zdj.brakMaszyn": "Na tej wyspie nie ma automatów z agentem.",
  "zdj.brakWBibliotece": "portal nie ma tego pliku",
  "zdj.brakWynikow": "Nic nie pasuje do filtrów.",
  "zdj.mierzono": "sprawdzono {kiedy}",
  "zdj.nieMierzono": "nie sprawdzano",
  "zdj.plik": "Plik",
  "zdj.pokazZMaszyny": "kliknij, żeby zobaczyć zdjęcie z tego automatu",
  "zdj.probaNieudana": "sprawdzanie nie udało się ({kiedy}): {powod}",
  "zdj.przycisk": "Zarządzaj zdjęciami",
  "zdj.spis": "Sprawdź automaty",
  "zdj.spisNikt": "Nie ma automatów, które można sprawdzić.",
  "zdj.spisOpis": "Sprawdza, jakie pliki są na automatach. Nic nie przesyła.",
  "zdj.spisZaStare": "Pominięto automaty ze starszym agentem: {wezly} — potrzebny {wersja}, zaktualizują się same.",
  "zdj.spisZaStareWszystkie": "Żaden automat jeszcze tego nie umie: {wezly} — potrzebny agent {wersja}. Zaktualizuje się sam albo użyj „aktualizuj teraz” na ekranie Agentów.",
  "zdj.spisZlecony": "Sprawdzamy automaty ({wezlow}) — wynik za chwilę.",
  "zdj.stan.BEZ_OBRAZKA": "bez zdjęcia",
  "zdj.stan.BRAKI": "brakuje na części automatów",
  "zdj.stan.NIEZMIERZONE": "nie sprawdzono",
  "zdj.stan.ROZJAZD": "inne zdjęcie na części automatów",
  "zdj.stan.WSZEDZIE": "na wszystkich automatach",
  "zdj.stanMaszyny.BRAK": "brak pliku — automat pokaże puste miejsce",
  "zdj.stanMaszyny.INNY_PLIK": "ten automat ma przypisane inne zdjęcie",
  "zdj.stanMaszyny.INNY_PLIK.opis": "ten automat pokazuje {plik}",
  "zdj.stanMaszyny.INNY_ROZMIAR": "ta sama nazwa, inna zawartość",
  "zdj.stanMaszyny.INNY_ROZMIAR.opis": "ta sama nazwa, inna zawartość ({bajty} B)",
  "zdj.stanMaszyny.MA": "jest",
  "zdj.stanMaszyny.NIEZMIERZONE": "nie sprawdzono",
  "zdj.stanMaszyny.PUSTY_PLIK": "pusty plik (0 B) — automat pokaże puste miejsce",
  "zdj.szukaj": "Szukaj artykułu albo pliku",
  "zdj.towar": "Artykuł",
  "zdj.tylkoBraki": "Tylko braki",
  "zdj.tytul": "Zdjęcia artykułów",
  "zdj.ucieto": "Pokazano {ile} z {z} — zawęź szukanie.",
  "zdj.wToku": "sprawdzanie…",
  "zdj.wezelZaStary": "agent {wersja}, potrzebny {wymagana} — zaktualizuje się sam",
  "zdj.zakladka.galeria": "Zdjęcia w portalu",
  "zdj.zakladka.pokrycie": "Na automatach",
  "zdj.zmien": "Zmień",
  "zdj.zmienOpis": "Wybierz inne zdjęcie dla tego artykułu",
  "zajetosc.tytul": "Zajętość automatów",
  "zajetosc.poCo": "Liczba portalu i to, za ile portal za nią ręczy. Wiersz zamrożony ma niewykonaną zmianę, więc jego stan pochodzi sprzed niej.",
  "zajetosc.pozycji": "{n} pozycji",
  "zajetosc.zamrozonych": "{n} zamrożonych ({p}%)",
  "zajetosc.pewna": "nic nie zamrożone",
  "zajetosc.brakPlanogramu": "brak planogramu",
  "zajetosc.brakWlasciciela": "portal nie zna węzła tego automatu",
  "zajetosc.cisza": "cisza {n} min",
  "zajetosc.nigdyNieOdpowiedzial": "nigdy się nie odezwał",
  "zajetosc.niepelne": "Kolejka jest większa niż granica liczenia — liczba zamrożonych jest zaniżona.",
  "zajetosc.zapytaj": "Zapytaj automaty",
  "zajetosc.czekam": "Czekam na odpowiedzi…",
  "zajetosc.nikt": "Nikt jeszcze nie pytał baz — to, co wyżej, to wyłącznie liczba portalu.",
  "zajetosc.wgBaz": "wg baz:",
  "zajetosc.zlecono": "Zapytano {n} węzłów — odpowiedzi przyjdą przy najbliższych cyklach.",
  "zajetosc.zaStare": "Pominięto węzły ze starszym agentem: {wezly}",
  "zajetosc.wszystkie.przycisk": "Przyjmij stan od wszystkich automatów",
  "zajetosc.wszystkie.opis": "Każdy automat poda portalowi stan swoich przegródek, a portal przejmie jego liczby. Na automaty nic nie idzie; pozycje z niewykonanymi zmianami zostają bez zmian.",
  "zajetosc.wszystkie.zlecono": "Zapytano automaty: {n}. Portal przyjmie stan, gdy odpowiedzą.",
  "zajetosc.wszystkie.wToku": "Przyjmowanie stanu…",
  "zajetosc.wszystkie.gotowe": "Przyjęto stan od automatów.",
  "zajetosc.wszystkie.CZEKA": "czeka na odczyt",
  "zajetosc.wszystkie.BLAD": "odczyt nie udał się: {powod}",
  "zajetosc.wszystkie.NIE": "bez zmian: {powod}",
  "zajetosc.wszystkie.PRZYJETO": "przyjęto pozycji: {n}",
  "zajetosc.wszystkie.ZGODNE": "zgodne",
  "zajetosc.wszystkie.zamrozonych": "pominięte z niewykonanymi zmianami: {n}",
  "zajetosc.wszystkie.nieznanych": "poza planogramem portalu: {n}",
  "zajetosc.wszystkie.bezWlasciciela": "Pominięte, bo nie mają jednej bazy (VMID): {automaty}",
  "zajetosc.wszystkie.zaStare": "Pominięto starsze agenty: {wezly}",
  "stanTabel.tytul": "Stan tabel — portal kontra węzły",
  "stanTabel.poCo": "Liczby węzłów przychodzą czujnikiem przy każdym cyklu, liczby portalu z read-modelu. Nic tu nie pytamy maszyn.",
  "stanTabel.portal": "portal {n}",
  "stanTabel.zgodne": "zgodne ({n} węzłów)",
  "stanTabel.rozjazd": "ROZJAZD: {wezly}",
  "stanTabel.nieWiemy": "nie wiemy",
  "stanTabel.nieMierzona": "czujnik nie liczy tej tabeli",
  "stanTabel.brakMeldunkow": "żaden węzeł jeszcze nie zgłosił",
  "stanTabel.brakLicznika": "portal nie liczy tej tabeli",
  "stanTabel.podsumowanie": "Porównane {n} z {razem} tabel — reszta czeka na licznik po stronie węzła.",
  "stanTabel.policz": "Policz w bazach",
  "stanTabel.czekam": "Czekam na odpowiedzi…",
  "stanTabel.zlecono": "Zlecono spis na {n} węzłach — odpowiedzi przyjdą przy najbliższych cyklach.",
  "stanTabel.zaStare": "Pominięto węzły ze starszym agentem: {wezly}",
  "stanTabel.zCzujnika": "z czujnika",
  "stanTabel.zOdczytu": "ze spisu",
  "stanTabel.podzbior": "nie porównujemy — portal trzyma tylko część tej tabeli",
  "stanTabel.wiersze": "Wiersze",
  "stanTabel.uzgodnij": "Uzgodnij",
  "stanTabel.znanaRoznica": "Znana różnica",
  "stanTabel.znanaPytanie": "Uznać różnicę {n} w tabeli {tabela} za wyjaśnioną? Wiersz zszarzeje i wróci na czerwono, gdy tylko różnica się zmieni.",
  "stanTabel.znana": "znana różnica {n} — {kto}, {kiedy}",
  "stanTabel.znanaByla": "uznana była różnica {n}",
  "stanTabel.cofnij": "Cofnij",
  "stanTabel.miedzyWezlami": "Węzły różnią się między sobą: {tabel} tabel na {automatow} automatach",
  "wstrz.tytul": "Wstrzymane zdjęcia",
  "wstrz.czeka": "czeka na decyzję",
  "wstrz.naglowek": "{kto} zdjął naraz {n} {co}",
  "wstrz.co.AUTOMAT": "przypisań do automatów",
  "wstrz.co.GRUPA": "członkostw w grupach",
  "wstrz.co.MPK": "przypisań do MPK",
  "wstrz.co.INNE": "wierszy",
  "wstrz.pozostaleMaja": "Nic nie poszło na wyspę — pozostałe bazy nadal je mają.",
  "wstrz.lista": "Pokaż listę",
  "wstrz.ukryj": "Ukryj listę",
  "wstrz.kolNumer": "Numer",
  "wstrz.kolOsoba": "Pracownik",
  "wstrz.kolCel.AUTOMAT": "Automat",
  "wstrz.kolCel.GRUPA": "Grupa",
  "wstrz.kolCel.MPK": "MPK",
  "wstrz.kolCel.INNE": "Cel",
  "wstrz.jeszcze": "…i jeszcze {n}",
  "wstrz.rozeslij": "Roześlij",
  "wstrz.przywroc": "Przywróć",
  "wstrz.pytanieRozeslij": "Zdjąć {n} we wszystkich bazach wyspy?",
  "wstrz.pytaniePrzywroc": "Przywrócić {n} na {kto}?",
  "wstrz.takRozeslij": "Tak, roześlij",
  "wstrz.takPrzywroc": "Tak, przywróć",
  "wstrz.zakolejkowano": "Zakolejkowano {n}",
  "stanRoz.pokaz": "Rozjazd stanu",
  "stanRoz.czekam": "Czekam na odpowiedzi węzłów…",
  "stanRoz.zgodne": "Stan zgodny we wszystkich bazach ({n} pozycji)",
  "stanRoz.roznych": "{n} pozycji o różnym stanie",
  "stanRoz.brakujace": "{n} pozycji, których gdzieś nie ma",
  "stanRoz.zaStare": "Pominięto węzły ze starszym agentem: {wezly}",
  "stanRoz.zlecono": "Zapytano {n} węzłów o stan tego automatu.",
  "stanRoz.nikt": "Nikt jeszcze nie pytał baz o stan tego automatu.",
  "stanRoz.wyrownaj": "Roześlij stan ponownie",
  "stanRoz.wyrownano": "Rozesłano {n} pozycji do pozostałych węzłów.",
  "stanRoz.nicDoRozeslania": "Portal nie ma dla tego automatu ani jednej pozycji do rozesłania.",
  "stanRoz.bezOdpowiedzi": "bez odpowiedzi",
  "uzgadnianie.tytul": "Wyrównaj bazy automatów",
  "uzgadnianie.poCo": "Jedna tabela, paczkami. Następna paczka dopiero po potwierdzeniu przez każdy węzeł. Dokładamy brakujące wiersze — nic nie jest kasowane.",
  "uzgadnianie.wybierzTabele": "wybierz tabelę",
  "uzgadnianie.wybierzAutomat": "wybierz automat",
  "uzgadnianie.zacznij": "Zacznij",
  "uzgadnianie.zaczeto": "Przebieg ruszył — {n} węzłów w kolejce",
  "uzgadnianie.zaStare": "Pominięte, za stary agent: {wezly}",
  "uzgadnianie.przerwij": "Przerwij",
  "uzgadnianie.wznow": "Wznów",
  "uzgadnianie.gdzie": "źródło: {wezel} ({nr} z {z}) · od wiersza {od}",
  "uzgadnianie.podsumowanie": "paczek: {paczek} · rozesłanych wierszy: {rozeslanych}",
  "uzgadnianie.znane": "{n} już rozesłanych wcześniej",
  "uzgadnianie.pominiete": "pominięte węzły: {wezly}",
  "uzgadnianie.stan.TRWA": "idzie",
  "uzgadnianie.stan.WSTRZYMANY": "wstrzymany",
  "uzgadnianie.stan.PRZERWANY": "przerwany",
  "uzgadnianie.stan.ZROBIONY": "domknięty",
  "uzgadnianie.faza.GOTOWY": "czeka na kolejny krok",
  "uzgadnianie.faza.ODCZYT": "czyta paczkę z węzła",
  "uzgadnianie.faza.ROZSYLKA": "czeka na potwierdzenia węzłów",
  "stanRoz.przyjmij": "Przyjmij stan od właściciela",
  "stanRoz.przyjeto": "Portal przyjął stan: {n} pozycji",
  "stanRoz.potwierdz": "Potwierdzam",
  "kopiaPortalu.tytul": "Kopia portalu",
  "kopiaPortalu.poCo": "Dane vendingowe tej wyspy w CSV, do porównania z bazą master. Nie jest to kopia do odtworzenia — nie ma tu kolejki zmian, dziennika ani agentów.",
  "kopiaPortalu.pobierz": "Pobierz kopię portalu",
  "kopiaPortalu.zawartosc": "{n} plików, razem {w} wierszy",
  "kopiaPortalu.osobowe": "W paczce są imiona, nazwiska i numery kart kadry klienta — bez nich tabeli Users nie da się porównać. PIN-ów portal nie przechowuje.",
  "kopiaPortalu.brakWyspy": "Wybierz wyspę, żeby zobaczyć, co znajdzie się w kopii.",
  "itm.supplier": "Dostawca",
  "itm.supplierUnknown": "(spoza słownika)",
  "itm.noSupplier": "bez dostawcy",
  "itm.noSuppliersOnIsland": "Ta wyspa nie ma jeszcze zdefiniowanych dostawców.",
  "dost.przycisk": "Dostawcy",
  "dost.tytul": "Słownik dostawców",
  "dost.dodaj": "Nowy dostawca",
  "dost.edycja": "Edycja dostawcy",
  "dost.pusto": "Ta wyspa nie ma jeszcze żadnego dostawcy.",
  "dost.towarow": "{n} towarów",
  "dost.zaDlugi": "za długi numer — nie da się przypisać do towaru",
  "dost.spozaSlownika": "{n} towarów wskazuje na numer spoza słownika.",
  "dost.numer": "Numer",
  "dost.numerHint": "Najwyżej 32 znaki — tyle mieści kolumna dostawcy na towarze. Po zapisie nie da się go zmienić.",
  "dost.nazwa": "Nazwa",
  "dost.adres": "Adres, linia {n}",
  "dost.zapisano": "Zmiana dostawcy zakolejkowana",
  "dost.usun": "Usuń dostawcę",
  "dost.usunPytanie": "Usunąć dostawcę {nazwa}?",
  "dost.usunZTowarami": "Dostawca {nazwa} jest przypisany do artykułów ({n}). Po usunięciu zniknie też z nich. Usunąć?",
  "dost.usunieto": "Zakolejkowano usunięcie dostawcy {nazwa}",
  "szer.poszerz": "Poszerz — wchłoń następną kolumnę",
  "szer.zwez": "Zwęź — oddaj ostatnią kolumnę",
  "szer.skutek.BEZ_SKUTKU": "Kolumna {zostaje} wchłonie kolumnę {kolumna}. Zniknie {przegrod} pustych przegród.",
  "szer.skutek.ZNIKNIE_PLANOGRAM": "Kolumna {zostaje} wchłonie kolumnę {kolumna}. Zniknie {przegrod} przegród, w tym {pozycji} z przypisanym towarem — bez stanu.",
  "szer.skutek.GINIE_TOWAR": "Kolumna {zostaje} wchłonie kolumnę {kolumna}. Zniknie {przegrod} przegród, w tym {pozycji} z przypisanym towarem i {sztuk} szt. stanu.",
  "szer.skutekZwezenia": "Kolumna {zostaje} odda kolumnę {kolumna}. Wróci pusta, z {przegrod} przegrodami — bez towaru.",
  "szer.towarNieWroci": "Zwężenie odda kolumnę z powrotem, ale towar w niej nie wróci.",
  "szer.potwierdzPoszerzenie": "Poszerz kolumnę {n}",
  "szer.potwierdzZwezenie": "Zwęź kolumnę {n}",
  "szer.zakolejkowano": "Zmiana szerokości zakolejkowana",
  "szer.tryb": "Edytuj kolumny",
  "kmpk.brakOsob": "Nikt nie pasuje do tej frazy.",
  "kmpk.do": "Do dnia",
  "kmpk.doZmiany": "Do poprawienia: {n}",
  "kmpk.juzPoprawne": "pomijamy {n} już poprawnych",
  "kmpk.kolAutomat": "Automat",
  "kmpk.kolData": "Data",
  "kmpk.kolIlosc": "Ilość",
  "kmpk.kolMpk": "MPK",
  "kmpk.kolTowar": "Towar",
  "kmpk.mpk": "Nowe MPK",
  "kmpk.mpkBiezace": "Obecne MPK osoby: {mpk}",
  "kmpk.nicDoZmiany": "W tym okresie nie ma wydań do poprawienia.",
  "kmpk.od": "Od dnia",
  "kmpk.operacji": "operacji: {n}",
  "kmpk.pokaz": "Pokaż, co się zmieni",
  "kmpk.pracownik": "Pracownik",
  "kmpk.pusto": "(puste)",
  "kmpk.starszyAgent": "Zatwierdzenie wymaga agenta {wersja} na każdej bazie wyspy. Starszego mają: {lista}.",
  "kmpk.szukaj": "Zacznij pisać nazwisko albo numer karty…",
  "kmpk.tytul": "Korekta MPK w historii wydań",
  "kmpk.wiecej": "… i jeszcze {n}",
  "kmpk.zatwierdz": "Popraw MPK ({n})",
  "kmpk.zrobione": "Zakolejkowano {n} wydań w {k} operacjach",
  "baza.zakladka": "Zapytania",
  "baza.zakladkaZmiany": "Zmiany",
  "baza.baza": "Baza",
  "baza.master": "master",
  "baza.zaStary": "agent {wersja} — za stary",
  "baza.porownaj": "Porównaj z",
  "baza.szukaj": "Szukaj tabeli",
  "baza.czytamSchemat": "Czytam schemat…",
  "baza.odswiezSchemat": "Odśwież schemat",
  "baza.top": "Top 1000",
  "baza.wstawKolumne": "Wstaw nazwę do zapytania",
  "baza.klucz": "klucz",
  "baza.widok": "widok",
  "baza.zapisBramka": "zapis przez bramkę",
  "baza.zapisZakaz": "tylko odczyt",
  "baza.placeholder": "SELECT TOP 100 * FROM Items",
  "baza.wykonaj": "Wykonaj",
  "baza.eksport": "Eksport CSV",
  "baza.czekam": "czekam na {wezel}…",
  "baza.wierszy": "{n} wierszy · {ms} ms · {wezel}",
  "baza.obcieto": "obcięto do {n}",
  "baza.porownanie": "vs {wezel}: zgodne {z} · inne {i} · tylko tu {t} · brak tu {b}",
  "baza.poKluczu": "po kluczu",
  "baza.poWierszach": "po całych wierszach",
  "baza.niepelne": "porównanie niepełne — wynik obcięty",
  "baza.inneKolumny": "Bazy oddały inne kolumny — nie porównuję.",
  "baza.stan": "Stan",
  "baza.stanWiersza.ZGODNY": "zgodne",
  "baza.stanWiersza.INNY": "inne",
  "baza.stanWiersza.TYLKO_TU": "tylko tu",
  "baza.stanWiersza.BRAK_TU": "brak tu",
  "baza.tam": "tam: {v}",
  "baza.brakBaz": "Na tej wyspie nie ma bazy z agentem.",
  "baza.edytuj": "Edytuj wynik",
  "baza.edycjaTabeli": "Edycja: {tabela}",
  "baza.dodajWiersz": "Dodaj wiersz",
  "baza.zakonczEdycje": "Zakończ edycję",
  "baza.usunNowy": "Usuń nowy wiersz",
  "baza.usunWiersz": "Usuń wiersz",
  "baza.przywrocWiersz": "Cofnij usunięcie",
  "baza.nowyWiersz": "Nowy wiersz",
  "baza.wiersz": "Wiersz",
  "baza.doWyslania": "Zmiany do wysłania: {n}",
  "baza.pojdzie": "Pójdzie:",
  "baza.zaDuzoZmian": "Najwyżej {n} zmian naraz — zawęź filtr.",
  "baza.hurtKolumna": "Kolumna",
  "baza.hurtWartosc": "Wartość",
  "baza.hurtUstaw": "Ustaw we wszystkich",
  "baza.hurtUsunWszystkie": "Usuń wszystkie",
  "baza.hurtPrzywrocWszystkie": "Cofnij usunięcie wszystkich",
  "baza.hurtObciety": "Wynik obcięty — zawęź filtr, żeby zmienić wszystkie pasujące wiersze.",
  "baza.hurtCzesci": "Pójdzie w częściach — operacji: {k}",
  "baza.hurtTytul": "Podgląd zmiany hurtowej",
  "baza.hurtOpis": "Zmian: {n} · operacji: {k} (po najwyżej {max})",
  "baza.hurtZablokowane": "Zablokowane: {n}",
  "baza.hurtPomin": "Pomiń zablokowane ({n})",
  "baza.hurtPominiete": "Pominięto: {n}",
  "baza.hurtIleZmian": "zmian: {n}, pierwsza #{nr}",
  "baza.odrzucZmiany": "Odrzuć zmiany",
  "baza.podgladWysylka": "Podgląd i wysyłka",
  "baza.wyslano": "Zakolejkowano na wyspę — wynik zmieni się po cyklu agentów.",
  "baza.odswiezWynik": "Odśwież wynik",
  "baza.wyslanoGotowe": "Zmiana jest na wszystkich bazach wyspy.",
  "baza.stanWezla.CZEKA": "czeka",
  "baza.stanWezla.W_DRODZE": "w drodze",
  "baza.stanWezla.ZROBIONE": "zrobione",
  "baza.stanWezla.BLAD": "błąd",
  "baza.pominieto": "pominięto {n}",
  "baza.operacjaNr": "Operacja {n}:",
  "baza.operacjiGotowe": "Zrobione operacje: {z} z {n}",
  "baza.sortuj": "Sortuj",
  "baza.podpowiedzi": "Podpowiedzi",
  "baza.tabela": "tabela",
  "baza.naprawa": "Naprawa",
  "baza.wg": "wg {wezel}",
  "baza.wgOpis": "Wyrównaj wszędzie do wersji z {wezel}",
  "baza.wgOpisUsun": "W {wezel} tego wiersza nie ma — zniknie z całej wyspy",
  "baza.potwierdzNaprawyUsun": "Tak, wyślij {n} (usunięcia: {u})",
  "baza.wzorzec": "wzorzec: {wezel}",
  "baza.wszystkieWg": "Wszystkie wg {wezel}",
  "baza.naprawyDoWyslania": "Naprawy do wysłania: {n}",
  "baza.wyslijNaprawy": "Wyślij naprawy",
  "baza.potwierdzNaprawy": "Tak, wyślij {n}",
  "baza.naprawyWyslane": "Zakolejkowano na wyspę: poprawki {p}, dołożenia {d}, usunięcia {u}.",
  "baza.wyczysc": "Wyczyść"
}
